import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { TaskService } from 'src/app/services/task.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { environment } from 'src/environments/environment';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { AgendaService } from 'src/app/services/agenda.service';
import { CategoryMasterService } from 'src/app/services/category-master.service';
import { CommitteeService } from 'src/app/services/committee.service';
import { EmailReminderService } from 'src/app/services/email-reminder.service';
import { Location } from '@angular/common';
import { AlertComponent } from '../../alert/alert.component';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { UserMasterPssService } from 'src/app/services/user-master-pss.service';
import { DefaultMeetingService } from 'src/app/services/default-meeting.service';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { LoaderService } from 'src/app/services/loader.service';

import { CompanyMasterService } from 'src/app/services/companymaster.service';


const enhanchArr = (item) => ({ ...item, disabled: true, isSubmited: true })


declare var $: any;
declare var jQuery: any;
declare var autosize: any

@Component({
  selector: 'app-addmeeting',
  templateUrl: './addmeeting.component.html',
  styleUrls: ['./addmeeting.component.css']
})

export class AddmeetingComponent implements OnInit {

  public tempArray: any = []

  public environmentSettings: any;
  public downloadSingleFile: string;
  public loading = false;
  public loading1 = false;
  /** True while meeting-type dropdown data (directors, agenda, categories…) is loading */
  public isMeetingTypeLoading = false;
  private _meetingTypeLoadPending = 0;

  public isLoadingAgenda: boolean = false;
  public isSaving: boolean = false;
  public renumberLoading: boolean = false;
  public agendaProcessingText: string = ''; // Text to show during agenda processing
  public agendaFailedText: string = ''; // Text to show failed agendas
  public failedAgendaNumbers: string[] = []; // Array to track failed agenda numbers
  private currentEventSource: EventSource = null; // Reference to current SSE connection

  public isNewScreen: boolean = false;

  isLibraryAgenda: any;
  companyNameData: any = [];
  pushCompanyId = [];
  uploadAgendaDocFileBtn: boolean = true;
  isCategoryGlobal: boolean;
  isPSSMasterAgenda: boolean;

  @ViewChild(DataTableDirective)
  dtElementForAgenda: DataTableDirective;
  dtAgendaOptions: any = {};
  dtTriggerAgenda: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForAgendaNew: DataTableDirective;
  dtAgendaNewOptions: any = {};
  dtTriggerAgendaNew: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForAgendaStore: DataTableDirective;
  dtOptionsOfAgendaStore: DataTables.Settings = {};
  dtTriggerAgendaStore: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementAgendaCompliancePopUp: DataTableDirective;
  dtOptionsOfAgendaCompliancePopUp: DataTables.Settings = {};
  dtTriggerAgendaCompliancePopUp: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForAddingCompliance: DataTableDirective;
  dtOptionsOfAddingCompliance: DataTables.Settings = {};
  dtTriggerAddingCompliance: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForDirector: DataTableDirective;
  dtOptionsOfDirector: DataTables.Settings = {};

  dtTriggerDirector: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForInvitees: DataTableDirective;
  dtOptionsOfInvitee: DataTables.Settings = {};
  dtTriggerInvitee: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForCompliance: DataTableDirective;
  dtOptionsOfCompliance: DataTables.Settings = {};
  dtTriggerCompliance: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForMember: DataTableDirective;
  dtOptionsOfMember: DataTables.Settings = {};
  dtTriggerMember: Subject<any> = new Subject();
  //dtOptions: DataTables.Settings = {};
  // dtOptionsOfAgenda: DataTables.Settings = {};

  @ViewChild(DataTableDirective)
  dtElementForTransferToGem: DataTableDirective;
  dtOptionsOfTransferToGem: any = {};
  dtTriggerOfTransferToGem: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForAgendaAccess: DataTableDirective;
  dtOptionsOfAgendaAccess: DataTables.Settings = {};
  dtTriggerAgendaAccess: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementForAgendaFiles: DataTableDirective;
  dtOptionsOfAgendaFiles: any = {};
  dtTriggerAgendaFiles: Subject<any> = new Subject();

  dtOptionsAttandance: DataTables.Settings = {};
  dtTriggerAttandance: Subject<any> = new Subject();

  dtOptionsAttandedMembers: DataTables.Settings = {};
  dtTriggerAttandedMembers: Subject<any> = new Subject();



  dtOptionsOfProcess: DataTables.Settings = {};
  dtTriggerProcess: Subject<any> = new Subject();

  dtOptionsOfProcessPopup: DataTables.Settings = {};
  dtTriggerAddingPopup: Subject<any> = new Subject();

  dtOptionsOfCategory: DataTables.Settings = {};
  dtTriggerOfCategory: Subject<any> = new Subject();

  dtOptionsOfCategoryPopup: DataTables.Settings = {};
  dtTriggerOfCategoryPopup: Subject<any> = new Subject();

  dtOptionsOfAgendaGen: DataTables.Settings = {};
  dtTriggerOfAgendaGen: Subject<any> = new Subject();

  dtOptionsImportAgendaModal: DataTables.Settings = {};
  dtTriggerImportAgenda: Subject<any> = new Subject();

  // dtOptionsOfTransferToGem: DataTables.Settings = {};
  // dtTriggerOfTransferToGem: Subject<any> = new Subject();

  g_meetingID: any;
  g_meetingTypeID: any;
  addmeetingForm: FormGroup;
  directorForm: FormGroup;
  inviteeForm: FormGroup;
  memberForm: FormGroup;
  documentForm: FormGroup;

  Invitees: Array<any> = [];
  inviteesEntry: any = {};
  meetingTypes: any;
  committeeMembers: any;
  inviteeArray: any;
  recipientsArray: any;
  recipients: Array<any> = [];
  processArray: any;
  MeetingDateModel: any;
  IssueNoticeDueDateModel: NgbDateStruct;
  IssueNoticeDueDateModelFromDatabase: NgbDateStruct;
  newAssignIssueNoticeDueDateModel: NgbDateStruct;
  ignoredFirstEvent: boolean = false;
  SigningNoticeDateModel: any;
  // Members: any;
  preDefinedTask: any[];
  preDefinedTasknew: any[];
  IsMeetingTimeSelected: boolean;
  selectProcessFlag: boolean;
  previousProcesStatus: boolean;
  PreviousProcessID: boolean;
  agendaArray: any[] = [];
  newAgendaArray: any[] = [];

  agendaAuditTrailHeadline = '';
  agendaAuditRows: { typeLabel: string; when: string; user: string; changes: string }[] = [];
  transferToGemArray: any[];
  isSearchDivVisible = false;

  loadedAgendaFilesImport: any = { meetingId: '', loadedAgendaFilesArray: [] };
  importAgendaSearchRows: any[] = [];
  isImportAgendaSearchDivVisible = true;
  responseImport: boolean = false;
  meetingTypeImport: any[] = [];
  selectedMeetingImport: any = null;
  meetingsSearchDateFromImport: NgbDateStruct | null = null;
  meetingsSearchDateToImport: any;
  minDateForSearchToImport: NgbDateStruct;
  importAgendaSelected: { [agendaId: string]: boolean } = {};
  importInternalSubmitting: boolean = false;
  private importAgendaDtOptionsInitialized = false;

  /** When false, Import DataTable DOM is destroyed so reopening rebuilds Angular DataTables cleanly. */
  importAgendaTableReady = false;

  agendaData: any[];
  selectedAllAgendaStore: any;
  selectedAllAgenda: any;
  IsSelectedAgenda: any;
  enableAgendaStore: any;
  enableAddComplianceButton: any;
  meetingAgendaArray: any;
  Directors: Array<any> = [];
  DirectorsToDisplayIn_MembersDirectors_Tab: Array<any> = [];
  Members: Array<any> = [];
  selectedAllDirector: any;
  selectedAllInvitee: any;
  selectedAllMember: any;
  agendaAddedTaskList: any = [];
  error: any = { isError: false, errorMessage: '' };
  TodayDate: NgbDateStruct;
  groupTypes: any[];
  companytasklist: any[];
  ActualDataToAgenda: any[];
  selectedAll: any;
  IsSelectedTasks: any;
  SearchtaskUserdefinedorPredefinedModel: any;
  SearchtaskEventbasedorPeriodicModel: any;
  groupID: any;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  directorData: any[];
  availableDirectorsID: any;
  complianceToShow: any = [];
  selectedComplianceToSave: any = [];
  agendaCompliances: any = [];
  AgendaCategory: any = [];
  directorObjectDinToBindWhileUpdating: any;
  directorToUpdateById: any;
  directorObjectToBindWhileUpdating: any;
  updatedirectorButtonFlag: boolean = false;

  inviteeToUpdateById: any;
  updateinviteeButtonFlag: boolean = false;

  memberToUpdateById: any;
  updateMemberButtonFlag: boolean = false;
  restrictTabFlag: boolean;
  /** Modal read-only breakdown for Document tab (draft / final minutes) */
  minuteVotingModalMinuteType: 'DRAFT' | 'FINAL' | null = null;

  get isMinuteVotingAdmin(): boolean {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const roles = Array.isArray(user?.Roles)
        ? user.Roles.map((r: any) => String(r?.RoleName || '').trim().toLowerCase())
        : [];
      return roles.includes('admin') || roles.includes('all role');
    } catch {
      return false;
    }
  }
  filesToUpload: Array<File>;
  attendedAll: any;
  isAttended: any;
  meetingType: any[];
  directorsmemberInvetteeAttended: any[];
  attandedMembers: any[]
  SelectedMeetingType: any;
  FileOrignalName: any;
  changedName: any;
  pdfArray1 = [];
  attendanceFile: any;
  AtrDocument: any;
  isFileAvailable: any;
  ATRFile_id: any;
  addedProcess: any[];
  AfterMeetingsSevenDays: NgbDateStruct;
  currentURL: any;
  hasPermission: any;
  titleOnAddUpdate: any;
  selectedType: any;
  MeetingTypeName: any;
  IsATRAvailable: any
  categoryArrayOnUpdate: any[];

  categoryPopupArray: any;
  availableCaegory: any[];
  selectCategoryFlag: any;
  categoryArray: any[];
  IsSelectedCategory: boolean;
  invitteeDeleteOBJ: any;
  disableAddTaskPopupButton: boolean;
  searchByGroupID: any;
  meetingMember: any[];
  alreadyExist: boolean = false;
  activatedDirectors: any[];
  activatedMemebers: any[];
  NewMeetingMember: any[];
  newMeetingMemberData: any[];
  deletingAgendaObject: any;
  Member: any;
  // activeDirectorINMeeting = [];
  // activeMemberINMeeting =[];
  InAciveDirectorINMeeting = [];
  InActiveMemberINMeeting = [];
  // activeDirectorINMeeting:any = [];
  // activeMemberINMeeting:any = [];
  meetingDocumentArray: any = {
    ATRFile: { name: "File Not Available", isAvaible: false, docId: "", UploadDate: "" },
    noticeFile: { name: "File Not Available", isAvaible: false, docId: "", UploadDate: "" },
    draftFile: { name: "File Not Available", isAvaible: false, docId: "", UploadDate: "" },
    agendaFile: { name: "File Not Available", isAvaible: false, docId: "", UploadDate: "" },
    agendaFileArray: [],
    finalFile: { name: "File Not Available", isAvaible: false, docId: "", UploadDate: "" }
  };

  fileHasError: any = {
    state: false,
    msg: ""
  };
  dateOfIncorpOfCompany: any;
  MeetingtimeCheack: boolean;
  madeAttendanceButtonValidInvalid: boolean;
  meetimeADJDate: any;
  meetimeADJTime: any;
  adjFlag: boolean = false;
  flagSetToNo: boolean
  flagSetToYes: any;
  specificDataForFile: any;
  ComplianceObject: any;
  Chairman: any;
  alternateChairmanID: any;
  meetingHeld: any = 'No';
  meetingStartTime: any;
  meetingStartDate: NgbDateStruct;
  meetingEndDate: NgbDateStruct;
  meetingEndTime: any;
  selectedVal: any;
  activatedTaskList: any;
  SelectedTaskOnProcessID: any[];
  selectedAllCategory: any;
  cheackCategory: boolean;
  categoryCheackEvent: any;
  categoryDataOnEvent: any;
  category: any;
  isMembersAreHidden: boolean;
  tabValue: any
  companiesListData: any[] = [];

  companyAddress: string = '';
  IsMeetingDetailsActive: any;
  IsCategoryTabActive: any;
  IsAgendaTabActive: any;
  IsAgendNewTabActive: any;
  IsComplianceTabActive: any;
  IsDirectorsTabActive: any;
  IsInviteesTabActive: any;
  IsMembersTabActive: any;
  IsAttendanceTabActive: any;
  IsDocumentStampGeneratorTabActive: any;
  IsTransferToGemTabActive: any;
  IsDocketTabActive: any;
  IsVotingResultsTabActive: any;

  meetingActive: any;
  categoryActive: any;
  agendaActive: any;
  agendaNewActive: any;
  complianceActive: any;
  directorActive: any;
  invitteeActive: any;
  memberActive: any;
  attendanceActive: any;
  documentActive: any;
  docketsActive: any;
  transferToGemActive: any;
  /** Bootstrap nav `active` class for Voting Results tab */
  votingResultsActive: any;
  /** Bumped when the Voting Results tab is opened so child refetches summaries */
  votingResultsRefreshKey = 0;
  hideUpdateButtonOfInvitee: any;
  orderDetails: any;
  agendaseq: any;
  searcheFilteredDataCategory: any[];
  searcheFilteredDataAgendaStore: any[];
  searcheFilteredDataTaskStore: any[];
  isPublished: boolean = false;
  addOrUpdate: any = 'Add';
  notifyresponse: any;
  iframeURL: any;
  checkEmailIdExistInInvitee: boolean = false;
  docketFileName: any;
  pdfFileName: any;
  pdfDocumentId: any;
  agendaGeneratedHistory: any[];
  agendaPdfAttachment: any[];
  disabledOnclick: boolean = false;
  private meetingDataObject: any;
  public downloadAllLink: string = "documentManagement/downloadSingleFileOnID/";
  disableAdjournedDate: boolean = false;
  splittedData: any[];
  isExisting: boolean = false;
  agendaToReplace = '';
  splittedAgendaTitle = '';
  splittedAgendaNumber = '';
  splittedAgendaFile = '';
  splittedDocumentId = '';
  splitId = '';
  splitDataId = '';
  documentIdToDelete = '';
  pdfToDelete = '';
  newIdrectors: any;
  isSplitOperationPerformed: boolean = false;
  enableGenerateDocxButton: boolean = false;
  UpdateMember = [];
  UpdateDirector = [];
  isNoticeNotify: boolean = false;
  isAgendaNotify: boolean = false;
  isDraftNotify: boolean = false;
  isATRNotify: boolean = false;
  isFinalNotify: boolean = false;
  selectedAgenda: any;
  meetingGemStatus: boolean;
  hideBtnMsg: any;
  hideOrShowBtnMsg: any;
  directorTabName: any;
  agendaDocName: any;
  meetingFreezeStatus: boolean;
  freezeBtnMsg: any;
  agendaAccessArray: any[];
  agendaAccessType: boolean;
  inviteeUser: any[];
  selectAllAccess: boolean;
  countAgenda = 0;
  agendaReplaceArray = [];
  agendaDocData: any;
  downloadGeneratedFile: boolean;
  minutesFileName: any;
  uploadButtonType: any;
  fileExtension: boolean = true;
  PSSMasterMeetingTypeID;
  defaultCategoryArray: any = [];
  isAgendaUpdateBtnEnable: boolean = false;
  financialYearEndDate: any;
  meetingIdForMeetingNumber: any;
  isMeetingDataGreaterSelectDate: boolean = false;
  showMeetingDateWhileUpdate: any;
  showMeetingNumberWhileUpdate: any;
  IsSequenseMeetingNumber: any;
  agendaForFilter: any = [];
  processForFilter: any = [];
  docketFileId: any;
  pdfFileId: any;
  filterAgendaId: any = null;
  filterProcessId: any = null;
  formattedMeetingDateTime: any;
  publishDateTime: any;
  isPublishedFirstTime: boolean = false;


  missingBodyKeywords: string;
  missingSubjectKeywords: string;
  reminders: any[];
  reminderMasterForm: FormGroup;
  emailReminderId: string;
  companyId: string;
  mailReminderStaticID: string;
  isDefault: boolean;
  disable: boolean;
  keywordsMissingBodyAlert: boolean;
  keywordsMissingSubjectAlert: boolean;
  aryBodyKeyWords: any[];
  arySubjectKeyWords: any[];
  bodyKeyWords: string;
  subjectKeyWords: string;


  IsSubjectKeyWordRequired: boolean;
  IsBodyKeyWordRequired: boolean;
  type: any;
  meetingDateChangeFormatForTime: any;
  meetingTimeForAutoMeetingNo: any;
  openUploadPanel: string = ''; // Track which upload panel is open (notice, draft, agenda, final, ATR)

  // filesToUpload: any;
  DocumentFileDoc: any;
  FileNameO: any;
  isFileDeleted: any;
  transferToGemSelectedAgenda = [];
  clonedAgendaArray: any;
  IsUpsiEmail: boolean;
  agendaAddForm: FormGroup;
  fileAgendaDocEvent: any;
  currentAgenda: any;
  saveCombinedButton: boolean = false;
  splitedCombinedMeetingId: any;

  // Properties for Notify Selected functionality
  showUserSelectionModal: boolean = false;
  selectedUsersForNotification: any[] = [];
  currentNotificationType: string = '';
  allMeetingUsers: any[] = [];
  selectAllUsers: boolean = false;

  constructor(private directorService: DirectorMasterService,
    private loaderService: LoaderService,
    private meetingService: MeetingMasterService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
    private taskService: TaskService,
    private groupMasterService: GroupMasterService,
    private alert: AlertComponent,
    private agendaService: AgendaService,
    private router: Router,
    private commonFunction: CommonFunction,
    private documentManagementMasterService: DocumentManagementMasterService,
    private committeeService: CommitteeService,
    private location: Location,
    private route: ActivatedRoute,
    private authAlert: AuthAlertComponent,
    private categoryMasterService: CategoryMasterService,
    private userMasterService: UserMasterPssService,
    private defaultmeetingService: DefaultMeetingService,
    private emailReminderService: EmailReminderService,
    private customValidation: CustomValidation,
    private companyMasterService: CompanyMasterService,
  ) {
    this.currentURL = window.location.href;
    this.notifyresponse = false;

  }

  ngOnInit() {
    this.loaderService.disable();
    this.reminderMasterForm = new FormGroup({
      Title: new FormControl('', [Validators.required]),
      Subject: new FormControl('', [Validators.required]),
      EmailText: new FormControl('', [])
    });

    if (this.router.url === '/structure/(structure-outlet:addMeetings)') {
      this.getCompaniesList();
    }
    // ===== Replace Library Agenda Doc START =======
    let uniqueUserId = JSON.parse(localStorage.getItem('user')).UniqueUserId;
    let uniqueCompanyId = JSON.parse(localStorage.getItem('user')).CompanyId;
    this.userMasterService.getAssociatedCompanyList(uniqueUserId).then(response => {
      if (response.status == 200) {
        var result = JSON.parse(response._body);
        result.companyList.forEach(compData => {
          if (compData._id != uniqueCompanyId) {
            this.companyNameData.push({
              id: compData._id,
              name: compData.CompanyName
            })
          }
        });
      }
    });

    // this.companyNameData=[
    //   { id:'5cee33d225242e023acfb2d4',name:'Tata Motors Ltd.'},
    //   { id:'5da438c6a542e87a3231e5e2',name:'Infosys Ltd.'},
    //   { id:'5d79d99f4ed6e5f7e1277f2b',name:'Lupin Ltd.'}
    // ];
    // ===== Replace Library Agenda Doc END =======
    this.IsSequenseMeetingNumber = true;


    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    localStorage.removeItem('fromMeeting')
    this.environmentSettings = environment;
    this.SearchtaskEventbasedorPeriodicModel = "1";
    this.searchByGroupID = '';
    var hasEditPermission: any = false;
    if (this.currentURL.includes('edit') && !environment.PSS) {
      hasEditPermission = this.commonFunction.validateURL('Meetings', 'edit');
    }
    else if (!environment.PSS) {
      hasEditPermission = this.commonFunction.validateURL('Meetings', 'add');
    } else {
      hasEditPermission = false;
    }
    this.hasPermission = hasEditPermission;

    this.enableAgendaStore = true;
    this.enableAddComplianceButton = true;



    // this.dtAgendaOptions = {
    //   destroy: true,
    //   scrollY: "250px",
    //   scrollCollapse: true,
    //   pagingType: 'full_numbers',
    //   paging: true,
    //   pageLength: 5,
    //   stateSave: true,
    //   stateDuration: -1,
    //   search: true,
    //   order: [1, 'asc'],
    //   lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    //   columnDefs: [{ orderable: false, targets: [1] }],
    //   rowReorder: {
    //     dataSrc: 'readingOrder',
    //     select: true,
    //   },
    //   select: true,
    // };

    let self = this;


    this.dtAgendaOptions = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      // pageLength: 5,
      stateSave: false,
      serverSide: false,
      stateDuration: -1,
      search: true,
      order: [[0, 'asc']],
      // order: [[2, 'asc'], [3, 'asc']],
      columnDefs: [{ orderable: false, targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      iDisplayLength: -1,
      rowReorder: {
        selector: 'td.reOrderRow'
      }
    };

    this.dtAgendaNewOptions = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      //pageLength: 5,
      stateSave: false,
      serverSide: false,
      stateDuration: -1,
      search: true,
      order: [[0, 'asc']],
      // order: [[2, 'asc'], [3, 'asc']],
      columnDefs: [{ orderable: false, targets: [0, 1, 2, 3, 4, 5] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      iDisplayLength: -1,
      // rowReorder: {
      //   selector: 'td.reOrderRow'
      // }
    };

    this.dtOptionsOfTransferToGem = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: false,
      serverSide: false,
      stateDuration: -1,
      search: true,
      order: [[0, 'asc']],
      // order: [[2, 'asc'], [3, 'asc']],
      columnDefs: [{ orderable: false, targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      rowReorder: {
        selector: 'td.reOrderRow'
      }
    };

    this.dtOptionsOfAgendaFiles = {
      destroy: true,
      scrollY: "200px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      paging: false,
      stateSave: false,
      serverSide: false,
      stateDuration: -1,
      search: false,
      order: [[0, 'asc']],
      columnDefs: [{ orderable: false, targets: [0, 2] }],
      rowReorder: {
        selector: 'td.reOrderRow'
      }
    };

    this.dtOptionsOfAgendaStore = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [2, 'asc'],
      columnDefs: [{ orderable: false, targets: [1] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };

    this.dtOptionsOfCompliance = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      processing: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [4, 'asc'],
      columnDefs: [{ orderable: false, targets: [1] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]]
    };


    this.dtOptionsOfAgendaCompliancePopUp = {
      destroy: true,
      // scrollY: "250px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      stateSave: true,
      stateDuration: -1,
      order: [4, 'asc'],
      columnDefs: [{ orderable: false, targets: [0, 1, 2, 3] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    }

    this.dtOptionsOfAddingCompliance = {
      destroy: true,
      scrollY: "300px",
      scrollX: true,
      processing: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      stateSave: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [4, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [7] }]
    };

    this.dtOptionsOfInvitee = {
      destroy: true,
      //scrollY: "250px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [0, 4] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };

    this.dtOptionsOfDirector = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      stateDuration: -1,
      stateSave: true,
      pageLength: 5,
      search: true,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };

    this.dtOptionsOfMember = {
      destroy: true,
      scrollY: "250px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      stateSave: true,
      stateDuration: -1,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [0, 2] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };

    this.dtOptionsAttandance = {
      destroy: true,
      scrollY: "250px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      // searching:false,
      search: true,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [0, 3] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };

    this.dtOptionsOfProcess = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      stateSave: true,
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: [3] }]
    }

    this.dtOptionsOfProcessPopup = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [2] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    }

    this.dtOptionsOfCategory = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      stateSave: true,
      stateDuration: -1,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [2] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    }

    this.dtOptionsOfCategoryPopup = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      stateSave: true,
      stateDuration: -1,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [0] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    }

    this.dtOptionsOfAgendaGen = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      stateSave: true,
      stateDuration: -1,
      order: [2, 'asc'],
      columnDefs: [{ orderable: false, targets: [3] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    }

    this.dtOptionsOfAgendaAccess = {
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [2, 'asc'],
      columnDefs: [{ orderable: false, targets: [1] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };

    this.SelectedTaskOnProcessID = []
    // var dateObj = new Date();
    // var month = dateObj.getUTCMonth() + 1; //months from 1-12
    // var day = dateObj.getUTCDate() + 1;
    // var year = dateObj.getUTCFullYear();
    // this.TodayDate = { year: year, month: month, day: day };

    this.IsMeetingTimeSelected = false;
    this.selectProcessFlag = false;
    $('.select2').select2();

    // $('.select2-tags').select2({
    //   tags: true,
    //   tokenSeparators: [',', ' ']
    // });
    this.meetingTypes = [];
    this.inviteeArray = [];



    this.addmeetingForm = new FormGroup({
      MeetingType: new FormControl('', [Validators.required]),
      MeetingDate: new FormControl('', [Validators.required]),
      EmailID: new FormControl('', []),
      MeetingTime: new FormControl('', [Validators.required]),
      MeetingNumber: new FormControl('', []),
      MeetingPlace: new FormControl('', []),
      IssueNoticeDueDate: new FormControl('', []),
      NoticeSignatoryName: new FormControl('', []),
      ContactNumber: new FormControl('', []),
      // agendaCompliance: new FormControl('', []),
      NoticeSignatoryDesignation: new FormControl('', []),
      DinNumber: new FormControl('', []),
      SigningNoticeDate: new FormControl('', []),
      SigningNoticePlace: new FormControl('', []),
      QuarterEnded: new FormControl('', []),
      Process: new FormControl('null', []),
      Category: new FormControl('null', []),
    });


    this.directorFormInitialisation();

    this.inviteeForm = new FormGroup({
      InviteeName: new FormControl('', [Validators.required]), //, Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")
      Designation: new FormControl('', []),
      Address: new FormControl('', []),
      City: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      State: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      TelO: new FormControl('', []),
      TelR: new FormControl('', []),
      FaxNo: new FormControl('', []),
      MobileNo: new FormControl('', [Validators.required]),
      EmailId: new FormControl('', [Validators.required, Validators.email]),
      InAttendance: new FormControl('', []),
      ThroughVC: new FormControl('No', []),
      GovevaUserId: new FormControl('', [])
    });

    this.memberForm = new FormGroup({
      MemberName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      Designation: new FormControl('', []),
      Address: new FormControl('', []),
      City: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      State: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      TelO: new FormControl('', []),
      TelR: new FormControl('', []),
      FaxNo: new FormControl('', []),
      MobileNo: new FormControl('', []),
      EmailId: new FormControl('', [Validators.required, Validators.email]),
    });

    this.documentForm = new FormGroup({
      noticeDate: new FormControl('', []),
      noticeTime: new FormControl('', []),
      draftTime: new FormControl('', []),
      draftDate: new FormControl('', []),
      agendaDate: new FormControl('', []),
      agendaTime: new FormControl('', []),
      finalDate: new FormControl('', []),
      finalTime: new FormControl('', [])
    });

    localStorage.removeItem("MeetingID");

    this.meetingService.getMeetingTypeList()
      .subscribe(meetingTypeList => {

        if (meetingTypeList.status == 0) {

          this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');

          this.activatedRoute.params.subscribe(params => {

            if (params['meetingId'] != undefined) {
              // it is edit page
              this.g_meetingID = params['meetingId'];

              // Check for ongoing SSE processing and reconnect if needed
              this.checkAndReconnectSSE();

              // viewDocketDocFile/:meetingID


              this.getAgendaGenerationData();

              this.tabValue = params['tab'];
              this.restrictTabFlag = true;
              localStorage.setItem('updateMeetingID', params['meetingId']);

              var data = {
                module: 'Meeting',
                ID: params['meetingId'],
                CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
              }
              this.meetingService.authonticateDataForComapnay(data).subscribe((meetingAccess: any) => {
                if (meetingAccess.status == 0) {
                  this.loadMeetingDetails(params['meetingId']);
                } else {
                  // alert(meetingAccess.companyID);
                  this.authAlert.validateModuleWithPermissions('Meeting', params['meetingId'], meetingAccess.companyID, 'edit')
                  // this.router.navigate(['/authAlert']);
                }

              })


              // this.markAttandenceMember();
              this.getActiveTab()
            }
            else {
              this.titleOnAddUpdate = 'Schedule Meeting'
              //it is add meeting page
              this.restrictTabFlag = false;
              this.companytasklist = [];
              localStorage.removeItem('updateMeetingID');
              this.getActiveTab()
            }
          });
        }
      })




    $(function () {
      $('.timepicker-init').datetimepicker({
        widgetPositioning: {
          horizontal: 'left'
        },
        icons: {
          time: "fa fa-clock-o",
          date: "fa fa-calendar",
          up: "fa fa-arrow-up",
          down: "fa fa-arrow-down",
          previous: 'fa fa-arrow-left',
          next: 'fa fa-arrow-right'
        },
        format: 'LT'
      });
      $('.timepicker-init').on('dp.hide change', (e) => {
        const val = $(e.target).val();
        if (val) {
          this.addmeetingForm.controls.MeetingTime.setValue(val);
        }
        $('.bootstrap-datetimepicker-widget').remove();
      });
    })

    this.disableControls(hasEditPermission);

    $("#agendaTable").DataTable().on('row-reorder', (e, newOrderDataList, changes) => {

      //  TODO      
    });

    $("#transferToGemTable").DataTable().on('row-reorder', (e, newOrderDataList, changes) => {
      //  TODO      
    });


    //On search Event In Dilogues//
    let table1 = $("#categoryTablePopup").DataTable();
    let table2 = $("#agendaStoreTable").DataTable();
    let table3 = $("#companytaskTable").DataTable();


    //Category Table Search Event
    table1.on('search.dt', function () {

      self.searcheFilteredDataCategory = [];
      var tableData = $("#categoryTablePopup").DataTable().column(3, { search: 'applied' }).data();
      for (var i = 0; i < tableData.length; i++) {
        self.searcheFilteredDataCategory.push(tableData[i])
      }
      var allSearchedSelectedCategory = true;
      if (_.size(self.categoryPopupArray)) {
        for (var i = 0; i < self.categoryPopupArray.length; i++) {
          for (var j = 0; j < self.searcheFilteredDataCategory.length; j++) {
            if (self.searcheFilteredDataCategory[j] == self.categoryPopupArray[i]._id) {
              if (self.categoryPopupArray[i].IsSelectedCategory) {
              } else {
                allSearchedSelectedCategory = false;
              }
            }
          }
        }
      }

      if (allSearchedSelectedCategory) {
        self.selectedAllCategory = true;
      } else {
        self.selectedAllCategory = false;
      }
    });

    //Category Table Search Event
    table2.on('search.dt', function () {
      self.searcheFilteredDataAgendaStore = [];
      var tableData = $("#agendaStoreTable").DataTable().column(0, { search: 'applied' }).data();
      for (var i = 0; i < tableData.length; i++) {
        self.searcheFilteredDataAgendaStore.push(tableData[i])
      }
      var allSearchedSelectedCategory = true;
      if (_.size(self.agendaData)) {
        for (var i = 0; i < self.agendaData.length; i++) {
          for (var j = 0; j < self.searcheFilteredDataAgendaStore.length; j++) {
            if (self.searcheFilteredDataAgendaStore[j] == self.agendaData[i]._id) {
              if (self.agendaData[i].selectAgenda) {
              } else {
                allSearchedSelectedCategory = false;
              }
            }
          }
        }
      }

      if (allSearchedSelectedCategory) {
        self.selectedAllAgendaStore = true;
      } else {
        self.selectedAllAgendaStore = false;
      }
    });

    //Category Table Search Event
    table3.on('search.dt', function () {
      self.searcheFilteredDataTaskStore = [];
      var tableData = $("#companytaskTable").DataTable().column(0, { search: 'applied' }).data();
      for (var i = 0; i < tableData.length; i++) {
        self.searcheFilteredDataTaskStore.push(tableData[i])
      }
      var allSearchedSelectedTask = true;
      if (_.size(self.companytasklist)) {

        for (var i = 0; i < self.companytasklist.length; i++) {
          for (var j = 0; j < self.searcheFilteredDataTaskStore.length; j++) {
            if (self.searcheFilteredDataTaskStore[j] == self.companytasklist[i].ID) {
              if (self.companytasklist[i].SelectedTask) {
              } else {
                allSearchedSelectedTask = false;
              }
            }
          }
        }
      }

      if (allSearchedSelectedTask) {
        self.selectedAll = true;
      } else {
        self.selectedAll = false;

      }
    });

    this.agendaAddForm = new FormGroup({
      agendaNumber: new FormControl('', [Validators.required]),
      agendaTitle: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
    });

    this.getGroupmasterList();
    // Defer compliance task list until the Add Compliances modal opens (avoids huge hidden DOM on add)
    this.getInCorpDate();
    this.getpredefinedTaskList();
  }//ngOnInit Close.

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  agendaSaveOrder() {
    this.disabledOnclick = true;
    var agendaTable = $('#agendaTable').DataTable();
    var agendaList = agendaTable.rows().data().toArray();

    var agendaListWithOrder = [];

    for (let agenda of agendaList) {
      agendaListWithOrder.push({
        _id: agenda[1],
        Order: agenda[0]
      });
    }

    this.meetingService.reOrderingOfAgendaArray(agendaListWithOrder, this.g_meetingID).subscribe(data => {
      this.disabledOnclick = false;
      if (data.status == 0) {
        this.transferToGemArray = [];
        $("#transferToGemTable").DataTable().destroy();
        this.transferToGemArray = data.data;
        for (var index = 0; index < this.transferToGemArray.length; index++) {
          this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
        }
        this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
        this.dtTriggerOfTransferToGem.next();
        this.alert.success("Order of the agenda saved successfully.");
      }
    });
  }
  agendaRenumber() {
    this.loading = true;

    const agendaTable = $('#agendaTable').DataTable();
    const agendaList = agendaTable.rows().data().toArray();
    const agendaListWithOrder = [];
    let i = 1;

    if (agendaList.length > 0) {
      for (let agenda of agendaList) {
        agendaListWithOrder.push({
          _id: agenda[1],
          Order: agenda[0],
          AgendaNumber: i++
        });
      }
    }

    this.meetingService.renumberAgenda(agendaListWithOrder, this.g_meetingID)
      .subscribe(data => {
        if (data.status === 0) {
          this.agendaArray = [];
          agendaTable.destroy();
          $("#agendaNewTable").DataTable().destroy();

          this.agendaArray = _.sortBy(data.data, ["Agendaorder"]);
          this.newAgendaArray = this.agendaArray.map(enhanchArr);
          this.newAgendaArray.push(...this.tempArray);

          if (this.agendaArray.length > 0) {
            this.isAgendaUpdateBtnEnable = this.agendaArray.some(value =>
              value.AgendaGenerationDocument.isUpdatedAsPerTemplate === false ||
              value.AgendaMinuteDocument.isUpdatedAsPerTemplate === false
            );
          }
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;

          this.dtTriggerAgenda.next();
          this.dtTriggerAgendaNew.next();

          $("#transferToGemTable").DataTable().destroy();
          this.transferToGemArray = _.sortBy(data.data.map(item => ({
            ...item,
            setSelected: item.isPublished
          })), ["Agendaorder"]);

          this.dtTriggerOfTransferToGem.next();

          this.loading = false;
          this.alert.success("Number of the agenda saved successfully.");
        } else {
          this.loading = false;
          this.alert.error(data.message);
        }
      });
  }


  transferToGemSaveOrder() {
    this.disabledOnclick = true;
    var agendaTable = $('#transferToGemTable').DataTable();
    var agendaList = agendaTable.rows().data();

    var agendaListWithOrder = [];

    for (let agenda of agendaList) {
      agendaListWithOrder.push({
        _id: agenda[1],
        Order: agenda[0]
      });
    }

    this.meetingService.reOrderingOfAgendaArray(agendaListWithOrder, this.g_meetingID).subscribe(data => {
      this.disabledOnclick = false;
      if (data.status == 0) {
        this.agendaArray = [];
        $("#agendaTable").DataTable().destroy();
        $("#agendaNewTable").DataTable().destroy();
        this.agendaArray = _.sortBy(data.data, ["Agendaorder"]);

        this.newAgendaArray = this.agendaArray.map(enhanchArr);
        this.newAgendaArray.push(...this.tempArray)

        this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
          return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
        });
        this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
        this.dtTriggerAgenda.next();
        this.dtTriggerAgendaNew.next()

        this.alert.success("Order of the agenda saved successfully.");
      }
    });
  }

  // ----------------------------------------+ Add Or Update Meeting +-----------------------

  addAndUpdateMeeting() {
    // Hide meeting-type loader so success/error modals are not blocked
    this.isMeetingTypeLoading = false;
    this._meetingTypeLoadPending = 0;
    this.syncMeetingTimeFromPicker();
    this.closeDatetimePickers();
    this.isSaving = true;
    this.disabledOnclick = true;

    if (this.g_meetingID != undefined) {
      // START === Date or Meeting number change automatic meeting number add subsequently ===
      var isChangeDateOrNumber = this.checkMeetingNumberOrDateChange();
      if (!isChangeDateOrNumber) {
        this.updateMeeting();
      }
      // END === Date or Meeting number change automatic meeting number add subsequently ===

    } else {
      this.addmeeting();
      var date = new Date();
      this.TodayDate = { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
      this.meetingStartDate = null;
      this.meetingEndDate = null;
    }
  }

  // Function For Automatic Meeting Number Functionality
  changeMeetingNumberInSubsequent() {
    if (this.IsSequenseMeetingNumber == false) {
      this.addmeetingForm.controls.MeetingNumber.setValue("");
    }
    if (this.g_meetingID != undefined) {
      this.updateMeeting();
    }
  }

  // Function For Automatic Meeting Number Functionality
  checkMeetingNumberOrDateChange() {
    // === Automatic Meeting number while update meeting number START ====
    var meetingNumberForAutomaticMeetingNo = this.addmeetingForm.controls.MeetingNumber.value;
    var isMeetingDataGreaterSelectDate = false;


    if (this.showMeetingDateWhileUpdate != undefined) {
      var showMeetingDateWhileUpdate = moment(this.showMeetingDateWhileUpdate).format('DD-MM-YYYY');
      var updateMeetingDate = moment(this.setDate(this.addmeetingForm.controls.MeetingDate.value)).format('DD-MM-YYYY');
      if (updateMeetingDate != showMeetingDateWhileUpdate || meetingNumberForAutomaticMeetingNo != this.showMeetingNumberWhileUpdate) {
        setTimeout(() => {
          $('#automaticMeetingNumberMessage').modal('show');
        }, 500);
        //$('#automaticMeetingNumberMessage').modal('show');
        isMeetingDataGreaterSelectDate = true;
      }
    }
    return isMeetingDataGreaterSelectDate;
    // === Automatic Meeting number while update meeting number END ====
  }

  addAndUpdateMeetingWithPublish() {
    this.isMeetingTypeLoading = false;
    this._meetingTypeLoadPending = 0;
    var meetingDateTime = this.setDate(this.addmeetingForm.controls.MeetingDate.value);
    var meetingTime = ($('.timepicker-init').val()).split(" ")
    var formattedMeetingDate = moment(meetingDateTime.split("-")[2] + "/" + meetingDateTime.split("-")[0] + "/" + meetingDateTime.split("-")[1] + " " + meetingTime[0] + " " + meetingTime[1]).format('DD-MM-YYYY');
    this.formattedMeetingDateTime = moment(meetingDateTime.split("-")[2] + "/" + meetingDateTime.split("-")[0] + "/" + meetingDateTime.split("-")[1] + " " + meetingTime[0] + " " + meetingTime[1]).format('DD-MM-YYYY hh:mm A');
    var publishDate = moment().format('DD-MM-YYYY');
    this.publishDateTime = moment().format('DD-MM-YYYY hh:mm A');

    this.disabledOnclick = true;
    this.documentForm.controls.noticeDate.setValue({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
    this.documentForm.controls.noticeTime.setValue(_.toString(moment().format('LT')));

    this.isAgendaNotify = false;
    this.isNoticeNotify = true;
    this.isPublished = true;
    this.isPublishedFirstTime = true;
    if (this.g_meetingID != undefined) {
      this.updateMeeting();
    } else {
      this.addmeeting();
      var date = new Date();
      this.TodayDate = { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
      this.meetingStartDate = null;
      this.meetingEndDate = null;
    }
  }

  addmeeting() {
    if ($('.timepicker-init').val() == "") {
      this.IsMeetingTimeSelected = true;
      this.isSaving = false;
      this.disabledOnclick = false;
      return false;
    }
    else {
      let self = this;
      let meetingObject = _.find(this.meetingTypes, function (element) { return element._id == self.addmeetingForm.controls.MeetingType.value })
      if (meetingObject == undefined) {
        this.alert.error("Meeting Type is required.");
        this.isSaving = false;
        this.disabledOnclick = false;
      } else {
        var CategoryId = this.addmeetingForm.controls.Category.value;

        var documentObject = {
          noticeDate: this.setDate(this.documentForm.controls.noticeDate.value),
          noticeTime: this.documentForm.controls.noticeTime.value,
          agendaDate: '',
          agendaTime: '',
          draftTime: '',
          draftDate: '',
          finalDate: '',
          finalTime: '',
          isAgendaNotify: this.isAgendaNotify,
          isNoticeNotify: this.isNoticeNotify
        }

        var meeting = {
          URL: location.href,
          CompanyID: null,
          MeetingTypeID: this.addmeetingForm.controls.MeetingType.value,
          MeetingTypeName: meetingObject.MeetingType,
          IsPublished: this.isPublished,
          MeetingNumber: this.addmeetingForm.controls.MeetingNumber.value,
          MeetingDate: this.setDate(this.addmeetingForm.controls.MeetingDate.value),
          MeetingTime: $('.timepicker-init').val(),
          MeetingPlace: this.addmeetingForm.controls.MeetingPlace.value,
          NoticeSignatoryName: this.addmeetingForm.controls.NoticeSignatoryName.value,
          ContactNumber: this.addmeetingForm.controls.ContactNumber.value,
          EmailID: this.addmeetingForm.controls.EmailID.value,
          IssueNoticeDueDate: this.setDate(this.addmeetingForm.controls.IssueNoticeDueDate.value),
          NoticeSignatoryDesignation: this.addmeetingForm.controls.NoticeSignatoryDesignation.value,
          DinNumber: this.addmeetingForm.controls.DinNumber.value,
          ProcessID: this.addmeetingForm.controls.Process.value,
          SigningNoticeDate: this.setDate(this.addmeetingForm.controls.SigningNoticeDate.value),
          SigningNoticePlace: this.addmeetingForm.controls.SigningNoticePlace.value,
          QuarterEnded: this.addmeetingForm.controls.QuarterEnded.value,
          Category: [],
          Compliance: this.SelectedTaskOnProcessID,
          Agenda: [],
          Directors: this.Directors,
          Invitees: this.Invitees,
          Members: this.Members,
          Attendance: [],
          AttendanceFile: "",
          AtrDocument: documentObject,
          isMeetingDataGreaterSelectDate: this.IsSequenseMeetingNumber,
          MeetType: "Meeting"
        }
        if (meeting.Agenda != undefined) {
          try {
            if (meeting.Agenda.length > 0) {
              meeting.Agenda[0].MeetingType = this.SelectedMeetingType;
            }
          } catch (error) {

          }
        }
        this.isSaving = true;
        this.meetingService.addMeeting(meeting)
          .subscribe({
            next: (response) => {
            if (response.status == 0) {
              localStorage.setItem("MeetingID", response.meeting._id);
              if (CategoryId != null && CategoryId != "") {
                this.defaultCategoryAndAgendaAdd(CategoryId, response.meeting._id);
              }

              const meetingId = response.meeting._id;
              const showSuccess = (msg: string) => {
                this.presentSaveSuccess(msg, () => this.EditTask1(meetingId));
              };

              if (this.isPublishedFirstTime == true) {
                if (moment(this.formattedMeetingDateTime).diff(this.publishDateTime) <= 0 && response.ciscoResponse == 1) {
                  showSuccess(
                    "Meeting saved successfully.  Meeting date/time has passed so this meeting is not created in WebEx"
                  );
                } else if (response.ciscoResponse == 1) {
                  showSuccess("Meeting saved successfully. But unable to create on Webx!");
                } else {
                  showSuccess("Meeting saved successfully.");
                }
              } else {
                showSuccess("Meeting saved successfully.");
              }

              if (response.shootMail) {

              }
            }
            else {
              this.isSaving = false;
              this.disabledOnclick = false;
              this.clearModalBackdrops();
              if (response.err_fields != undefined && response.err_fields != "") {
                this.alert.error(JSON.stringify(response.err_fields) + ' fields are required or invalid.');
              } else {
                this.alert.error(response.message);
              }
            }
            },
            error: () => {
              this.isSaving = false;
              this.disabledOnclick = false;
              this.clearModalBackdrops();
              this.alert.error('Unable to save meeting. Please try again.');
            }
          });
      }
    }
  }

  updateMeeting() {
    this.refreshCommitteeRosterBeforeUnpublishedUpdate()
      .then(() => this.executeUpdateMeeting())
      .catch(() => this.executeUpdateMeeting());
  }

  private executeUpdateMeeting() {
    this.meetingAgendaArray = [];

    let meeting1;
    let meeting2;
    let meeting3;
    let meeting;

    var MeetingTypeId = this.addmeetingForm.controls.MeetingType.value;
    var CategoryId = this.addmeetingForm.controls.Category.value;

    var documentObject = {
      noticeDate: this.setDate(this.documentForm.controls.noticeDate.value),
      noticeTime: this.documentForm.controls.noticeTime.value,
      agendaDate: this.documentForm.controls.agendaDate.value && this.documentForm.controls.agendaTime.value != "" ? this.setDate(this.documentForm.controls.agendaDate.value) : '',
      agendaTime: this.documentForm.controls.agendaTime.value,
      draftTime: this.documentForm.controls.draftTime.value,
      draftDate: this.documentForm.controls.draftDate.value && this.documentForm.controls.draftTime.value != "" ? this.setDate(this.documentForm.controls.draftDate.value) : '',
      finalDate: this.documentForm.controls.finalDate.value && this.documentForm.controls.finalTime.value != "" ? this.setDate(this.documentForm.controls.finalDate.value) : '',
      finalTime: this.documentForm.controls.finalTime.value,
      isAgendaNotify: this.isAgendaNotify,
      isNoticeNotify: this.isNoticeNotify,
      isDraftNotify: this.isDraftNotify,
      isATRNotify: this.isATRNotify,
      isFinalNotify: this.isFinalNotify
    }

    if ((this.previousProcesStatus == this.selectProcessFlag)) {
      //No Change in process id--remove compliances during update and leave it as it is
      meeting1 = {
        _id: this.g_meetingID,
        URL: location.href,
        CompanyID: null,
        IsPublished: this.isPublished,
        MeetingTypeID: this.addmeetingForm.controls.MeetingType.value,
        MeetingNumber: this.addmeetingForm.controls.MeetingNumber.value,
        MeetingDate: this.setDate(this.addmeetingForm.controls.MeetingDate.value),
        MeetingTime: $('.timepicker-init').val(),
        MeetingPlace: this.addmeetingForm.controls.MeetingPlace.value,
        NoticeSignatoryName: this.addmeetingForm.controls.NoticeSignatoryName.value,
        ContactNumber: this.addmeetingForm.controls.ContactNumber.value,
        EmailID: this.addmeetingForm.controls.EmailID.value,
        IssueNoticeDueDate: this.setDate(this.addmeetingForm.controls.IssueNoticeDueDate.value),
        NoticeSignatoryDesignation: this.addmeetingForm.controls.NoticeSignatoryDesignation.value,
        DinNumber: this.addmeetingForm.controls.DinNumber.value,
        ProcessID: this.addmeetingForm.controls.Process.value,
        SigningNoticeDate: this.setDate(this.addmeetingForm.controls.SigningNoticeDate.value),
        SigningNoticePlace: this.addmeetingForm.controls.SigningNoticePlace.value,
        QuarterEnded: this.addmeetingForm.controls.QuarterEnded.value,
        Directors: this.UpdateDirector,
        Invitees: this.Invitees,
        Members: this.UpdateMember,
        Compliance: this.SelectedTaskOnProcessID,
        AtrDocument: documentObject,
        isMeetingDataGreaterSelectDate: this.IsSequenseMeetingNumber,
        MeetType: "Meeting"
      }
      meeting = meeting1

    } else if (this.previousProcesStatus && !this.selectProcessFlag) {
      //On Previous change there was task available now empty the compliances
      meeting2 = {
        _id: this.g_meetingID,
        URL: location.href,
        CompanyID: null,
        IsPublished: this.isPublished,
        MeetingTypeID: this.addmeetingForm.controls.MeetingType.value,
        MeetingNumber: this.addmeetingForm.controls.MeetingNumber.value,
        MeetingDate: this.setDate(this.addmeetingForm.controls.MeetingDate.value),
        MeetingTime: $('.timepicker-init').val(),
        MeetingPlace: this.addmeetingForm.controls.MeetingPlace.value,
        NoticeSignatoryName: this.addmeetingForm.controls.NoticeSignatoryName.value,
        ContactNumber: this.addmeetingForm.controls.ContactNumber.value,
        EmailID: this.addmeetingForm.controls.EmailID.value,
        IssueNoticeDueDate: this.setDate(this.addmeetingForm.controls.IssueNoticeDueDate.value),
        NoticeSignatoryDesignation: this.addmeetingForm.controls.NoticeSignatoryDesignation.value,
        DinNumber: this.addmeetingForm.controls.DinNumber.value,
        ProcessID: this.addmeetingForm.controls.Process.value,
        SigningNoticeDate: this.setDate(this.addmeetingForm.controls.SigningNoticeDate.value),
        SigningNoticePlace: this.addmeetingForm.controls.SigningNoticePlace.value,
        QuarterEnded: this.addmeetingForm.controls.QuarterEnded.value,

        Directors: this.InAciveDirectorINMeeting,
        Invitees: this.Invitees,
        Members: this.InActiveMemberINMeeting,
        Compliance: this.SelectedTaskOnProcessID,
        AtrDocument: documentObject,
        isMeetingDataGreaterSelectDate: this.IsSequenseMeetingNumber,
        MeetType: "Meeting"
      }
      meeting = meeting2;

    } else if (!this.previousProcesStatus && this.selectProcessFlag) {
      //On Previous change there was no task available  now has tasks--no change in process
      meeting3 = {
        _id: this.g_meetingID,
        URL: location.href,
        CompanyID: null,
        IsPublished: this.isPublished,
        MeetingTypeID: this.addmeetingForm.controls.MeetingType.value,
        MeetingNumber: this.addmeetingForm.controls.MeetingNumber.value,
        MeetingDate: this.setDate(this.addmeetingForm.controls.MeetingDate.value),
        MeetingTime: $('.timepicker-init').val(),
        MeetingPlace: this.addmeetingForm.controls.MeetingPlace.value,
        NoticeSignatoryName: this.addmeetingForm.controls.NoticeSignatoryName.value,
        ContactNumber: this.addmeetingForm.controls.ContactNumber.value,
        EmailID: this.addmeetingForm.controls.EmailID.value,
        IssueNoticeDueDate: this.setDate(this.addmeetingForm.controls.IssueNoticeDueDate.value),
        NoticeSignatoryDesignation: this.addmeetingForm.controls.NoticeSignatoryDesignation.value,
        DinNumber: this.addmeetingForm.controls.DinNumber.value,
        ProcessID: this.addmeetingForm.controls.Process.value,
        SigningNoticeDate: this.setDate(this.addmeetingForm.controls.SigningNoticeDate.value),
        SigningNoticePlace: this.addmeetingForm.controls.SigningNoticePlace.value,
        QuarterEnded: this.addmeetingForm.controls.QuarterEnded.value,

        Directors: this.InAciveDirectorINMeeting,
        Invitees: this.Invitees,
        Members: this.InActiveMemberINMeeting,
        Compliance: this.SelectedTaskOnProcessID,
        AtrDocument: documentObject,
        isMeetingDataGreaterSelectDate: this.IsSequenseMeetingNumber,
        MeetType: "Meeting"
      }
      meeting = meeting3
    }
       this.meetingService.addMeeting(meeting)
      .subscribe(meeting => {
        if (meeting.status == 0) {
          if (CategoryId != null && CategoryId != "") {
            this.defaultCategoryAndAgendaAdd(CategoryId, this.g_meetingID);  // === Add Category And Agenda After Default Category Select ===
          }

          if (this.isPublishedFirstTime == true) {
            if (moment(this.formattedMeetingDateTime).diff(this.publishDateTime) <= 0 && meeting.ciscoResponse == 1) {
              this.alert.successWithOk1("Meeting updated successfully. Meeting date/time has passed so this meeting is not created in WebEx", () => {
                this.backToMeetingsPage();
              });


            } else {
              if (meeting.ciscoResponse == 1) {

                this.alert.successWithOk1("Meeting updated successfully. But unable to create on WebEx", () => {
                  this.backToMeetingsPage();
                });


              } else {
                this.alert.successWithOk1("Meeting updated successfully.", () => {
                  this.backToMeetingsPage();
                });


              }

            }

          } else {
            this.alert.successWithOk1("Meeting updated successfully.", () => {
              this.backToMeetingsPage();
            });

          }

          this.disabledOnclick = false;
          if (meeting.shootMail) {

          }
        } else {
          if (meeting.err_fields != undefined && meeting.err_fields != "") {
            this.alert.error(JSON.stringify(meeting.err_fields) + ' fields are required or invalid.');
          } else {
            this.alert.error(meeting.message);
          }
        }
      });

  }

  //---------------------------------------+Load Meeting Data On Edit PAge Load------------------

  newDirectors: any;
  loadMeetingDetails(MeetingID) {
    if (!this.companytasklist?.length) {
      this.getCompanyTaskList();
    }

    this.meetingService.getMeetingDetails(MeetingID)
      .subscribe((meetingDetails: any) => {
        if (meetingDetails.status == 0) {
          var activeMemberINMeeting = [];
          var activeDirectorINMeeting = [];
          var activeUserAttendanceINMeeting = [];
          let dt;
          this.MeetingTypeName = meetingDetails.meetingData[0].MeetingTypeName;
          this.addOrUpdate = 'Update';
          this.meetingDataObject = meetingDetails.meetingData
          this.g_meetingTypeID = meetingDetails.meetingData[0].MeetingTypeID;
          this.defaultCategoryArray = [];
          this.toGetDefaultCategory(this.g_meetingTypeID, 'MeetingEdit');
          $("#AttandanceTable").DataTable().destroy();
          // START === Use For Automatic Meeting Number ====
          if (meetingDetails.meetingData[0].MeetingNumber != "" && meetingDetails.meetingData[0].MeetingNumber != null) {
            this.showMeetingNumberWhileUpdate = meetingDetails.meetingData[0].MeetingNumber;
          }
          this.showMeetingDateWhileUpdate = meetingDetails.meetingData[0].MeetingDate;
          // END === Use For Automatic Meeting Number ====

          if (meetingDetails.meetingData[0].MeetingTypeName == 'Board'
            || meetingDetails.meetingData[0].MeetingTypeName == 'Independent Directors'
            || meetingDetails.meetingData[0].MeetingTypeName == 'Annual General Meeting'
            || meetingDetails.meetingData[0].MeetingTypeName == 'Extraordinary General Meeting'
            || meetingDetails.meetingData[0].MeetingTypeName == 'Postal Ballot'
            || meetingDetails.meetingData[0].MeetingTypeName == 'Others') {

            this.isMembersAreHidden = true;
            this.directorTabName = 'Directors'

          } else {

            this.isMembersAreHidden = false
            this.directorTabName = 'Members';
          }
          var self = this;
          if (meetingDetails.meetingData[0].MeetingTypeName == "Independent Directors") {
            self.meetingService.getDirectorOnOtherThenCommitteeMembers().subscribe(director => {
              if (director.status == 0) {
                var rec = [];
                var dirObj = [];
                rec = director.directorList;
                var newData = rec.filter(function (element) {
                  if (element.DirectorProfession[0].Category == "Independent") {
                    return true;
                  }
                });
                newData.forEach(element => {
                  var data = {
                    DirectorID: element._id,
                    DirectorName: element.FirstName + ' ' + element.MiddleName + ' ' + element.LastName,
                    Designation: element.DirectorProfession.length == 0 ? '' : element.DirectorProfession[0].Designation,
                    IsExecutive: element.DirectorProfession.length == 0 ? 'Non-Executive' : element.DirectorProfession[0].IsExecutive,
                    AppointmentDate: element.DirectorProfession.length == 0 ? '' : element.DirectorProfession[0].AppointmentDate,
                    Chairman: element.DirectorProfession.length == 0 ? 'No' : element.DirectorProfession[0].IsChairman,
                    Category: element.DirectorProfession.length == 0 ? '' : element.DirectorProfession[0].Category,
                    CessationDate: element.DirectorProfession.length == 0 ? '' : element.DirectorProfession[0].CessationDate,
                    Tenure: "",
                    UserGovevaId: element.UserGovevaId,
                    CessationReason: "",
                    EmailID: element.EmailID
                  }
                  dirObj.push(data);
                })
              }
              this.Directors = dirObj;
              $("#directorTable").DataTable().destroy();
              this.dtTriggerDirector.next();
            })
          }
          // else{
          $("#directorTable").DataTable().destroy();
          this.dtTriggerDirector.next();
          this.Directors = meetingDetails.meetingData[0].Directors;
          if (this.Member != null) {
            this.Directors = this.Directors.concat(this.Member);
          }

          // var dirData = meetingDetails.meetingData[0].Directors;          
          this.UpdateDirector = meetingDetails.meetingData[0].Directors;
          // }

          // $('#inviteeTable').destroy();
          $("#inviteeTable").DataTable().destroy();
          this.dtTriggerInvitee.next();
          this.Invitees = meetingDetails.meetingData[0].Invitees;
          //  var memberTable = $('#memberTable').DataTable({ destroy: true });
          this.Member = meetingDetails.meetingData[0].Members;
          this.Members = meetingDetails.meetingData[0].Members;

          this.DirectorsToDisplayIn_MembersDirectors_Tab = this.Directors;
          if (this.Member != null) {
            this.DirectorsToDisplayIn_MembersDirectors_Tab = this.Directors.concat(this.Member);
          }

          // this.directorsmemberInvetteeAttended = activeUserAttendanceINMeeting;
          this.directorsmemberInvetteeAttended = meetingDetails.meetingData[0].Attendance;
          this.meetingMember = meetingDetails.meetingData[0].Members;
          this.UpdateMember = meetingDetails.meetingData[0].Members;
          this.getActivatedTaskList();
          this.addmeetingForm.controls.MeetingNumber.setValue(meetingDetails.meetingData[0].MeetingNumber);
          this.addmeetingForm.controls.MeetingPlace.setValue(meetingDetails.meetingData[0].MeetingPlace);
          this.addmeetingForm.controls.NoticeSignatoryName.setValue(meetingDetails.meetingData[0].NoticeSignatoryName);
          this.addmeetingForm.controls.ContactNumber.setValue(meetingDetails.meetingData[0].ContactNumber);
          this.addmeetingForm.controls.DinNumber.setValue(meetingDetails.meetingData[0].DinNumber);
          this.addmeetingForm.controls.EmailID.setValue(meetingDetails.meetingData[0].EmailID);
          this.addmeetingForm.controls.MeetingType.setValue(meetingDetails.meetingData[0].MeetingTypeID);
          this.addmeetingForm.controls.MeetingType.disable();
          this.addmeetingForm.controls.MeetingTime.setValue(meetingDetails.meetingData[0].MeetingTime);
          this.addmeetingForm.controls.NoticeSignatoryDesignation.setValue(meetingDetails.meetingData[0].NoticeSignatoryDesignation);
          this.addmeetingForm.controls.SigningNoticePlace.setValue(meetingDetails.meetingData[0].SigningNoticePlace);
          this.addmeetingForm.controls.QuarterEnded.setValue(meetingDetails.meetingData[0].QuarterEnded);
          this.meetingGemStatus = meetingDetails.meetingData[0].isVisibleInGem;
          if (this.meetingGemStatus == true || this.meetingGemStatus == undefined || this.meetingGemStatus == null) {
            this.hideOrShowBtnMsg = 'Hide Meeting From GEM'
          } else {
            this.hideOrShowBtnMsg = 'Show Meeting in GEM'
          }

          this.meetingFreezeStatus = meetingDetails.meetingData[0].isFreezed;
          if (this.meetingFreezeStatus == true) {
            this.freezeBtnMsg = 'Unfreeze Meeting'
          } else {
            this.freezeBtnMsg = 'Freeze Meeting'
          }

          if (meetingDetails.meetingData[0].AtrDocument.length > 0) {
            if (meetingDetails.meetingData[0].AtrDocument[0].noticeDate != null) {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].noticeDate));
              this.documentForm.controls.noticeDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            }
            if (meetingDetails.meetingData[0].AtrDocument[0].agendaDate != null) {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].agendaDate));
              this.documentForm.controls.agendaDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            }

            if (meetingDetails.meetingData[0].AtrDocument[0].draftDate != null) {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].draftDate));
              this.documentForm.controls.draftDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            }

            if (meetingDetails.meetingData[0].AtrDocument[0].finalDate != null) {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].finalDate));
              this.documentForm.controls.finalDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            }

            this.isNoticeNotify = meetingDetails.meetingData[0].AtrDocument[0].isNoticeNotify;
            this.isFinalNotify = meetingDetails.meetingData[0].AtrDocument[0].isFinalNotify;
            this.isDraftNotify = meetingDetails.meetingData[0].AtrDocument[0].isDraftNotify;
            this.isAgendaNotify = meetingDetails.meetingData[0].AtrDocument[0].isAgendaNotify;
            this.isATRNotify = meetingDetails.meetingData[0].AtrDocument[0].isATRNotify;

            this.documentForm.controls.noticeTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].noticeTime);
            this.documentForm.controls.agendaTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].agendaTime);
            this.documentForm.controls.draftTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].draftTime);
            this.documentForm.controls.finalTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].finalTime);
          }


          if (meetingDetails.meetingData[0].IsPublished == true) {
            this.isPublished = true;
          } else {
            this.isPublished = false;
          }

          // Enrich blank Member/Invitee names; unpublished committee meetings refresh roster from committee
          this.syncMeetingRosterAfterEditLoad(meetingDetails.meetingData[0]);


          if (meetingDetails.meetingData[0].Category.length > 0) {
            this.AgendaCategory = []
            $("#addingCategoryTable").DataTable().destroy();
            this.AgendaCategory = meetingDetails.meetingData[0].Category;
            this.dtTriggerOfCategory.next();

          }
          this.toGetCategoryOnUpdate(meetingDetails.meetingData[0].MeetingTypeID, meetingDetails.meetingData[0].Category)

          this.availableCaegory = meetingDetails.meetingData[0].MeetingTypeID, meetingDetails.meetingData[0].Category;

          if (meetingDetails.meetingData[0].IssueNoticeDueDate != null) {
            dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].IssueNoticeDueDate));
            this.IssueNoticeDueDateModelFromDatabase = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            this.addmeetingForm.controls['IssueNoticeDueDate'].setValue(this.IssueNoticeDueDateModelFromDatabase)
          }
          if (meetingDetails.meetingData[0].SigningNoticeDate != null) {
            dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].SigningNoticeDate));
            this.SigningNoticeDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
          }

          if (meetingDetails.meetingData[0].MeetingDate != null) {
            dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].MeetingDate));
            var date = new Date(meetingDetails.meetingData[0].MeetingDate);
            this.TodayDate = { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
            this.MeetingDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };


            var meeting = _.find(this.meetingTypes, function (meettingObject) {
              if (meettingObject._id == meetingDetails.meetingData[0].MeetingTypeID) {
                return meettingObject.MeetingType
              }
            });

            this.titleOnAddUpdate = meeting.MeetingType + '- (' + date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ', ' + meetingDetails.meetingData[0].MeetingTime + ')';


          }//Meeting dae Not Null IF

          if (meetingDetails.meetingData[0].Documents != undefined || meetingDetails.meetingData[0].Documents != null) {
            this.meetingDocumentArray = meetingDetails.meetingData[0].Documents
            this.include_agendaFile_in_agendaFileArray();
          }


          this.meetingService.getProcessByMeetingType(meetingDetails.meetingData[0].MeetingTypeID)
            .subscribe(process => {
              if (process.status == 0) {
                this.processArray = process.processData;

              }
            });
          this.addmeetingForm.controls.Process.setValue(meetingDetails.meetingData[0].ProcessID);
          if (meetingDetails.meetingData[0].ProcessID) {
            this.selectProcessFlag = true;
            this.previousProcesStatus = true;
            this.PreviousProcessID = meetingDetails.meetingData[0].ProcessID
          } else {
            this.previousProcesStatus = false;
          }

          this.complianceToShow = [];
          $("#addedtaskTable").DataTable().destroy()

          this.agendaArray = [];
          $("#agendaTable").DataTable().destroy();
          $("#agendaNewTable").DataTable().destroy();
          this.agendaArray = _.sortBy(meetingDetails.meetingData[0].Agenda, ["Agendaorder"]);

          this.newAgendaArray = this.agendaArray.map(enhanchArr);
          this.newAgendaArray.push(...this.tempArray)

          this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
            return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
          });
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
          this.dtTriggerAgenda.next();
          this.dtTriggerAgendaNew.next()

          this.transferToGemArray = [];
          $("#transferToGemTable").DataTable().destroy();
          this.transferToGemArray = meetingDetails.meetingData[0].Agenda;
          for (var index = 0; index < this.transferToGemArray.length; index++) {
            this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
          }

          this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
          this.dtTriggerOfTransferToGem.next();


          this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
            return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
          });
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;

          $("#agendaAccessTable").DataTable().destroy();
          this.agendaAccessArray = meetingDetails.meetingData[0].AgendaAccessRights;
          this.dtTriggerAgendaAccess.next();

          if (meetingDetails.meetingData[0].AttendanceAttribute[0] != undefined) {

            if (meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingStartDate == null) {
              this.meetingStartDate = null;
            } else {
              var dt1 = new Date(this.setFormatDate(meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingStartDate));
              this.meetingStartDate = { month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() };
            }
            if (meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingEndDate == null) {
              this.meetingEndDate = null;
            } else {
              dt1 = new Date(this.setFormatDate(meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingEndDate));
              this.meetingEndDate = { month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() };
            }
            if (meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingStartTime != undefined || meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingStartTime != '') {
              this.checkMeetingStartTime(event);
            }
            if (meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingEndTime != undefined || meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingEndTime != '') {
              this.checkMeetingEndTime(event);
            }
            this.meetingStartTime = meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingStartTime;
            this.meetingEndTime = meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingEndTime;

            $("#meetingStartTime").val(meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingStartTime);
            $("#meetingEndTime").val(meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingEndTime);


            this.meetingHeld = meetingDetails.meetingData[0].AttendanceAttribute[0].MeetingHeld;
            if (meetingDetails.meetingData[0].AttendanceAttribute[0].MeetimeADJDate == 'null' || meetingDetails.meetingData[0].AttendanceAttribute[0].MeetimeADJDate == null) {
              this.meetimeADJDate = null;
            } else {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AttendanceAttribute[0].MeetimeADJDate))
              this.meetimeADJDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
              var newMeetimeADJDate = moment(meetingDetails.meetingData[0].AttendanceAttribute[0].MeetimeADJDate).format('YYYY-MM-DD');
            }
            var newMeetingDates = moment(meetingDetails.meetingData[0].MeetingDate).format('YYYY-MM-DD');

            if (newMeetimeADJDate == null || (moment(newMeetimeADJDate).diff(moment(newMeetingDates).format('YYYY-MM-DD'), "days") >= 0)) {
              this.disableAdjournedDate = true;
            } else {
              this.disableAdjournedDate = false;
            }
            if (this.meetingHeld == "Adjourned") {
              this.adjournedClicked('ADJ')
            }
            else {
              this.adjournedClicked(this.meetingHeld);
            }

            this.meetimeADJTime = meetingDetails.meetingData[0].AttendanceAttribute[0].MeetimeADJTime;

          } else {
            var date = new Date();
            this.TodayDate = { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
            this.meetingStartDate = null;
            this.meetingEndDate = null;
            this.meetimeADJDate = null
            var Meetingdate = this.setDate(this.MeetingDateModel);
            var meetimeADJDate = this.setDate(this.meetimeADJDate);
            if (meetimeADJDate == null || (moment(meetimeADJDate).diff(moment(Meetingdate).format('YYYY-MM-DD'), "days") >= 0)) {
              this.disableAdjournedDate = true;

            } else {
              this.disableAdjournedDate = false;
            }

          }



          // this.setActivatedMemberRecordOnMeetingDateChange(meetingDetails.meetingData[0].MeetingDate);

          // this.setActivatedDirectorRecordOnMeetingDateChange(meetingDetails.meetingData[0].MeetingDate);

          this.IsATRAvailable = false;
          this.ATRFile_id = undefined;
          if (this.AtrDocument != undefined) {

            this.ATRFile_id = meetingDetails.meetingData[0].AtrDocument[0].atrFile_id;
            if (this.ATRFile_id != undefined) {
              this.IsATRAvailable = true;
            }
            if (meetingDetails.meetingData[0].AtrDocument[0].noticeDate != null) {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].noticeDate));
              this.documentForm.controls.noticeDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            }
            if (meetingDetails.meetingData[0].AtrDocument[0].draftDate != null) {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].draftDate));
              this.documentForm.controls.draftDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            }
            if (meetingDetails.meetingData[0].AtrDocument[0].agendaDate != null) {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].agendaDate));
              this.documentForm.controls.agendaDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            }
            if (meetingDetails.meetingData[0].AtrDocument[0].finalDate != null) {
              dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].finalDate));
              this.documentForm.controls.finalDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            }

            this.documentForm.controls.noticeTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].noticeTime);
            this.documentForm.controls.agendaTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].agendaTime);
            this.documentForm.controls.draftTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].draftTime);
            this.documentForm.controls.finalTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].finalTime);


          }
          // this.documentForm.controls.draftDate.setValue(this.commonFunction.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].draftDate));
          // this.documentForm.controls.draftTime.setValue("");
          // this.documentForm.controls.agendaDate.setValue(this.commonFunction.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].agendaDate));
          // this.documentForm.controls.agendaTime.setValue("");

          // this.refreshDirectorsTableWithData(this.Directors, this.Invitees, this.Members);


          if (this.attendanceFile == "") {
            this.isFileAvailable = false;
          } else {
            this.isFileAvailable = true;
          }
          var activeAttendanceDirectorData = []
          this.dtTriggerAttandance.next()
          if (meetingDetails.meetingData[0].IssueNoticeDueDate != null) {

            this.ignoredFirstEvent = true;
            dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].IssueNoticeDueDate));
            this.IssueNoticeDueDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            this.newAssignIssueNoticeDueDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
            this.addmeetingForm.controls['IssueNoticeDueDate'].setValue(this.IssueNoticeDueDateModel)

            this.isIssueDispacted = true

          }
        }
      });

  }

  isIssueDispacted: boolean = false;

  isDirectorActive(directorId) {
    var retrningVal = false;
    for (var i = 0; i < this.Directors.length; i++) {
      if (this.Directors[i]._id == directorId) {
        retrningVal = true;
        break;
      } else {
        retrningVal = false;
      }
    }
    return retrningVal;
  }




  maintainOnlyOneChairman(ev, data) {
    if (ev.target.checked == false) {

      this.directorsmemberInvetteeAttended.forEach(element => {
        element.alternateChairman = false;
      });

      for (var i = 0; i < this.directorsmemberInvetteeAttended.length; i++) {
        this.directorsmemberInvetteeAttended[i].alternateChairman = false;
        ev.target.checked = false
      }


    } else {

      this.directorsmemberInvetteeAttended.forEach(element => {
        element.alternateChairman = false;
      });
      //ev.target.checked == true
      for (var i = 0; i < this.directorsmemberInvetteeAttended.length; i++) {
        if (data._id == this.directorsmemberInvetteeAttended[i]._id) {
          this.directorsmemberInvetteeAttended[i].alternateChairman = true;
          ev.target.checked = true;
        }
      }

    }

  }

  checkselected() {
    this.attendedAll = this.directorsmemberInvetteeAttended.every(function (item: any) {
      return item.isAttended == true;
    })
  }


  selectAllAttanded(ev) {
    // alert(ev.target.checked);
    if (ev.target.checked == true) {

      this.directorsmemberInvetteeAttended.forEach(element => {
        element.isAttended = true;
      });
    } else {
      this.directorsmemberInvetteeAttended.forEach(element => {
        element.isAttended = false;
      });
    }

  }


  addInvitee() {
    this.Invitees.push(this.inviteesEntry);
    this.inviteesEntry = {};
  }

  addAttandance() {
    this.disabledOnclick = true;
    var attendedMember = [];
    if (this.adjFlag == false) {
      this.meetimeADJDate = null;
      this.meetimeADJTime = "";
    }
    var attendance = {
      "MeetingHeld": this.meetingHeld,
      "MeetingStartDate": this.commonFunction.setDate(this.meetingStartDate),
      "MeetingStartTime": $("#meetingStartTime").val(),
      "MeetingEndDate": this.commonFunction.setDate(this.meetingEndDate),
      "MeetingEndTime": $("#meetingEndTime").val(),
      "MeetimeADJDate": this.commonFunction.setDate(this.meetimeADJDate),
      "MeetimeADJTime": $("#meetingADJTime").val(),
    }

    this.meetingService.addAttendance(this.g_meetingID, this.directorsmemberInvetteeAttended, attendance)
      .subscribe(meeting => {
        this.disabledOnclick = true;
        if (meeting.status == 0) {
          this.disabledOnclick = false;

          this.alert.success('Attendance saved succesfully');
        }
      });
    this.attandedMembers = attendedMember;
  }

  directorFormInitialisation() {

    this.directorForm = new FormGroup({
      MemberName: new FormControl({ disabled: true }, [Validators.required]),
      Designation: new FormControl({ disabled: true }, [Validators.required]),
      Category: new FormControl({ disabled: true }, [Validators.required]),
      IsExecutive: new FormControl({ disabled: true }, [Validators.required]),
      Chairman: new FormControl('', []),
      AppointmentDate: new FormControl('', [Validators.required]),
      Tenure: new FormControl('', []),
      CessationDate: new FormControl(null, []),
      CessationReason: new FormControl('', []),
      DirectorID: new FormControl({ value: '', disabled: true }, []),
    });

  }


  toRefreshAgendaAndComplianceDatatable(MeetingTypeId) {
    this.agendaArray = [];
    var agendaTable = $('#agendaTable').DataTable({ destroy: true });
    agendaTable.destroy();
    $("#agendaNewTable").DataTable().destroy();
    this.transferToGemArray = [];
    var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
    transferToGemTable.destroy();

    this.meetingService.getAgendaByMeetingType(MeetingTypeId)
      .subscribe(agenda => {
        if (agenda.status == 0) {

          this.agendaArray = _.sortBy(agenda.agendaData, ["Agendaorder"]);

          this.newAgendaArray = this.agendaArray.map(enhanchArr);
          this.newAgendaArray.push(...this.tempArray)
          this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
            return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
          });
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;

          this.dtTriggerAgenda.next();
          this.dtTriggerAgendaNew.next()
          this.transferToGemArray = agenda.agendaData;
          for (var index = 0; index < this.transferToGemArray.length; index++) {
            this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
          }
          this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
          this.dtTriggerOfTransferToGem.next();
          $("#agendaAccessTable").DataTable().destroy();
          this.agendaAccessArray = agenda.agendaData;
          this.dtTriggerAgendaAccess.next();
        }
      });
  }

  //need to think on this functionality for further use.
  toRefreshDirectorsInviteesAndMembersDatatable(meetingId) {
  }

  private isBoardLikeMeetingTypeName(meetingTypeName?: string): boolean {
    const name = meetingTypeName || this.MeetingTypeName || '';
    return [
      'Board',
      'Independent Directors',
      'Annual General Meeting',
      'Extraordinary General Meeting',
      'Postal Ballot',
      'Others'
    ].indexOf(name) !== -1;
  }

  private isCommitteeMeetingType(meetingTypeId?: string): boolean {
    const id = meetingTypeId || this.g_meetingTypeID || this.addmeetingForm?.controls?.MeetingType?.value;
    const meetingType = _.find(this.meetingTypes || [], (o) => o._id == id);
    if (meetingType && meetingType.IsCommitteeType != null) {
      return !!meetingType.IsCommitteeType;
    }
    return !this.isBoardLikeMeetingTypeName(meetingType?.MeetingType || this.MeetingTypeName);
  }

  private getCurrentMeetingTypeId(): string {
    return this.g_meetingTypeID || this.addmeetingForm?.controls?.MeetingType?.value;
  }

  /** Pull live Directors / Members / Invitees from the linked committee. */
  private loadCommitteeMembersIntoMeeting(meetingTypeId: string): Promise<void> {
    if (!meetingTypeId) {
      return Promise.resolve();
    }

    return this.meetingService.getCommitteeMembers(meetingTypeId).toPromise()
      .then((members: any) => {
        if (!members || members.status != 0 || !members.committeeMembers || !members.committeeMembers.length) {
          this.Directors = [];
          this.Invitees = [];
          this.Members = [];
          this.Member = [];
          this.UpdateDirector = [];
          this.UpdateMember = [];
          this.meetingMember = [];
          return;
        }

        const committee = members.committeeMembers[0];
        (committee.Directors || []).forEach((element) => { element.selectedDirector = false; });
        (committee.Invitees || []).forEach((element) => { element.selectedInvitee = false; });
        (committee.Members || []).forEach((element) => { element.selectedMember = false; });

        this.Directors = committee.Directors || [];
        this.Invitees = committee.Invitees || [];
        this.Members = committee.Members || [];
        this.Member = this.Members;
        this.UpdateDirector = this.Directors;
        this.UpdateMember = this.Members;
        this.meetingMember = this.Members;
      });
  }

  /**
   * Members/Invitees may store only UserGovevaId. Resolve names from GovEva
   * (same approach as committee-edit) so the meeting members datatable is not blank.
   */
  private resolveMissingMeetingMemberDisplayDetails(): Promise<void> {
    const members = this.Members || this.Member || [];
    const invitees = this.Invitees || [];
    const directors = this.Directors || [];

    const membersNeedLookup = (members || []).some(
      (m) => (m.UserGovevaId || m.GovevaUserId) && !m.MemberName
    );
    const inviteesNeedLookup = (invitees || []).some(
      (i) => (i.UserGovevaId || i.GovevaUserId) && !i.InviteeName
    );
    const directorsNeedLookup = (directors || []).some(
      (d) => (d.UserGovevaId || d.GovevaUserId) && !d.DirectorName && !d.MemberName
    );

    const tasks: Promise<void>[] = [];

    if (membersNeedLookup || directorsNeedLookup) {
      tasks.push(
        this.committeeService.getMembersFromGoveva().toPromise().then((response: any) => {
          const users = response && response.status === 0 ? (response.userList || []) : [];
          const byId = {};
          users.forEach((u) => {
            const id = String(u.UserGovevaId || u._id || '');
            if (id) {
              byId[id] = u;
            }
          });

          const buildName = (user) =>
            user.FullName || [user.Title, user.FirstName, user.LastName].filter(Boolean).join(' ').trim();

          this.Members = (this.Members || this.Member || []).map((m) => {
            const id = String(m.UserGovevaId || m.GovevaUserId || '');
            const user = byId[id];
            if (user && !m.MemberName) {
              m.MemberName = buildName(user);
              if (!m.Designation && (user.Designation || m.GovEvaUserDesignation)) {
                m.Designation = user.Designation || m.GovEvaUserDesignation;
              }
              if (!m.EmailId && user.EmailId) {
                m.EmailId = user.EmailId;
              }
              if (!m.MobileNo && user.MobileNumber) {
                m.MobileNo = user.MobileNumber;
              }
            }
            return m;
          });
          this.Member = this.Members;
          this.UpdateMember = this.Members;

          this.Directors = (this.Directors || []).map((d) => {
            const id = String(d.UserGovevaId || d.GovevaUserId || '');
            const user = byId[id];
            if (user && !d.DirectorName && !d.MemberName) {
              const fullName = buildName(user);
              d.DirectorName = fullName;
              d.MemberName = fullName;
              if (!d.Designation && (user.Designation || d.GovEvaUserDesignation)) {
                d.Designation = user.Designation || d.GovEvaUserDesignation;
              }
            }
            return d;
          });
          this.UpdateDirector = this.Directors;
        }).catch(() => undefined)
      );
    }

    if (inviteesNeedLookup) {
      tasks.push(
        this.committeeService.getUsersFromGovevaForInvittee().toPromise().then((response: any) => {
          const users = response && response.status === 0
            ? (response.result || response.userList || response.UserList || response.data || [])
            : [];
          const byId = {};
          (Array.isArray(users) ? users : []).forEach((u) => {
            const id = String(u.UserGovevaId || u._id || '');
            if (id) {
              byId[id] = u;
            }
          });
          this.Invitees = (this.Invitees || []).map((i) => {
            const id = String(i.UserGovevaId || i.GovevaUserId || '');
            const user = byId[id];
            if (user && !i.InviteeName) {
              i.InviteeName = user.FullName || [user.Title, user.FirstName, user.LastName].filter(Boolean).join(' ').trim();
              if (!i.Designation && user.Designation) {
                i.Designation = user.Designation;
              }
              if (!i.EmailId && user.EmailId) {
                i.EmailId = user.EmailId;
              }
              if (!i.MobileNo && user.MobileNumber) {
                i.MobileNo = user.MobileNumber;
              }
            }
            return i;
          });
        }).catch(() => undefined)
      );
    }

    return Promise.all(tasks).then(() => undefined);
  }

  private rebuildDirectorsMembersDisplayTab(): void {
    const directors = (this.Directors || []).map((d) => {
      if (!d.DirectorName && d.MemberName) {
        d.DirectorName = d.MemberName;
      }
      return d;
    });
    const members = (this.Members || this.Member || []).map((m) => {
      if (!m.DirectorName && m.MemberName) {
        m.DirectorName = m.MemberName;
      }
      if (!m.Designation && m.GovEvaUserDesignation) {
        m.Designation = m.GovEvaUserDesignation;
      }
      return m;
    });

    this.UpdateDirector = this.Directors || [];
    this.UpdateMember = this.Members || this.Member || [];
    this.DirectorsToDisplayIn_MembersDirectors_Tab = directors.concat(members);
  }

  private refreshMeetingMemberDataTables(): void {
    try { $('#directorTable').DataTable().destroy(); } catch (e) { }
    try { $('#inviteeTable').DataTable().destroy(); } catch (e) { }
    try { $('#memberTable').DataTable().destroy(); } catch (e) { }
    setTimeout(() => {
      try { this.dtTriggerDirector.next(); } catch (e) { }
      try { this.dtTriggerInvitee.next(); } catch (e) { }
      try { this.dtTriggerMember.next(); } catch (e) { }
    }, 0);
  }

  /**
   * On edit load: resolve blank names always.
   * If unpublished committee meeting, replace roster from live committee first.
   */
  private syncMeetingRosterAfterEditLoad(meetingData: any): void {
    const meetingTypeId = meetingData.MeetingTypeID;

    // Independent Directors load their director list separately
    if (meetingData.MeetingTypeName === 'Independent Directors') {
      this.Invitees = meetingData.Invitees || [];
      this.Members = meetingData.Members || [];
      this.Member = this.Members;
      this.UpdateMember = this.Members;
      this.resolveMissingMeetingMemberDisplayDetails().then(() => {
        this.DirectorsToDisplayIn_MembersDirectors_Tab = this.Directors || [];
        this.refreshMeetingMemberDataTables();
      });
      return;
    }

    const applyDisplay = () => {
      this.resolveMissingMeetingMemberDisplayDetails().then(() => {
        this.rebuildDirectorsMembersDisplayTab();
        this.refreshMeetingMemberDataTables();
      });
    };

    if (!this.isPublished && this.isCommitteeMeetingType(meetingTypeId)) {
      this.loadCommitteeMembersIntoMeeting(meetingTypeId)
        .then(() => applyDisplay())
        .catch(() => applyDisplay());
      return;
    }

    // Published / board-like: keep meeting snapshot, but reset clean arrays (avoid stale concat)
    this.Directors = meetingData.Directors || [];
    this.Invitees = meetingData.Invitees || [];
    this.Members = meetingData.Members || [];
    this.Member = this.Members;
    this.UpdateDirector = this.Directors;
    this.UpdateMember = this.Members;
    applyDisplay();
  }

  /** Before update of an unpublished committee meeting, refresh members from committee. */
  private refreshCommitteeRosterBeforeUnpublishedUpdate(): Promise<void> {
    if (this.isPublished || !this.isCommitteeMeetingType()) {
      return Promise.resolve();
    }
    return this.loadCommitteeMembersIntoMeeting(this.getCurrentMeetingTypeId())
      .then(() => this.resolveMissingMeetingMemberDisplayDetails())
      .then(() => {
        this.rebuildDirectorsMembersDisplayTab();
      })
      .catch(() => undefined);
  }

  addProcessModalOpenEvent() {
  }

  addComplianceModalOpenEvent() {
    //on click of button to show popup form..
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#AddCompliancesDialog').removeClass('show').hide();

    if (!this.companytasklist?.length) {
      this.getCompanyTaskList();
    }

    setTimeout(() => {
      $('#AddCompliancesDialog').modal('show');
    }, 100);
    this.showAllTasks()

  }

  loadModelForAddDirector() {
    this.updatedirectorButtonFlag = false;
    this.directorForm.reset();
    $("#btnUpdateDirectorRow").hide();
    $("#btnaddDirectorRow").show();
    this.getDirectorsDIN();
  }

  getDirectorsDIN() {
    //this.availableDirectorsID
    var actualdDataToShow = [];
    this.directorData = [];
    this.availableDirectorsID = "";
    const self = this;
    if (this.Directors.length > 0) {
      this.Directors.forEach(function (o) {
        if (self.availableDirectorsID == "" || self.availableDirectorsID == null) {
          self.availableDirectorsID = o.DirectorID;
        } else {
          self.availableDirectorsID = self.availableDirectorsID + "," + o.DirectorID;
        }
      })
    }
    else {
    }


    this.directorService.getDirectorMember().subscribe(director => {

      if (director.status == 0) {
        this.directorData = director.directorList;
        var availDirectorId = this.availableDirectorsID.split(',');

        for (var i = 0; i < this.directorData.length; i++) {
          var found = false;
          for (var j = 0; j < availDirectorId.length; j++) {
            if (availDirectorId[j] == this.directorData[i]._id && availDirectorId[j] != undefined) {

              if (this.updatedirectorButtonFlag) {
                if (availDirectorId[j] == this.directorObjectToBindWhileUpdating.DirectorID) {

                  _.assign(this.directorObjectToBindWhileUpdating, { "Din": this.directorData[i].Din, "FirstName": this.directorData[i].FirstName, "LastName": this.directorData[i].LastName, "IsUpdating": true });

                  this.directorObjectDinToBindWhileUpdating = this.directorData[i].Din;
                }
              }
              found = true;
            }
          }
          if (this.directorData[i] && !found) {
            actualdDataToShow.push(this.directorData[i]);
          }
        }
      }
      this.directorData = actualdDataToShow;


      if (this.updatedirectorButtonFlag) {
        this.directorData.push(this.directorObjectToBindWhileUpdating);
      }


    });
  }

  getDirectorDetails(ev) {
    var dinID = ev.target.value;
    this.directorData.forEach(element => {
      if (element.Din == dinID) {
        this.directorForm.controls.DirectorID.setValue(element._id);
        this.directorForm.controls.MemberName.setValue(element.FirstName + " " + element.MiddleName + " " + element.LastName);

        if (element.IsUpdating == undefined) {

          if (element.DirectorProfession.length > 0) {
            if (element.DirectorProfession[0].Designation == undefined || element.DirectorProfession[0].Designation == null || element.DirectorProfession[0].Designation == "") {
              this.directorForm.controls.Designation.setValue("");
            }
            else if (element.DirectorProfession[0].Designation) {
              this.directorForm.controls.Designation.setValue(element.DirectorProfession[0].Designation);
            }

            if (element.DirectorProfession[0].Category == undefined || element.DirectorProfession[0].Category == null || element.DirectorProfession[0].Category == "") {
              this.directorForm.controls.Category.setValue("");
            }
            else if (element.DirectorProfession[0].Category) {
              this.directorForm.controls.Category.setValue(element.DirectorProfession[0].Category);
            }

            if (element.DirectorProfession[0].IsExecutive == undefined || element.DirectorProfession[0].IsExecutive == null) {
              this.directorForm.controls.IsExecutive.setValue("");
            }
            else if (element.DirectorProfession[0].IsExecutive == false) {
              this.directorForm.controls.IsExecutive.setValue("Non-Executive");
            }
            else if (element.DirectorProfession[0].IsExecutive) {
              this.directorForm.controls.IsExecutive.setValue("Executive");
            }

          }
          else {
            this.directorForm.controls.Designation.setValue("");
            this.directorForm.controls.Category.setValue("");
            this.directorForm.controls.IsExecutive.setValue("");
          }

        } else if (element.IsUpdating) {
          this.directorForm.controls.Designation.setValue(element.Designation);
          this.directorForm.controls.Category.setValue(element.Category);
          this.directorForm.controls.IsExecutive.setValue(element.IsExecutive);
        }

      }
    });

  }

  agendasCompliancepopUpDataToShow(agendaDetailsObject) {
    var agendaCompliancePopUpTable = $('#agendaCompliancePopUpTable').DataTable({ destroy: true });
    agendaCompliancePopUpTable.destroy();
    if (agendaDetailsObject.AgendaCompliance == undefined || agendaDetailsObject.AgendaCompliance.length == 0) {
      this.agendaCompliances = [];
    } else if (agendaDetailsObject.AgendaCompliance.length > 0) {
      this.agendaCompliances = agendaDetailsObject.AgendaCompliance
    }
    this.dtTriggerAgendaCompliancePopUp.next()
  }

  removeDUplicateCompliance(ComplianceArray, PropertyValueToCheck) {
    return ComplianceArray.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[PropertyValueToCheck]).indexOf(obj[PropertyValueToCheck]) === pos;
    });
  }

  //commented out for later use when unique task will be required.
  toGetComplianceRelatedToAgendaOfCurrentMeetingType() {
    if (this.agendaArray.length > 0) {
      const self = this;
      _.forEach(self.agendaArray, function (agendaElement) {
        if (agendaElement.Compliance == undefined || agendaElement.Compliance == null) {
        }
        else if (agendaElement.Compliance.length > 0) {
          _.forEach(agendaElement.Compliance, function (complianceElement) {
            self.agendaAddedTaskList.push(complianceElement);
          })
        }
      })
    }
  }

  onSelectProcess() {
    var taskData = [];
    this.SelectedTaskOnProcessID = []
    if (this.selectProcessFlag && this.addmeetingForm.controls.Process.value != null) {

      this.meetingService.getSelectedProcessTask(this.addmeetingForm.controls.Process.value).subscribe(tasks => {
        if (tasks.status == 0) {
          for (var i = 0; i < tasks.processTasksDatalist.length; i++) {
            taskData.push(tasks.processTasksDatalist[i].ProcessTasksData);
          }
          this.SelectedTaskOnProcessID = taskData;
        }
      });
    } else {

    }


  }

  getpredefinedTaskList() {
    this.preDefinedTask = [];
    this.agendaService.getpredefinedTask().subscribe(tasklist => {
      if (tasklist.status == 0) {
        this.preDefinedTasknew = tasklist.taskList;
        var removingKeyArr = [];
        if (this.preDefinedTask.length > 0) {
          var newtsk = [];
          newtsk = this.preDefinedTasknew;
          for (var key in this.preDefinedTasknew) {
            for (var key2 in this.preDefinedTask) {
              if (this.preDefinedTasknew[key].TaskName == this.preDefinedTask[key2].TaskName) {
                removingKeyArr = removingKeyArr.concat(key);
                newtsk.splice(parseInt(key), 1);
              }
            }
          }
          this.preDefinedTasknew = newtsk;
        }
      }
    })
  }

  messagePopUpTimeoutToggle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }



  getMembers(ev, onDone?: () => void) {

    this.Directors = [];
    this.Invitees = [];
    this.Members = [];
    var meetingTypeId = ev.target.value;
    var selectedMeetingTypeObject = _.find(this.meetingTypes, function (o) {
      if (o._id == meetingTypeId) {
        return o;
      }
    });

    if (!selectedMeetingTypeObject) {
      if (onDone) onDone();
      return;
    }

    this.selectedType = selectedMeetingTypeObject.MeetingType;



    switch (selectedMeetingTypeObject.MeetingType) {
      case 'Independent Directors':
      case 'Annual General Meeting':
      case 'Extraordinary General Meeting':
      case 'Postal Ballot':
      case 'Others':
      case 'Board': {
        //statements; 
        this.directorTabName = 'Directors';
        this.safeDestroyDataTable('#directorTable');
        this.meetingService.getDirectorOnOtherThenCommitteeMembers()
          .subscribe({
            next: (members) => {

            var directorOBJ = [];
            if (members.status == 0) {
              members.directorList.forEach(element => {
                var userGovevaId = "";
                if (element.GovevaUserId) {
                  userGovevaId = element.GovevaUserId;
                } else if (element.userGovevaId) {
                  userGovevaId = element.userGovevaId;
                } else {
                  userGovevaId = null;
                }
                var data = {
                  DirectorID: element._id,
                  DirectorName: element.FirstName + ' ' + element.MiddleName + ' ' + element.LastName,
                  Designation: element.DirectorProfession.length == 0 ? '' : element.DirectorProfession[0].Designation,
                  IsExecutive: element.DirectorProfession.length == 0 ? 'Non-Executive' : element.DirectorProfession[0].IsExecutive,
                  AppointmentDate: element.DirectorProfession.length == 0 ? '' : element.DirectorProfession[0].AppointmentDate,
                  Chairman: element.DirectorProfession.length == 0 ? 'No' : element.DirectorProfession[0].IsChairman,
                  Category: element.DirectorProfession.length == 0 ? '' : element.DirectorProfession[0].Category,
                  CessationDate: element.DirectorProfession.length == 0 ? '' : element.DirectorProfession[0].CessationDate,
                  Tenure: "",
                  UserGovevaId: userGovevaId,
                  CessationReason: "",
                  EmailID: element.EmailID
                }
                directorOBJ.push(data);
              });


              this.Directors = directorOBJ;
              if (this.restrictTabFlag) {
                setTimeout(() => this.dtTriggerDirector.next(), 0);
              }
            }

          },
            error: () => {},
            complete: () => { if (onDone) onDone(); }
          });

        if (selectedMeetingTypeObject.MeetingType == 'Board') {
          this.loadBoardInviteesFromLastMeeting(meetingTypeId);
        }
        break;
      }
      default: {

        this.directorTabName = 'Members';
        this.SelectedMeetingType = selectedMeetingTypeObject.MeetingType;
        var directorTable = $('#directorTable').DataTable({ destroy: true });
        var inviteeTable = $('#inviteeTable').DataTable({ destroy: true });
        var memberTable = $('#memberTable').DataTable({ destroy: true });
        if (selectedMeetingTypeObject.IsCommitteeType) {

          this.meetingService.getCommitteeMembers(meetingTypeId)
            .subscribe({
              next: (members) => {
              if (members.status == 0) {

                if (members.committeeMembers.length > 0) {
                  if (members.committeeMembers[0].Directors.length > 0) {

                    members.committeeMembers[0].Directors.forEach(element => {
                      element.selectedDirector = false;
                    });
                    this.Directors = members.committeeMembers[0].Directors;
                    this.UpdateDirector = this.Directors;
                    directorTable.destroy();

                    this.dtTriggerDirector.next();
                  }
                  //Get Invitees of committee
                  if (members.committeeMembers[0].Invitees.length > 0) {
                    members.committeeMembers[0].Invitees.forEach(element => {
                      element.selectedInvitee = false;
                    });
                    inviteeTable.destroy();
                    this.Invitees = members.committeeMembers[0].Invitees;
                    this.dtTriggerInvitee.next();
                  }
                  if (members.committeeMembers[0].Members.length > 0) {
                    members.committeeMembers[0].Members.forEach(element => {
                      element.selectedMember = false;
                    });
                    memberTable.destroy();
                    this.Members = members.committeeMembers[0].Members;
                    this.Member = this.Members;
                    this.UpdateMember = this.Members;
                    this.dtTriggerMember.next();
                  }

                  this.resolveMissingMeetingMemberDisplayDetails().then(() => {
                    this.rebuildDirectorsMembersDisplayTab();
                    this.refreshMeetingMemberDataTables();
                  });
                }
                else {

                  directorTable.destroy();
                  inviteeTable.destroy();
                  memberTable.destroy();
                  this.Directors = [];
                  this.Invitees = [];
                  this.Members = [];
                  setTimeout(() => {
                    this.dtTriggerDirector.next();
                    this.dtTriggerInvitee.next();
                    this.dtTriggerMember.next();
                  }, 500);


                }

              }
            },
              error: () => {},
              complete: () => { if (onDone) onDone(); }
            });

        } else {

          directorTable.destroy();
          inviteeTable.destroy();
          memberTable.destroy();
          this.Directors = [];
          this.Invitees = [];
          this.Members = [];
          setTimeout(() => {
            this.dtTriggerDirector.next();
            this.dtTriggerInvitee.next();
            this.dtTriggerMember.next();
          }, 500);
          if (onDone) onDone();

        }
        break;
      }
    }


  }

  userList: any[];
  isHeaderSetted: boolean = false;
  getActivatedTaskList() {

    this.taskService.getUsersList().subscribe(data => {
      if (data.status == 0) {
        this.userList = data.result;


        this.activatedTaskList = [];
        $("#addedtaskTable").DataTable().destroy();

        this.meetingService.getActivatedTaskList(this.g_meetingID).subscribe(data => {
          if (data.status == 0) {

            this.activatedTaskList = data.taskList;

            this.activatedTaskList.forEach(element => {

              for (var i = 0; i < this.userList.length; i++) {
                if (element.AssignedTo == this.userList[i]._id) {
                  element.AssignedName = this.userList[i].FirstName + ' ' + this.userList[i].LastName
                } else {
                  if (element.AssignedName == "" || element.AssignedName == undefined || element.AssignedName == null) {
                    element.AssignedName = ""
                  }

                }

              }
            });

            var self = this;
            setTimeout(() => {
              this.dtTriggerAddingCompliance.next();
              setTimeout(() => {
                $("#addedtaskTable").DataTable().columns.adjust().draw();
                self.isHeaderSetted = true
              }, 100);
            }, 100)
          }
        })
      }

    });

  }


  getTaskStatus(duedate, completeddate, taskStatus) {

    var text = "";
    var dueDate = (duedate != null || duedate != undefined) ? duedate : null;
    var completeddate = (completeddate != null || completeddate != undefined) ? completeddate : null;
    if (dueDate != null && completeddate != null) {
      if (completeddate > dueDate) {
        text = this.getStatusforTask(3);
      }
      else {
        text = this.getStatusforTask(taskStatus);
      }
    }
    else {
      text = this.getStatusforTask(taskStatus);
    }
    return text;
  }

  getStatusforTask(taskStatusId) {

    var taskStatusName = '';
    switch (taskStatusId) {
      case 1:
        taskStatusName = "Pending";
        break;
      case 2:
        taskStatusName = "Completed";
        break;
      case 3:
        taskStatusName = "Delayed Completion";
        break;
      case 4:
        taskStatusName = "Partially Completed";
        break;
      case 5:
        taskStatusName = "NA";
        break;
      case 6:
        taskStatusName = "Done";
        break;
      case 7:
        taskStatusName = "Cancelled";
        break;
      default:
        taskStatusName = "";
    }
    return taskStatusName;
  }


  getProcess(ev, onDone?: () => void) {

    if (ev.target.value != "") {
      var meetingTypeId = ev.target.value;
      this.processArray = [];
      this.meetingService.getProcessByMeetingType(meetingTypeId)
        .subscribe({
          next: (process) => {
          if (process.status == 0) {
            this.processArray = process.processData;
            this.commonFunction.sortByKey(this.processArray, "ProcessName")
          }
          this.addmeetingForm.controls.Process.setValue(null);
          },
          error: () => {},
          complete: () => { if (onDone) onDone(); }
        });
    }
    else {
      if (onDone) onDone();
      return false;
    }
  }

  getAgendaByMeetingType(ev, onDone?: () => void) {
    if (ev.target.value != "") {
      this.enableAgendaStore = false;
      this.enableAddComplianceButton = false;
      this.agendaArray = [];
      this.agendaArray = new Array<any>();
      var meetingTypeID = ev.target.value;

      this.meetingService.getAgendaByMeetingType(meetingTypeID)
        .subscribe({
          next: (agenda) => {
          if (agenda.status == 0) {
            if (this.dtElementForAgenda.dtInstance != undefined) {
              this.dtElementForAgenda.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
              });
            }

            this.agendaArray = _.sortBy(agenda.agendaData, ["Agendaorder"]);

            this.newAgendaArray = this.agendaArray.map(enhanchArr);
            this.newAgendaArray.push(...this.tempArray)

            if( this.agendaArray.length > 0) {
            this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
              return (
                value.AgendaGenerationDocument?.isUpdatedAsPerTemplate === false ||
                value.AgendaMinuteDocument?.isUpdatedAsPerTemplate === false
              );
            });
          }


            if (this.restrictTabFlag) {
              this.dtTriggerAgenda.next();
              this.dtTriggerAgendaNew.next();
              $("#agendaAccessTable").DataTable().destroy();
              this.agendaAccessArray = agenda.agendaData;
              this.dtTriggerAgendaAccess.next();
            }
          }
          },
          error: () => {},
          complete: () => { if (onDone) onDone(); }
        });
    }
    else {
      this.enableAgendaStore = true;
      this.enableAddComplianceButton = true;
      this.agendaArray = [];
      if (onDone) onDone();
      return false;
    }
  }

  private loadBoardInviteesFromLastMeeting(meetingTypeId: string) {
    this.meetingService.getInvitteeFromLastBoardMeeting(meetingTypeId)
      .subscribe({
        next: (data) => {
          if (data.status == 0 && data.result?.length) {
            // Strip subdocument _ids from the previous meeting so new meeting gets fresh ids
            this.Invitees = data.result.map((invitee: any) => {
              const copy = { ...invitee, selectedInvitee: true };
              delete copy._id;
              return copy;
            });
          } else {
            this.Invitees = [];
          }
        },
        error: () => {
          this.Invitees = [];
        }
      });
  }

  /** Sync Angular form state from the jQuery timepicker widget. */
  private syncMeetingTimeFromPicker() {
    try {
      const timeVal = $('.timepicker-init').val();
      if (timeVal) {
        this.addmeetingForm.controls.MeetingTime.setValue(timeVal);
      }
    } catch (_) {
      // ignore if jQuery not ready
    }
  }

  /** Hide datetimepicker popups — they can leave a blocking overlay over the page. */
  private closeDatetimePickers() {
    try {
      $('.timepicker-init').each(function () {
        const $el = $(this);
        const picker = $el.data('DateTimePicker');
        if (picker) {
          picker.hide();
        }
      });
      $('.bootstrap-datetimepicker-widget').remove();
    } catch (_) {
      // ignore if jQuery/bootstrap not ready
    }
  }

  private clearModalBackdrops() {
    try {
      this.closeDatetimePickers();
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      $('body').css('padding-right', '');
    } catch (_) {
      // ignore if jQuery/bootstrap not ready
    }
  }

  /** Clear loaders/backdrops then show success modal above the form (not behind overlay). */
  private presentSaveSuccess(message: string, onOk: () => void) {
    this.isSaving = false;
    this.isMeetingTypeLoading = false;
    this._meetingTypeLoadPending = 0;
    this.disabledOnclick = false;
    this.clearModalBackdrops();
    this.ngZone.run(() => {
      this.cdr.detectChanges();
      setTimeout(() => {
        this.clearModalBackdrops();
        this.alert.successWithOk1(message, onOk);
      }, 100);
    });
  }

  private safeDestroyDataTable(selector: string) {
    try {
      if ($.fn.DataTable.isDataTable(selector)) {
        $(selector).DataTable().destroy();
      }
    } catch (_) {
      // Table may not be initialized yet on first meeting-type change
    }
  }

  membersAndProcess(ev) {

    this.categoryArray = [];
    this.defaultCategoryArray = [];
    this.safeDestroyDataTable('#categoryTable');

    const meetingTypeId = ev.target.value;
    if (!meetingTypeId) {
      this.isMeetingTypeLoading = false;
      this._meetingTypeLoadPending = 0;
      return;
    }

    const selectedMeetingTypeObject = _.find(this.meetingTypes, (o) => o._id === meetingTypeId);
    if (selectedMeetingTypeObject) {
      this.MeetingTypeName = selectedMeetingTypeObject.MeetingType;
      this.selectedType = selectedMeetingTypeObject.MeetingType;
    }

    // Board invitees load in background — do not block the meeting-type loader on that call
    let pendingLoads = this.restrictTabFlag ? 5 : 4;
    this._meetingTypeLoadPending = pendingLoads;
    this.isMeetingTypeLoading = pendingLoads > 0;
    const onMeetingTypeLoadDone = () => {
      this._meetingTypeLoadPending--;
      if (this._meetingTypeLoadPending <= 0) {
        this._meetingTypeLoadPending = 0;
        this.isMeetingTypeLoading = false;
      }
    };

    this.getProcess(ev, onMeetingTypeLoadDone);
    if (this.restrictTabFlag) {
      this.getAgendaByMeetingType(ev, onMeetingTypeLoadDone);
    } else {
      this.agendaArray = [];
      this.newAgendaArray = [];
      onMeetingTypeLoadDone();
    }
    this.getMembers(ev, onMeetingTypeLoadDone);
    this.toGetCategory(ev, onMeetingTypeLoadDone);
    this.meetingIdForMeetingNumber = meetingTypeId;

    // In the case of Board and all committee meetings the due date should be automatically auto populated as date of meeting - 7 days
    // for all meeting types. For AGM / EGM it should be 21 days prior. For postal ballot no date to be autopopulated
    this.setDateOfSigning();
    this.setDefaultMeetingMasterData(ev.target.value, onMeetingTypeLoadDone);
  }

  private setDefaultMeetingMasterData(meetingId: any, onDone?: () => void) {
    if (meetingId != undefined && meetingId != "") {
      this.defaultmeetingService.getDefaultMeetingDataByMeetingIdNCompanyId(meetingId)
        .subscribe({
          next: (getData) => {
          if (getData.status == 0 && getData.defaultMeetingData != null) {
            //let dt;
            var DefaultMeetingData = getData.defaultMeetingData[0];
            this.addmeetingForm.controls.MeetingPlace.setValue(DefaultMeetingData.MeetingPlace);
            this.addmeetingForm.controls.NoticeSignatoryName.setValue(DefaultMeetingData.NoticeSignatoryName);
            this.addmeetingForm.controls.ContactNumber.setValue(DefaultMeetingData.ContactNumber);
            this.addmeetingForm.controls.EmailID.setValue(DefaultMeetingData.EmailID);
            this.addmeetingForm.controls.NoticeSignatoryDesignation.setValue(DefaultMeetingData.NoticeSignatoryDesignation);
            this.addmeetingForm.controls.DinNumber.setValue(DefaultMeetingData.DinNumber);
            // if (DefaultMeetingData.SigningNoticeDate != null) {
            //   dt = new Date(this.setFormatDate(DefaultMeetingData.SigningNoticeDate));
            //   this.SigningNoticeDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            // }
            this.addmeetingForm.controls.SigningNoticePlace.setValue(DefaultMeetingData.SigningNoticePlace);
          } else {
            this.addmeetingForm.controls.MeetingPlace.setValue(this.companyAddress);
            this.addmeetingForm.controls.NoticeSignatoryName.setValue("");
            this.addmeetingForm.controls.ContactNumber.setValue("");
            this.addmeetingForm.controls.EmailID.setValue("");
            this.addmeetingForm.controls.NoticeSignatoryDesignation.setValue("");
            this.addmeetingForm.controls.DinNumber.setValue("");
            // this.addmeetingForm.controls.SigningNoticeDate.setValue(null);
            this.addmeetingForm.controls.SigningNoticePlace.setValue("");
          }
          },
          error: () => {},
          complete: () => { if (onDone) onDone(); }
        });
    } else {
      this.addmeetingForm.controls.MeetingPlace.setValue(this.companyAddress);
      this.addmeetingForm.controls.NoticeSignatoryName.setValue("");
      this.addmeetingForm.controls.ContactNumber.setValue("");
      this.addmeetingForm.controls.EmailID.setValue("");
      this.addmeetingForm.controls.NoticeSignatoryDesignation.setValue("");
      this.addmeetingForm.controls.DinNumber.setValue("");
      // this.addmeetingForm.controls.SigningNoticeDate.setValue(null);
      this.addmeetingForm.controls.SigningNoticePlace.setValue("");
      if (onDone) onDone();
    }
  }

  onlyNumber(ev) {

    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 11) {
        ev.preventDefault();
      }

    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getSelectedTaskList(taskList) {
    var Arr = [];
    var newArr = [];
    Arr = taskList.split(',');
    if (taskList != "") {
      for (var i = 0; i < Arr.length; i++) {
        var element = Arr[i];
        newArr = newArr.concat({ TaskName: element });
      }
      this.preDefinedTask = newArr;
    }
  }

  refreshDirectorsTableWithData(DirectorsData, InviteesData, MembersData) {
    var directorTable = $('#directorTable').DataTable({ destroy: true });
    var inviteeTable = $('#inviteeTable').DataTable({ destroy: true });
    var memberTable = $('#memberTable').DataTable({ destroy: true });

    directorTable.destroy();
    memberTable.destroy();

    this.Directors = DirectorsData;

    inviteeTable.destroy();
    this.dtTriggerDirector.next();
    this.Invitees = InviteesData;
    this.dtTriggerInvitee.next();
    this.Members = MembersData;
    this.dtTriggerMember.next();

  }

  DinNumber(ev) {

    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 8 digits
      if ((ev.target.value + ev.key).length > 8) {
        ev.preventDefault();
      }

    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  //delete this
  check(event) {
    this.addmeetingForm.controls.MeetingTime.setValue($('.timepicker-init').val());
    this.meetingTimeForAutoMeetingNo = $('.timepicker-init').val();
    this.toGetMeetingNumber(this.meetingIdForMeetingNumber, this.meetingDateChangeFormatForTime, this.meetingTimeForAutoMeetingNo);
  }

  meetingTimeSelect(ev) {
    if (ev.target.value != "") {
      this.IsMeetingTimeSelected = false;
    }
  }

  onChangeProcess() {
    this.SelectedTaskOnProcessID = []
    if (this.selectProcessFlag == true) {
      this.selectProcessFlag = false;
      this.addmeetingForm.controls.Process.reset()
      this.addmeetingForm.controls.Process.clearValidators();
      this.addmeetingForm.controls.Process.updateValueAndValidity();
      this.SelectedTaskOnProcessID = [];
    } else {
      this.selectProcessFlag = true;
      this.addmeetingForm.controls.Process.setValidators([Validators.required]);
      this.addmeetingForm.controls.Process.updateValueAndValidity();
      this.SelectedTaskOnProcessID = [];
    }

  }

  onChangeCategory() {
    if (this.selectCategoryFlag == true) {
      this.selectCategoryFlag = false;
      this.addmeetingForm.controls.Category.reset()
      this.addmeetingForm.controls.Category.clearValidators();
      this.addmeetingForm.controls.Category.updateValueAndValidity();
    } else {
      this.selectCategoryFlag = true;
      this.addmeetingForm.controls.Category.setValidators([Validators.required]);
      this.addmeetingForm.controls.Category.updateValueAndValidity();
    }
  }

  toGetCategory(ev, onDone?: () => void) {
    this.categoryArray = [];
    this.defaultCategoryArray = [];
    this.safeDestroyDataTable('#categoryTable');
    if (ev.target.value != "") {
      var meetingTypeId = ev.target.value;
      this.meetingService.getCategoryByMeetingType(meetingTypeId)
        .subscribe({
          next: (category) => {
          if (category.status == 0) {
            this.categoryArray = category.categoryList;
            this.categoryArray.forEach(element => {
              element.IsSelectedCategory = false;
              if (element.isDefault === true) {
                this.defaultCategoryArray.push({
                  _id: element._id,
                  CategoryName: element.CategoryName
                });
              }
            });
          }
          this.commonFunction.sortByKey(this.categoryArray, "CategoryName");
          if (this.restrictTabFlag) {
            this.dtTriggerOfCategory.next();
          }
          this.addmeetingForm.controls.Category.setValue(null);
          },
          error: () => {},
          complete: () => { if (onDone) onDone(); }
        });
    }
    else {
      if (onDone) onDone();
      return false;
    }
  }

  checkselectedCategory(ev, category) {
    if (this.g_meetingID && ev.target.checked == false) {
      this.categoryCheackEvent = ev;
      this.categoryDataOnEvent = category;
      $("#categoryRemovingConfirmation").modal("toggle");
      $('#categoryMessage').html('Do you want to remove all agenda related to this category from meeting?');
      $('#addAgenda').hide();
      $('#removeAgenda').show();
    } else if (this.g_meetingID) {
      this.categoryCheackEvent = ev;
      this.categoryDataOnEvent = category;
      $("#categoryRemovingConfirmation").modal("toggle");
      $('#categoryMessage').html('Do you want to add all agenda related to this category in meeting?');
      $('#addAgenda').show();
      $('#removeAgenda').hide();
    }

  }

  toGetCategoryOnUpdate(meetingTypeId, categoriesSelected) {

    this.categoryArray = [];
    $("#categoryTable").DataTable().destroy()

    this.meetingService.getCategoryByMeetingType(meetingTypeId)
      .subscribe(category => {
        if (category.status == 0) {
          this.categoryArray = category.categoryList;
          this.categoryArray.forEach(element => {
            var doselect = false;

            for (var i = 0; i < categoriesSelected.length; i++) {

              if (element._id == categoriesSelected[i].categoryID) {
                doselect = true;
              }
            }
            if (doselect == true) {
              element.IsSelectedCategory = true;
            }
          });
        }

        this.commonFunction.sortByKey(this.categoryArray, "CategoryName");
        this.dtTriggerOfCategory.next();
      });
  }


  //  db.getCollection('Agenda').find({"libaryType" : "Non-Library", "agendaType" : "Open"})
  //Get Agenda list having Same type as of Category Type selected

  getAgendaLibraryList() {

    //on click of button to show popup form..
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#agendaStoreDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#agendaStoreDialog').modal('show');
    }, 100);
    this.agendaData = [];
    var actualdDataToShow = [];
    var categoryIDArray = this.categoryArray.map(function (data) {
      return data._id
    })
    var agendaStoreTable = $("#agendaStoreTable").DataTable({ destroy: true });
    agendaStoreTable.destroy();
    if (this.PSSMasterMeetingTypeID != undefined) {
      this.agendaService.getAgendaLibraryForPredefinedCommittee(this.categoryArray, this.g_meetingTypeID)
        .subscribe(agenda => {
          if (agenda.status == 0) {

            this.agendaData = this.agendaData.concat(agenda.agendaList);

            for (var i = 0; i < this.agendaData.length; i++) {
              var found = false;
              for (var j = 0; j < this.agendaArray.length; j++) {
                if (this.agendaData[i]._id == this.agendaArray[j]._id) {
                  found = true;
                }
              }
              if (this.agendaData.length > 0 && !found) {
                actualdDataToShow.push(this.agendaData[i]);
              }
            }
            this.agendaData = [];
            this.agendaData = actualdDataToShow;
            this.dtTriggerAgendaStore.next();
          }

          setTimeout(() => {
            $("#agendaStoreTable").DataTable().columns.adjust().draw();
          }, 200);

        });
    } else {

      this.agendaService.getAgendaLibrary(this.categoryArray, this.g_meetingTypeID)
        .subscribe(agenda => {
          if (agenda.status == 0) {

            this.agendaData = this.agendaData.concat(agenda.agendaList);

            for (var i = 0; i < this.agendaData.length; i++) {
              var found = false;
              for (var j = 0; j < this.agendaArray.length; j++) {
                if (this.agendaData[i]._id == this.agendaArray[j]._id) {
                  found = true;
                }
              }
              if (this.agendaData.length > 0 && !found) {
                actualdDataToShow.push(this.agendaData[i]);
              }
            }
            this.agendaData = [];
            this.agendaData = actualdDataToShow;
            this.dtTriggerAgendaStore.next();
          }

          setTimeout(() => {
            $("#agendaStoreTable").DataTable().columns.adjust().draw();
          }, 200);

        });
    }

  }

  //  db.getCollection('Agenda').find({"libaryType" : "Non-Library", "agendaType" : "Open"})
  //Get Agenda list having Same meeting Type type as of
  getOpenAgendaAgendaList() {
    this.agendaData = [];
    var actualdDataToShow = [];
    var categoryIDArray = this.categoryArray.map(function (data) {
      return data._id
    })
    var agendaStoreTable = $("#agendaStoreTable").DataTable({ destroy: true });
    agendaStoreTable.destroy();
    this.agendaService.getAgendaOpenLibrary(this.g_meetingTypeID)
      .subscribe(agenda => {
        if (agenda.status == 0) {

          this.agendaData = this.agendaData.concat(agenda.agendaList);

          for (var i = 0; i < this.agendaData.length; i++) {
            var found = false;
            for (var j = 0; j < this.agendaArray.length; j++) {
              if (this.agendaData[i]._id == this.agendaArray[j]._id) {
                found = true;
              }
            }
            if (this.agendaData.length > 0 && !found) {
              actualdDataToShow.push(this.agendaData[i]);
            }
          }
          this.agendaData = [];
          this.agendaData = actualdDataToShow;
          this.dtTriggerAgendaStore.next();
        }

        setTimeout(() => {
          $("#agendaStoreTable").DataTable().columns.adjust().draw();
        }, 200);

      });
  }

  checkAllAgendaStore(event) {

    if (event.target.checked == true) {
      for (var i = 0; i < this.agendaData.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataAgendaStore.length; j++) {
          if (this.searcheFilteredDataAgendaStore[j] == this.agendaData[i]._id) {
            this.selectedAllAgendaStore = true;
            this.IsSelectedAgenda = true;
            this.agendaData[i].selectAgenda = true;
          }
        }
      }
    } else {
      this.IsSelectedAgenda = false;
      this.agendaData.forEach(element => {
        element.selectAgenda = false;
      });
    }
  }

  checkAllAgenda() {
    for (var i = 0; i < this.agendaArray.length; i++) {
      this.agendaArray[i].selectAgenda = this.selectedAllAgenda;
      this.IsSelectedAgenda = this.selectedAllAgenda;
    }
  }

  agendaFromStoreSelected(ev) {
    this.selectedAllAgendaStore = false;
    this.IsSelectedAgenda = false;
    let allFlag = true;
    // if (ev.target.checked == true) {
    //   this.IsSelectedAgenda = true;
    // }
    // else {
    //   this.IsSelectedAgenda = false;
    // }

    var allSearchedSelectedCategory = true;
    if (_.size(this.agendaData)) {
      for (var i = 0; i < this.agendaData.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataAgendaStore.length; j++) {
          if (this.searcheFilteredDataAgendaStore[j] == this.agendaData[i]._id) {
            if (this.agendaData[i].selectAgenda) {
              this.IsSelectedAgenda = true
            } else {
              allSearchedSelectedCategory = false;
            }
          }
        }
      }
    }

    if (allSearchedSelectedCategory) {

      this.selectedAllAgendaStore = true;
    } else {
      this.selectedAllAgendaStore = false;
    }
  }

  agendaSelected(ev) {
    if (ev.target.checked == true) {
      this.IsSelectedAgenda = true;
    }
    else {
      this.IsSelectedAgenda = false;
    }
  }


  checkAllDirector() {
    for (var i = 0; i < this.Directors.length; i++) {
      this.Directors[i].selectedDirector = this.selectedAllDirector;
      //this.IsSelectedAgenda = this.selectedAllAgendaStore;
    }
  }

  checkIfAllAgendaItemsSelected() {
    this.selectedAllAgenda = this.agendaArray.every(function (item: any) {
      return item.selectAgenda == true;
    })
  }

  checkIfAllDirectorsSelected() {
    this.selectedAllDirector = this.Directors.every(function (item: any) {
      return item.selectedDirector == true;
    })
  }

  checkAllInvitee() {
    for (var i = 0; i < this.Invitees.length; i++) {
      this.Invitees[i].selectedInvitee = this.selectedAllInvitee;
    }
  }

  checkIfAllInviteeSelected(_id) {
    this.selectedAllInvitee = this.Invitees.every(function (item: any) {
      return item.selectedInvitee == true;
    });
  }

  updateSelectedInvitees(Invitees) {
    this.disabledOnclick = true;
    var inviteeData = []
    var self = this;
    var meetingType = _.find(self.meetingTypes, function (element) { return element._id == self.addmeetingForm.controls['MeetingType'].value })

    Invitees.forEach(element => {
      if (!element.Selected) {
        inviteeData.push(element)
      }
    });
    this.taskService.sendMeetingTypeAndInvitee(meetingType, Invitees).subscribe(responseFromCISCO => {
      this.disabledOnclick = false;
    })


    this.meetingService.deSelectInvittee(this.g_meetingID, Invitees).subscribe(data => {
      this.disabledOnclick = false;
      if (data.status == 0) {
        this.alert.success('Selected Invitee updated successfully.');
        this.Invitees = []
        $("#inviteeTable").DataTable().destroy();
        this.Invitees = data.MeetingData[0].Invitees;
        this.loadMeetingDetails(this.g_meetingID);
        this.dtTriggerInvitee.next()
      }
    })

  }

  getAttendance() {

  }

  checkAllMember() {
    for (var i = 0; i < this.Members.length; i++) {
      this.Members[i].selectedMember = this.selectedAllMember;
    }
  }

  checkIfAllMemberSelected() {
    this.selectedAllMember = this.Members.every(function (item: any) {
      return item.selectedMember == true;
    })
  }

  getMeetingIdFromLocalStorage() {
    var newMeetingID = "";
    if (localStorage.getItem("MeetingID") != undefined) {
      newMeetingID = localStorage.getItem("MeetingID");
    }
    else if (localStorage.getItem("updateMeetingID") != undefined) {
      newMeetingID = localStorage.getItem("updateMeetingID");
    }
    if (newMeetingID == "") {
      this.alert.error("Please first insert meeting details.");
      return false;
    }
    return newMeetingID;
  }

  addAgendaFromAgenaStore() {
    this.disabledOnclick = true;
    var addedtaskTable = $('#addedtaskTable').DataTable({ destroy: true });

    addedtaskTable.destroy();
    ////inside popup form dialog
    $('#agendaStoreDialog').off('hidden.bs.modal');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#agendaStoreDialog').modal('hide');

    var agendaToAdd: any = [];
    for (var i = 0; i < this.agendaData.length; i++) {
      if (this.agendaData[i].selectAgenda == true) {
        if (this.agendaData[i].from == 'OpenAgenda') {
          this.agendaData[i].meetingId = this.g_meetingID;
        } else {
          this.agendaData[i].meetingId = null;
        }

        agendaToAdd.push(this.agendaData[i]);
        this.agendaArray.push(this.agendaData[i]);

      }
    }

    this.meetingService.addAgendaInMeeting(this.g_meetingID, agendaToAdd)
      .subscribe(response => {
        this.disabledOnclick = false;

        if (response.status == 0) {
          this.getAgendaList();
          this.getAgendaAccessRights()
          this.getAgendaGenerationData();
          setTimeout(() => {
            this.getActivatedTaskList()
          }, 1000)
          this.alert.success("Agenda added successfully.");
        }
      },
        error => { console.log("error", error) });
  }

  toggleImportInternalSearchDiv() {
    this.isImportAgendaSearchDivVisible = !this.isImportAgendaSearchDivVisible;
  }

  meetingDateSearchMeetingImport() {
    this.minDateForSearchToImport = this.meetingsSearchDateFromImport;
  }

  setDateImport(date) {
    if (date != '' && date != null) {
      return date.year + '-' + date.month + '-' + date.day;
    }
    return null;
  }

  initImportAgendaModalDtOptions() {
    if (this.importAgendaDtOptionsInitialized) {
      return;
    }
    this.importAgendaDtOptionsInitialized = true;
    this.dtOptionsImportAgendaModal = {
      processing: true,
      destroy: true,
      scrollY: '360px',
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: false,
      serverSide: false,
      stateDuration: -1,
      search: { smart: true, caseInsensitive: true },
      language: {
        searchPlaceholder: 'Search Agenda Title...',
        processing: '',
        loadingRecords: '',
        emptyTable: 'No agendas to display'
      },
      order: [[2, 'asc']],
      columnDefs: [{ orderable: false, targets: [0] }],
      columns: [
        { searchable: false },
        { searchable: false },
        { searchable: false },
        { searchable: true },
        { searchable: false },
        { searchable: false },
        { searchable: false }
      ],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
      dom: 'lBfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Agenda Import List',
          title: 'Agenda Import List',
          extend: 'excel',
          exportOptions: {
            columns: [1, 2, 3, 4, 5, 6],
            format: {
              body: function (data, row, column, node) {
                if (data.includes('+') || data.includes('@') || data.includes('=') || data.includes('|') || data.includes('!')) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data; } else { return '\'' + data + '\''; }
                } else { return data }
              }
            }
          },
        }
      ]
    };
  }

  private importAgendaRowKey(title: string, agendaNum: any): string {
    var t = ((title ?? '') + '').trim().toLowerCase();
    var n = agendaNum != null && agendaNum !== '' ? String(agendaNum).trim() : '';
    return t + '|' + n;
  }

  private getImportExcludedKeysFromTargetMeeting(): Set<string> {
    var keys = new Set<string>();
    var arr = this.agendaArray || [];
    for (var i = 0; i < arr.length; i++) {
      var a = arr[i];
      var rawTitle = ((a?.AgendaTitle ?? '') + '').trim();
      if (!rawTitle) continue;
      keys.add(this.importAgendaRowKey(a?.AgendaTitle, a?.AgendaNumber));
    }
    return keys;
  }

  private excludeCandidateRowsMatchingTargetMeeting(rowList: any[]): any[] {
    var existingKeys = this.getImportExcludedKeysFromTargetMeeting();
    var self = this;
    return rowList.filter(function (row: any) {
      var title = ((row?.AgendaTitle ?? '') + '').trim();
      if (!title) return true;
      var key = self.importAgendaRowKey(row?.AgendaTitle, row?.AgendaNumber);
      return !existingKeys.has(key);
    });
  }

  private applyImportListFiltersMeetingAndType(rows: any[], targetMeetingId: string, restrictMeetingTypeId: any): any[] {
    var tid = targetMeetingId != null ? String(targetMeetingId) : '';
    var data = rows.filter(function (a: any) {
      return a && a.meetingID != null && String(a.meetingID) !== tid;
    });
    if (restrictMeetingTypeId != null && restrictMeetingTypeId !== '') {
      data = data.filter(function (a: any) {
        return a.MeetingTypeID == restrictMeetingTypeId || String(a.MeetingTypeID) === String(restrictMeetingTypeId);
      });
    }
    return this.excludeCandidateRowsMatchingTargetMeeting(data);
  }

  /**
   * Only send sourceMeetingId when every selected agenda row belongs to one meeting.
   * If any selected row lacks meetingID or sources differ (or any row missing), omit it so the backend clones all ids.
   */
  private resolveOptionalSourceMeetingIdForClone(ids: string[]): string | undefined {
    var only: string | null = null;
    for (var i = 0; i < ids.length; i++) {
      var row = this.importAgendaSearchRows.find((a: any) => a && a._id === ids[i]);
      if (!row || row.meetingID == null || row.meetingID === '') {
        return undefined;
      }
      var mid = String(row.meetingID);
      if (only == null) only = mid;
      else if (only !== mid) return undefined;
    }
    return only != null ? only : undefined;
  }

  private afterImportAgendaTableDataReady(openModalWhenDone?: boolean) {
    var self = this;
    if (openModalWhenDone) {
      $('#importAgendasInternalDialog').modal('show');
    }
    var delayMs = openModalWhenDone ? 120 : 0;
    setTimeout(function () {
      self.dtTriggerImportAgenda.next();
      setTimeout(function () {
        if ($.fn.DataTable.isDataTable('#importAgendaSearchTable')) {
          var api = $('#importAgendaSearchTable').DataTable();
          api.columns.adjust().draw(false);
          var $wrap = $('#importAgendasInternalDialog .dataTables_scrollBody');
          if ($wrap.length) {
            $wrap.scrollTop(0);
          }
        }
        self.responseImport = false;
      }, 120);
    }, delayMs);
  }

  loadMeetingTypesForImport() {
    this.meetingService.getMeetingTypeList()
      .subscribe((meetingTypeList: any) => {
        if (meetingTypeList.status == 0) {
          this.meetingTypeImport = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');
        }
      });
  }

  openImportAgendasInternalPopup() {
    var meetingId = this.g_meetingID || this.getMeetingIdFromLocalStorage();
    if (!meetingId) {
      this.alert.error('Open a saved meeting before importing agendas.');
      return;
    }
    if ($.fn.DataTable.isDataTable('#importAgendaSearchTable')) {
      $('#importAgendaSearchTable').DataTable().destroy();
    }
    this.importAgendaTableReady = false;
    this.dtTriggerImportAgenda = new Subject<any>();
    this.cdr.detectChanges();
    this.initImportAgendaModalDtOptions();
    $('#importAgendasInternalDialog').off('shown.bs.modal.importAgenda').on('shown.bs.modal.importAgenda', function () {
      setTimeout(function () {
        if ($.fn.DataTable.isDataTable('#importAgendaSearchTable')) {
          $('#importAgendaSearchTable').DataTable().columns.adjust().draw(false);
        }
      }, 50);
    });
    this.importAgendaSelected = {};
    this.isImportAgendaSearchDivVisible = true;
    this.selectedMeetingImport = this.g_meetingTypeID != null && this.g_meetingTypeID !== '' ? this.g_meetingTypeID : null;
    this.meetingsSearchDateFromImport = null;
    this.meetingsSearchDateToImport = null;
    this.loadMeetingTypesForImport();
    this.loadImportAgendaListInitial(true);
  }

  loadImportAgendaListInitial(openModalWhenDone?: boolean) {
    var self = this;
    var meetingIdFilter = self.g_meetingID || self.getMeetingIdFromLocalStorage();
    self.importAgendaTableReady = false;
    self.cdr.detectChanges();
    this.responseImport = true;
    this.importAgendaSearchRows = [];
    if ($.fn.DataTable.isDataTable('#importAgendaSearchTable')) {
      $('#importAgendaSearchTable').DataTable().destroy();
    }
    var companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
    var companyId = companyDetails.companyID;
    this.meetingService.getMeetingAgendaList(companyId)
      .subscribe(
        (meetingList: any) => {
          if (meetingList.status == 0) {
            let data = meetingList.data || [];
            data = self.applyImportListFiltersMeetingAndType(data, meetingIdFilter, self.selectedMeetingImport);
            this.importAgendaSearchRows = data;
            self.dtTriggerImportAgenda = new Subject<any>();
            self.importAgendaTableReady = true;
            self.cdr.detectChanges();
            this.afterImportAgendaTableDataReady(openModalWhenDone);
          } else {
            this.importAgendaSearchRows = [];
            this.importAgendaTableReady = false;
            this.responseImport = false;
            if (openModalWhenDone) {
              $('#importAgendasInternalDialog').modal('show');
            }
          }
        },
        () => {
          this.importAgendaTableReady = false;
          this.responseImport = false;
          this.alert.error('Could not load agenda list.');
        }
      );
  }

  clearImportInternalSearchResult() {
    this.importAgendaSearchRows = [];
    this.responseImport = true;
    this.selectedMeetingImport = null;
    this.meetingsSearchDateFromImport = null;
    this.meetingsSearchDateToImport = null;
    if ($.fn.DataTable.isDataTable('#importAgendaSearchTable')) {
      $('#importAgendaSearchTable').DataTable().destroy();
    }
    this.importAgendaTableReady = false;
    this.dtTriggerImportAgenda = new Subject<any>();
    this.cdr.detectChanges();
    this.loadImportAgendaListInitial(false);
  }

  advImportInternalFilterSearch() {
    var self = this;
    var meetingIdFilter = self.g_meetingID || self.getMeetingIdFromLocalStorage();
    self.importAgendaTableReady = false;
    self.dtTriggerImportAgenda = new Subject<any>();
    self.cdr.detectChanges();
    this.importAgendaSearchRows = [];
    this.responseImport = true;
    var paramData = {
      'MeetingTypeID': this.selectedMeetingImport,
      '_id': null,
      'meetingFrom': this.setDateImport(this.meetingsSearchDateFromImport),
      'meetingTo': this.setDateImport(this.meetingsSearchDateToImport),
    };
    if ($.fn.DataTable.isDataTable('#importAgendaSearchTable')) {
      $('#importAgendaSearchTable').DataTable().destroy();
    }
    var companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
    var companyId = companyDetails.companyID;
    this.meetingService.getMeetingAgendaList(companyId)
      .subscribe(
        (meetingList: any) => {
          if (meetingList.status == 0) {
            let rows = meetingList.data || [];
            rows = rows.filter(function (a: any) {
              return a && a.meetingID != null && String(a.meetingID) !== String(meetingIdFilter);
            });
            var noMeetingType = paramData.MeetingTypeID == null || paramData.MeetingTypeID === '';
            var noDateRange = paramData.meetingFrom == null || paramData.meetingTo == null;
            let filterData: any[];
            if (noMeetingType && noDateRange) {
              filterData = rows;
            } else {
              filterData = rows.filter(function (currentElement: any) {
                let meetingDate = moment(currentElement.MeetingDate).utc().format('YYYY-M-D')
                let sameMT = paramData.MeetingTypeID == null ? false
                  : currentElement.MeetingTypeID == paramData.MeetingTypeID
                  || String(currentElement.MeetingTypeID) === String(paramData.MeetingTypeID);
                if (paramData.MeetingTypeID != null && paramData.meetingFrom == null && paramData.meetingTo == null) {
                  return sameMT;
                }
                if (paramData.MeetingTypeID == null && paramData.meetingFrom != null && paramData.meetingTo != null) {
                  return meetingDate >= paramData.meetingFrom && meetingDate <= paramData.meetingTo;
                }
                if (paramData.MeetingTypeID != null && paramData.meetingFrom != null && paramData.meetingTo != null) {
                  return sameMT && meetingDate >= paramData.meetingFrom && meetingDate <= paramData.meetingTo;
                }
                return false;
              });
            }
            filterData = self.excludeCandidateRowsMatchingTargetMeeting(filterData);
            this.importAgendaSearchRows = filterData;
            self.dtTriggerImportAgenda = new Subject<any>();
            self.importAgendaTableReady = true;
            self.cdr.detectChanges();
            this.afterImportAgendaTableDataReady(false);
          } else {
            this.importAgendaSearchRows = [];
            this.importAgendaTableReady = false;
            this.responseImport = false;
          }
        },
        () => {
          this.importAgendaTableReady = false;
          this.responseImport = false;
          this.alert.error('Could not load agenda list.');
        }
      );
  }

  onImportInternalCheckboxChange(agendaId: string, checked: boolean) {
    if (checked) {
      this.importAgendaSelected[agendaId] = true;
    } else {
      delete this.importAgendaSelected[agendaId];
    }
  }

  importInternalSelectedCount(): number {
    return Object.keys(this.importAgendaSelected).filter(k => this.importAgendaSelected[k]).length;
  }

  closeImportAgendasInternalPopup() {
    $('#importAgendasInternalDialog').off('shown.bs.modal.importAgenda');
    $('#importAgendasInternalDialog').modal('hide');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    if ($.fn.DataTable.isDataTable('#importAgendaSearchTable')) {
      $('#importAgendaSearchTable').DataTable().destroy();
    }
    this.importAgendaTableReady = false;
    this.dtTriggerImportAgenda = new Subject<any>();
    this.cdr.detectChanges();
  }

  private notifyAfterClosingImportPopup(isSuccess: boolean, message: string, afterAlert?: () => void) {
    var $dialog = $('#importAgendasInternalDialog');
    var wasOpen = $dialog.hasClass('show') || $dialog.hasClass('in');
    if (wasOpen) {
      this.closeImportAgendasInternalPopup();
    }
    var self = this;
    setTimeout(function () {
      if (isSuccess) {
        self.alert.success(message);
      } else {
        self.alert.error(message);
      }
      if (afterAlert) {
        afterAlert();
      }
    }, wasOpen ? 350 : 0);
  }

  confirmImportInternalAgendas() {
    var n = this.importInternalSelectedCount();
    if (n === 0 || this.importInternalSubmitting) {
      return;
    }
    var targetId = this.g_meetingID || this.getMeetingIdFromLocalStorage();
    if (!targetId) {
      this.alert.error('Missing target meeting.');
      return;
    }
    var ids = Object.keys(this.importAgendaSelected).filter(k => this.importAgendaSelected[k]);
    var payload: { sourceAgendaIds: string[]; sourceMeetingId?: string } = { sourceAgendaIds: ids };
    var resolvedSource = this.resolveOptionalSourceMeetingIdForClone(ids);
    if (resolvedSource) payload.sourceMeetingId = resolvedSource;
    this.importInternalSubmitting = true;
    this.meetingService.cloneAgendasToMeeting(targetId, payload).subscribe(
      (resp: any) => {
        this.importInternalSubmitting = false;
        if (resp && resp.status == 0) {
          var cloned = resp.clonedCount != null ? resp.clonedCount : n;
          var skippedCnt = resp.skippedCount != null ? resp.skippedCount : 0;
          var msgSuccess = cloned > 0
            ? 'Imported ' + cloned + ' agenda(s).'
            : (resp.message || 'No agendas were imported.');
          if (skippedCnt > 0 && cloned > 0) {
            msgSuccess += ' ' + skippedCnt + ' skipped.';
          } else if (skippedCnt > 0 && cloned === 0) {
            msgSuccess = resp.message ? resp.message : ('Nothing imported; ' + skippedCnt + ' item(s) skipped.');
          }
          this.notifyAfterClosingImportPopup(true, msgSuccess, () => {
            this.getAgendaList();
            this.getAgendaAccessRights();
            this.getAgendaGenerationData();
            setTimeout(() => {
              this.getActivatedTaskList();
            }, 1000);
          });
        } else {
          var errMsg = (resp && (resp.message || resp.Message)) ? (resp.message || resp.Message) : 'Could not import agendas.';
          this.notifyAfterClosingImportPopup(false, errMsg);
        }
      },
      (err: any) => {
        this.importInternalSubmitting = false;
        var errMsg = (err && err.error && (err.error.message || err.error.Message))
          ? (err.error.message || err.error.Message)
          : 'Could not import agendas.';
        this.notifyAfterClosingImportPopup(false, errMsg);
        console.log('cloneAgendasToMeeting error', err);
      }
    );
  }

  downloadImportInternalFile(downloadingFileID) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/' + downloadingFileID + '/' + token;
  }

  downloadImportAgendaDocs(meetingID, agendaId, type) {
    this.meetingService.generateKeyBeforDownloadingDocument(meetingID, agendaId, type);
  }

  openPdfImportInternal(docId, meetingId, docName, filetype) {
    let file = docName;
    var fileTypechk = (file).substr(-3)
    if (fileTypechk != 'pdf') {
      this.alert.error('Only PDF can be viewed');
    }
    else {
      var token = localStorage.getItem('token')
      this.meetingService.getAttendanceFileName(docId).then(response => {
        var url = environment.PSSFileNotValidurl + '/' + 'documentManagement/getFileById' + '/' + docId + '/' + token;
        window.open(url, '_blank');
      })
    }
  }

  sycnAgendaFileandAgendaFileArrayAndOpenDownloadModalImport(meetingId) {
    var meeting = this.importAgendaSearchRows.find(m => { return m.meetingID == meetingId });
    if (!meeting || !meeting.Documents) { return; }
    var agendaFile = { ...(meeting.Documents.agendaFile || {}) };
    var agendaFileArray = [...(meeting.Documents.agendaFileArray || [])];
    var agendaFile_docId = null;
    if (agendaFile && agendaFile.docId) {
      agendaFile_docId = agendaFile.docId;
      if (agendaFileArray.filter(af => { return af.docId == agendaFile_docId }).length == 0) {
        agendaFileArray.push(agendaFile);
      }
    }
    this.loadedAgendaFilesImport.loadedAgendaFilesArray = [...agendaFileArray];
    this.loadedAgendaFilesImport.meetingId = meetingId;
    $('#importAgendaFilesDialogInternal').modal('toggle');
  }

  downloadImportInternalDoc(data) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/' + data + '/' + token;
  }

  getAgendaList() {
    this.agendaArray = [];
    $("#agendaTable").DataTable().destroy()

    this.transferToGemArray = [];
    var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
    transferToGemTable.destroy();

    this.meetingService.getAgendaByMeeting(this.g_meetingID)
      .subscribe(agenda => {
        if (agenda.status == 0) {
          this.agendaArray = _.sortBy(agenda.Agenda, ["Agendaorder"]);
          this.newAgendaArray = this.agendaArray.map(enhanchArr);
          this.newAgendaArray.push(...this.tempArray)
          this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
            return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
          });
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
          this.dtTriggerAgenda.next();
          this.dtTriggerAgendaNew.next()
          this.transferToGemArray = agenda.Agenda;
          for (var index = 0; index < this.transferToGemArray.length; index++) {
            this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
          }
          this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
          this.dtTriggerOfTransferToGem.next();
          $("#agendaAccessTable").DataTable().destroy();
          this.agendaAccessArray = agenda.Agenda;
          this.dtTriggerAgendaAccess.next();
        }
      });
  }

  addDirectorIntoTableCheckList() {
    if (this.directorForm.valid) {
      var cessationDate: any;
      if (this.directorForm.controls.CessationDate.value) {
        cessationDate = this.commonFunction.setDate(this.directorForm.controls.CessationDate.value)
      } else {
        cessationDate = this.directorForm.controls.CessationDate.value
      }
      var varDirectorToAddIntoTable = {
        DirectorName: this.directorForm.controls.MemberName.value,
        Designation: this.directorForm.controls.Designation.value,
        Category: this.directorForm.controls.Category.value,
        IsExecutive: this.directorForm.controls.IsExecutive.value,
        Chairman: this.directorForm.controls.Chairman.value,
        AppointmentDate: this.commonFunction.setDate(this.directorForm.controls.AppointmentDate.value),
        Tenure: this.directorForm.controls.Tenure.value,
        CessationDate: cessationDate,
        CessationReason: this.directorForm.controls.CessationReason.value,
        DirectorID: this.directorForm.controls.DirectorID.value
      }
      var directorTable = $('#directorTable').DataTable({ destroy: true });
      directorTable.destroy();
      var newMeetingID = this.getMeetingIdFromLocalStorage();
      $("#directorDialog").modal('toggle');
      this.meetingService.addDirectorsInmeeting(newMeetingID, varDirectorToAddIntoTable)
        .subscribe(director => {
          if (director.status == 0) {
            this.Directors = director.MeetingData[0].Directors
            this.alert.success('Director saved successfully.');
            this.dtTriggerDirector.next();
          }
          else {
            this.alert.error(director.message);
          }
        });
      this.Directors.push(varDirectorToAddIntoTable);
      this.alert.success("Director added successfully.");
    }
  }

  updateDirector() {
    var newMeetingID = this.getMeetingIdFromLocalStorage();
    var cessationDate
    if (this.directorForm.controls.CessationDate.value) {
      cessationDate = this.commonFunction.setDate(this.directorForm.controls.CessationDate.value)
    } else {
      cessationDate = this.directorForm.controls.CessationDate.value
    }
    var directorTable = $('#directorTable').DataTable({ destroy: true });
    directorTable.destroy();
    if (this.directorForm.valid) {
      var directorToUpdate = {
        _id: this.directorToUpdateById,
        DirectorID: this.directorObjectToBindWhileUpdating.DirectorID,
        AppointmentDate: this.commonFunction.setDate(this.directorForm.controls.AppointmentDate.value),
        Category: this.directorForm.controls.Category.value,
        CessationDate: cessationDate,
        CessationReason: this.directorForm.controls.CessationReason.value,
        Designation: this.directorForm.controls.Designation.value,
        IsExecutive: this.directorForm.controls.IsExecutive.value,
        MemberName: this.directorForm.controls.MemberName.value,
        Tenure: this.directorForm.controls.Tenure.value
      }
      $('#directorDialog').modal('toggle');
      this.meetingService.updateDirector(newMeetingID, directorToUpdate)
        .subscribe(response => {
          if (response.status == 0) {
            this.loadMeetingDetails(this.g_meetingID);
            this.Directors = response.MeetingData[0].Directors;
            this.alert.success('Director Updated successfully.');
            this.dtTriggerDirector.next();
            this.directorForm.reset();
          }
        },
          error => {
          })
    }
  }

  updateDirectorModalOpen(directorObject) {
    this.directorObjectToBindWhileUpdating = directorObject;
    this.getDirectorsDIN();

    this.updatedirectorButtonFlag = true;
    var directorById = directorObject._id;
    this.directorToUpdateById = directorObject._id;

    var directorDetails;
    _.find(this.Directors, function (o) {
      if (o._id === directorById) {
        directorDetails = o;
      }
      return false;
    });

    this.directorForm.reset();

    if (directorDetails) {

      $('#directorDialog').modal('toggle');

      this.directorForm.controls.MemberName.setValue(directorDetails.DirectorName);
      this.directorForm.controls.Designation.setValue(directorDetails.Designation);
      this.directorForm.controls.Category.setValue(directorDetails.Category);
      this.directorForm.controls.IsExecutive.setValue(directorDetails.IsExecutive); // to be executed

      var dt = new Date(this.setFormatDate(directorDetails.AppointmentDate));
      var directorMeetingDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };

      this.directorForm.controls.AppointmentDate.setValue(directorMeetingDate);
      this.directorForm.controls.Tenure.setValue(directorDetails.Tenure);


      if (directorDetails.CessationDate) {
        var dtCessationDate = new Date(this.setFormatDate(directorDetails.CessationDate))
        var cessationDate = { month: dtCessationDate.getMonth() + 1, day: dtCessationDate.getDate(), year: dtCessationDate.getFullYear() };
        this.directorForm.controls.CessationDate.setValue(cessationDate);
      }
      else {
        this.directorForm.controls.CessationDate.setValue(directorDetails.CessationDate);
      }
      this.directorForm.controls.CessationReason.setValue(directorDetails.CessationReason);

    }
  }

  //to delete director from meeting
  deleteDirector(directorObject) {
    var directorById = directorObject._id
    var meetingId = this.getMeetingIdFromLocalStorage();
    var directorToDeleteById = {
      "id": directorById
    };

    var directorTable = $('#directorTable').DataTable({ destroy: true });
    directorTable.destroy();

    this.meetingService.deleteDirectorInMeeting(meetingId, directorToDeleteById)
      .subscribe(response => {
        if (response.status == 0) {
          this.Directors = response.MeetingData[0].Directors;
          this.alert.success('director deleted successfully.');
          this.dtTriggerDirector.next();
        }
      },
        error => {
        })


  }

  addInviteeModal() {
    this.alreadyExist = false;
    this.inviteeForm.reset();
    this.updateinviteeButtonFlag = false;
    this.hideUpdateButtonOfInvitee = false;
    this.inviteeForm.controls.InviteeName.enable();
    this.inviteeForm.controls.Designation.enable();
    this.inviteeForm.controls.Address.enable();
    this.inviteeForm.controls.City.enable();
    this.inviteeForm.controls.State.enable();
    this.inviteeForm.controls.TelO.enable();
    this.inviteeForm.controls.TelR.enable();
    this.inviteeForm.controls.FaxNo.enable();
    this.inviteeForm.controls.MobileNo.enable();
    this.inviteeForm.controls.EmailId.enable();
    this.inviteeForm.controls.ThroughVC.enable();

    this.inviteeForm.controls.ThroughVC.setValue('No');
    if (this.MeetingTypeName == 'Board') {
      this.inviteeForm.controls.InAttendance.setValue('Special Invitee');
    } else {
      this.inviteeForm.controls.InAttendance.setValue('Special Invitee');
      this.inviteeForm.controls.InAttendance.disable();
    }

  }

  addInviteeIntoCheckList() {
    if (this.inviteeForm.valid) {
      var varInvitee = {
        InviteeName: this.inviteeForm.controls.InviteeName.value,
        Designation: this.inviteeForm.controls.Designation.value,
        Address: this.inviteeForm.controls.Address.value,
        City: this.inviteeForm.controls.City.value,
        State: this.inviteeForm.controls.State.value,
        TelO: this.inviteeForm.controls.TelO.value,
        TelR: this.inviteeForm.controls.TelR.value,
        FaxNo: this.inviteeForm.controls.FaxNo.value,
        MobileNo: this.inviteeForm.controls.MobileNo.value,
        EmailId: this.inviteeForm.controls.EmailId.value,
        InAttendance: this.inviteeForm.controls.InAttendance.value,
        ThroughVC: this.inviteeForm.controls.ThroughVC.value,
        UserGovevaId: this.inviteeForm.controls.GovevaUserId.value,
        selectedInvitee: true
      }

      var newMeetingID = this.getMeetingIdFromLocalStorage();

      var existingInvity = [];

      this.meetingMember.forEach(function (item) {
        if (item.EmailId == varInvitee.EmailId) {
          existingInvity.push(item);
        }
      })
      if (existingInvity.length) {
        this.alreadyExist = true;
      } else {
        this.alreadyExist = false;
        this.meetingService.addInviteesInmeeting(newMeetingID, varInvitee)
          .subscribe((invitees: any) => {
            if (invitees.status == 0) {
              var inviteeTable = $('#inviteeTable').DataTable({ destroy: true });
              inviteeTable.destroy();
              $("#InviteeDialog").modal('toggle');
              this.loadMeetingDetails(this.g_meetingID);
              this.Invitees = invitees.MeetingData[0].Invitees;
              this.alert.success("Invitee added successfully.");
              this.dtTriggerInvitee.next();
              this.inviteeForm.reset();
            }
            else {
              this.alert.error(invitees.message);
            }
          });
      }
    }
    else {
      return false;
    }
  }

  updateInvitee() {
    this.disabledOnclick = true;
    var newMeetingID = this.getMeetingIdFromLocalStorage();
    var inviteeObjectToUpdate = {
      _id: this.inviteeToUpdateById,
      InviteeName: this.inviteeForm.controls.InviteeName.value,
      Designation: this.inviteeForm.controls.Designation.value,
      Address: this.inviteeForm.controls.Address.value,
      City: this.inviteeForm.controls.City.value,
      State: this.inviteeForm.controls.State.value,
      TelO: this.inviteeForm.controls.TelO.value,
      TelR: this.inviteeForm.controls.TelR.value,
      FaxNo: this.inviteeForm.controls.FaxNo.value,
      MobileNo: this.inviteeForm.controls.MobileNo.value,
      EmailId: this.inviteeForm.controls.EmailId.value,
      InAttendance: this.inviteeForm.controls.InAttendance.value,
      ThroughVC: this.inviteeForm.controls.ThroughVC.value,
    }

    var existingInvity = [];
    var checkInviteeEmailExist = _.concat(this.Invitees, this.Members);
    checkInviteeEmailExist.forEach(function (element) {
      if (inviteeObjectToUpdate._id != element._id && element.EmailId == inviteeObjectToUpdate.EmailId) {
        existingInvity.push(element);
      }
    });
    if (existingInvity.length) {
      this.checkEmailIdExistInInvitee = true;
    } else {
      this.checkEmailIdExistInInvitee = false;
      var inviteeTable = $('#inviteeTable').DataTable({ destroy: true });
      inviteeTable.destroy();

      $('#InviteeDialog').modal('toggle');

      this.meetingService.updateInvitee(newMeetingID, inviteeObjectToUpdate)
        .subscribe((response: any) => {
          this.disabledOnclick = false;
          this.loadMeetingDetails(this.g_meetingID);
          if (response.status == 0) {
            this.Invitees = response.MeetingData[0].Invitees;
            this.alert.success('Invitee Updated successfully.');
            this.dtTriggerInvitee.next();
            this.inviteeForm.reset();
          }
        },
          error => {
          })
    }
  }


  updateInviteeModalOpen(inviteeObject) {
    this.updateinviteeButtonFlag = true;
    var inviteeById = inviteeObject._id;
    this.inviteeToUpdateById = inviteeById;
    var inviteeDetails;
    _.find(this.Invitees, function (o) {
      if (o._id === inviteeById) {
        inviteeDetails = o;
      }
      return false;
    });

    this.inviteeForm.reset();

    if (inviteeDetails) {

      $('#InviteeDialog').modal('toggle');

      this.inviteeForm.controls.InviteeName.setValue(inviteeDetails.InviteeName);
      this.inviteeForm.controls.Designation.setValue(inviteeDetails.Designation);
      this.inviteeForm.controls.Address.setValue(inviteeDetails.Address);
      this.inviteeForm.controls.City.setValue(inviteeDetails.City);
      this.inviteeForm.controls.State.setValue(inviteeDetails.State);
      this.inviteeForm.controls.TelO.setValue(inviteeDetails.TelO);
      this.inviteeForm.controls.TelR.setValue(inviteeDetails.TelR);
      this.inviteeForm.controls.FaxNo.setValue(inviteeDetails.FaxNo);
      this.inviteeForm.controls.MobileNo.setValue(inviteeDetails.MobileNo);
      this.inviteeForm.controls.EmailId.setValue(inviteeDetails.EmailId);
      this.inviteeForm.controls.InAttendance.setValue(inviteeDetails.InAttendance);
      this.inviteeForm.controls.ThroughVC.setValue(inviteeDetails.ThroughVC);

      if (this.MeetingTypeName == 'Board') {

        this.hideUpdateButtonOfInvitee = false;
        this.inviteeForm.controls.InviteeName.enable();
        this.inviteeForm.controls.Designation.enable();
        this.inviteeForm.controls.Address.enable();
        this.inviteeForm.controls.City.enable();
        this.inviteeForm.controls.State.enable();
        this.inviteeForm.controls.TelO.enable();
        this.inviteeForm.controls.TelR.enable();
        this.inviteeForm.controls.FaxNo.enable();
        this.inviteeForm.controls.MobileNo.enable();
        this.inviteeForm.controls.EmailId.enable();
        this.inviteeForm.controls.InAttendance.enable();
        this.inviteeForm.controls.ThroughVC.enable();

      } else {

        this.hideUpdateButtonOfInvitee = false;
        this.inviteeForm.controls.InviteeName.enable();
        this.inviteeForm.controls.Designation.enable();
        this.inviteeForm.controls.Address.enable();
        this.inviteeForm.controls.City.enable();
        this.inviteeForm.controls.State.enable();
        this.inviteeForm.controls.TelO.enable();
        this.inviteeForm.controls.TelR.enable();
        this.inviteeForm.controls.FaxNo.enable();
        this.inviteeForm.controls.MobileNo.enable();
        this.inviteeForm.controls.EmailId.enable();
        this.inviteeForm.controls.InAttendance.enable();
        this.inviteeForm.controls.ThroughVC.enable();
        if (this.inviteeForm.controls.InAttendance.value == 'Yes' || this.inviteeForm.controls.InAttendance.value == 'No') {
          this.hideUpdateButtonOfInvitee = true;
          this.inviteeForm.controls.InviteeName.disable();
          this.inviteeForm.controls.Designation.disable();
          this.inviteeForm.controls.Address.disable();
          this.inviteeForm.controls.City.disable();
          this.inviteeForm.controls.State.disable();
          this.inviteeForm.controls.TelO.disable();
          this.inviteeForm.controls.TelR.disable();
          this.inviteeForm.controls.FaxNo.disable();
          this.inviteeForm.controls.MobileNo.disable();
          this.inviteeForm.controls.EmailId.disable();
          this.inviteeForm.controls.InAttendance.disable();
          this.inviteeForm.controls.ThroughVC.disable();
        } else {
          this.hideUpdateButtonOfInvitee = false;
          this.inviteeForm.controls.InviteeName.enable();
          this.inviteeForm.controls.Designation.enable();
          this.inviteeForm.controls.Address.enable();
          this.inviteeForm.controls.City.enable();
          this.inviteeForm.controls.State.enable();
          this.inviteeForm.controls.TelO.enable();
          this.inviteeForm.controls.TelR.enable();
          this.inviteeForm.controls.FaxNo.enable();
          this.inviteeForm.controls.MobileNo.enable();
          this.inviteeForm.controls.EmailId.enable();
          this.inviteeForm.controls.InAttendance.enable();
          this.inviteeForm.controls.ThroughVC.enable();
        }

        this.inviteeForm.controls.InAttendance.disable();
      }
    }
  }



  deleteInviteeConfirmation(inviteeObject) {
    this.invitteeDeleteOBJ = inviteeObject;
    $("#deleteInvitteeData").modal('toggle')
  }

  //to delete invitee from meeting
  deleteInvitee() {
    var inviteeById = this.invitteeDeleteOBJ._id
    var meetingId = this.getMeetingIdFromLocalStorage();
    var inviteeToDeleteById = {
      "id": inviteeById
    };
    var inviteeTable = $('#inviteeTable').DataTable({ destroy: true });
    inviteeTable.destroy();

    this.meetingService.deleteInviteeInMeeting(this.g_meetingTypeID, this.g_meetingID, inviteeToDeleteById)
      .subscribe((response: any) => {
        // console.log("Invitee Deleted", response);
        if (response.status == 0) {
          this.Invitees = response.MeetingData[0].Invitees;
          this.alert.success('Invitee deleted successfully.');
          this.dtTriggerInvitee.next();
          this.loadMeetingDetails(this.g_meetingID);
        }
      },
        error => {
        })
  }

  addMemberModal() {
    this.updateMemberButtonFlag = false;
  }

  //to add member into Meeting
  AddMember() {
    this.disabledOnclick = true;
    if (this.memberForm.valid) {
      var memberFormMember = {
        MemberName: this.memberForm.controls.MemberName.value,
        Designation: this.memberForm.controls.Designation.value,
        Address: this.memberForm.controls.Address.value,
        City: this.memberForm.controls.City.value,
        State: this.memberForm.controls.State.value,
        TelO: this.memberForm.controls.TelO.value,
        TelR: this.memberForm.controls.TelR.value,
        FaxNo: this.memberForm.controls.FaxNo.value,
        MobileNo: this.memberForm.controls.MobileNo.value,
        EmailId: this.memberForm.controls.EmailId.value,
        selectedMember: true
      }

      var memberTable = $('#memberTable').DataTable({ destroy: true });
      memberTable.destroy();

      var newMeetingID = this.getMeetingIdFromLocalStorage();

      $("#MemberDialog").modal('toggle');

      this.meetingService.addMembersInmeeting(newMeetingID, memberFormMember)
        .subscribe(members => {
          this.disabledOnclick = false;
          if (members.status == 0) {
            this.loadMeetingDetails(this.g_meetingID);
            this.Members = members.MembersData[0].Members;
            this.alert.success('Members saved successfully.');
            this.dtTriggerMember.next();

            this.memberForm.reset();
          }
          else {
            this.alert.error(members.message);
          }
        });

    }
    else {
      return false;
    }
  }

  updateMember() {

    var newMeetingID = this.getMeetingIdFromLocalStorage();

    var memberObjectToUpdate = {
      _id: this.memberToUpdateById,
      MemberName: this.memberForm.controls.MemberName.value,
      Designation: this.memberForm.controls.Designation.value,
      Address: this.memberForm.controls.Address.value,
      City: this.memberForm.controls.City.value,
      State: this.memberForm.controls.State.value,
      TelO: this.memberForm.controls.TelO.value,
      TelR: this.memberForm.controls.TelR.value,
      FaxNo: this.memberForm.controls.FaxNo.value,
      MobileNo: this.memberForm.controls.MobileNo.value,
      EmailId: this.memberForm.controls.EmailId.value
    }

    $("#MemberDialog").modal('toggle');

    var memberTable = $('#memberTable').DataTable({ destroy: true });
    memberTable.destroy();

    this.meetingService.updateMember(newMeetingID, memberObjectToUpdate)
      .subscribe(response => {
        if (response.status == 0) {
          this.loadMeetingDetails(this.g_meetingID);
          this.Members = response.MeetingData[0].Members;
          this.alert.success('Member Updated successfully.');
          this.dtTriggerMember.next();
        }
      },
        error => {
          console.log("error", error);
        })

  }

  updateMemberModalOpen(memberObject) {

    this.updateMemberButtonFlag = true;
    var memberDetails;
    var memberById = memberObject._id;
    this.memberToUpdateById = memberById;

    _.find(this.Members, function (o) {
      if (o._id == memberById) {
        memberDetails = o;
      }
      return false;
    });

    this.memberForm.reset();

    if (memberDetails) {

      $('#MemberDialog').modal('toggle');

      this.memberForm.controls.MemberName.setValue(memberDetails.MemberName);
      this.memberForm.controls.Designation.setValue(memberDetails.Designation);
      this.memberForm.controls.Address.setValue(memberDetails.Address)
      this.memberForm.controls.City.setValue(memberDetails.City);
      this.memberForm.controls.State.setValue(memberDetails.State);
      this.memberForm.controls.TelO.setValue(memberDetails.TelO);
      this.memberForm.controls.TelR.setValue(memberDetails.TelR);
      this.memberForm.controls.FaxNo.setValue(memberDetails.FaxNo)
      this.memberForm.controls.MobileNo.setValue(memberDetails.MobileNo);
      this.memberForm.controls.EmailId.setValue(memberDetails.EmailId);

    }
  }

  deleteMember(memberObject) {
    var memberById = memberObject._id
    var meetingId = this.getMeetingIdFromLocalStorage();
    var memberToDeleteById = {
      "id": memberById
    };

    var memberTable = $('#memberTable').DataTable({ destroy: true });
    memberTable.destroy();

    this.meetingService.deleteMemberInMeeting(meetingId, memberToDeleteById)
      .subscribe(response => {
        if (response.status == 0) {
          this.loadMeetingDetails(this.g_meetingID);
          this.Members = response.MemberData[0].Members;
          this.alert.success('Member deleted successfully.');
          this.dtTriggerMember.next();
        }
      },
        error => {
        })

  }

  /* Save selected director in meeting */
  saveDirectors() {

    var newMeetingID = "";
    if (localStorage.getItem("MeetingID") != undefined) {
      newMeetingID = localStorage.getItem("MeetingID");
    }
    else if (localStorage.getItem("updateMeetingID") != undefined) {
      newMeetingID = localStorage.getItem("updateMeetingID");
    }
    if (newMeetingID == "") {
      this.alert.error("Please first insert meeting details.");
      return false;
    }
    var selectedDirectorsForMeeting = [];
    for (var i = 0; i < this.Directors.length; i++) {
      if (this.Directors[i].selectedDirector == true) {
        selectedDirectorsForMeeting.push(this.Directors[i]);
      }
    }
    if (selectedDirectorsForMeeting.length == 0) {
      this.alert.error("Please select directors.");
      return false;
    }
    this.meetingService.addDirectorsInmeeting(newMeetingID, selectedDirectorsForMeeting)
      .subscribe(director => {
        if (director.status == 0) {
          this.loadMeetingDetails(this.g_meetingID);
          this.alert.success('Directors saved successfully.');

        }
        else {
          this.alert.error(director.message);
        }
      });
  }


  clearMeetingConfirmation() {
    $("#clearMeetingData").modal('toggle');
  }


  onlyAlphabates(ev) {
    var charCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (!(charCode >= 65 && charCode <= 120) && (charCode != 32 && charCode != 0) && (charCode != 8) && (charCode != 46) && (charCode != 9)
      && (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
      event.preventDefault();
    }
  }

  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList: any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }

  //Get company task list
  getActivatedTaskListBySearchFilter(searchParameters) {

    this.companytasklist = [];
    // this.dtElementForCompliance.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    // });
    var table = $('#companytaskTable').DataTable({ destroy: true });
    table.destroy();
    var companytaskWithAddedToShow = [];
    var companytaskWithoutAgendaTaskList = []
    this.taskService.getCompanyTaskListBySearchFilters(searchParameters)
      .subscribe(taskList => {
        if (taskList.status == 0) {

          if (this.ActualDataToAgenda) {
            //On Update show nont available Task from agenda in search filter
            companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;

            var k = 0;
            for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
              var flag = true;
              for (var j = 0; j < this.ActualDataToAgenda.length; j++) {

                if (companytaskWithAddedToShow[i].ID == this.ActualDataToAgenda[j].Task_id) {
                  flag = false;
                  break;
                } else {
                }
              }
              if (flag) {
                companytaskWithoutAgendaTaskList.push(companytaskWithAddedToShow[i]);
              }
            }

            companytaskWithAddedToShow = companytaskWithoutAgendaTaskList;

            this.companytasklist = companytaskWithAddedToShow
          } else {
            this.companytasklist = taskList.tasksDatalist.TasksData;
          }

          this.dtTriggerCompliance.next();

        }

      })
  }

  indexOfElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {
      return o.ID == elementValue.ID;
    })
    if (index == -1) {
      var index = _.findIndex(array, function (o) {

        return o.TaskID == elementValue.TaskID;
      })
    }
    return index;
  }

  indexOfElementArrayInitial(array: any[], elementValue) {

    var index = _.findIndex(array, function (o) {
      return o.TaskID == elementValue.TaskID;
    })

    return index;
  }



  //to add compliance into compliance datatable 
  addSelectedCompliance() {
    this.disabledOnclick = true;
    ////inside popup form dialog
    $('#AddCompliancesDialog').off('hidden.bs.modal');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#AddCompliancesDialog').modal('hide');
    var addedtaskTable = $('#addedtaskTable').DataTable({ destroy: true });
    addedtaskTable.destroy();
    $("#companytaskTable").DataTable().destroy()

    var compliancesToAdd = [];
    const self = this;
    var i = 0;
    _.forEach(this.companytasklist, function (o) {
      if (o.SelectedTask) {
        compliancesToAdd.push(o);
        self.complianceToShow.push(o);
      }
    })
    for (var i = 0; i < this.complianceToShow.length; i++) {
      var index = this.indexOfElementArray(this.companytasklist, this.complianceToShow[i]);
      this.companytasklist.splice(index, 1);
    }
    this.dtTriggerCompliance.next()
    $("#addedtaskTable").DataTable().destroy();
    this.meetingService.addCompliancesInMeeting(this.g_meetingID, compliancesToAdd)
      .subscribe(response => {
        this.disabledOnclick = false;
        this.alert.success("Compliance added successfully.");
        this.getActivatedTaskList();
      },
        error => {
        })

  }

  getCompanyTaskList() {
    this.taskService.getCompanyTaskList()
      .subscribe(taskList => {
        let checked = true;
        if (taskList.status == 0) {
          this.companytasklist = [];
          var companytaskWithAddedToShow = [];
          var data = [];
          companytaskWithAddedToShow = $(taskList.tasksDatalist.TasksData).filter(function (i, n) { return n.TriggerType == 1 });
          companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;
          for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
            if (companytaskWithAddedToShow[i].TriggerType == 1) {
              data.push(companytaskWithAddedToShow[i]);
            }
          }
          this.companytasklist = data;
          this.dtTriggerCompliance.next();
        }
      })
  }


  checkAllCompliances(ev) {
    if (ev.target.checked == true) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataTaskStore.length; j++) {
          if (this.searcheFilteredDataTaskStore[j] == this.companytasklist[i].ID) {
            this.selectedAllAgendaStore = true;
            this.selectedAll = true;
            this.companytasklist[i].SelectedTask = true;
          }
        }
      }
    } else {
      this.companytasklist.forEach(element => {
        element.SelectedTask = false;
      });
    }
  }



  checkselectedCompliance(ev) {
    // searcheFilteredDataTaskStore
    if (ev.target.checked == true) {
      this.IsSelectedTasks = true;
    }
    else {
      this.IsSelectedTasks = false;
    }

    var allSearchedSelectedTask = true;
    if (_.size(this.companytasklist)) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataTaskStore.length; j++) {
          if (this.searcheFilteredDataTaskStore[j] == this.companytasklist[i].ID) {
            if (this.companytasklist[i].SelectedTask) {
            } else {
              allSearchedSelectedTask = false;
            }
          }
        }
      }
    }

    if (allSearchedSelectedTask) {
      this.selectedAll = true;
    } else {
      this.selectedAll = false;

    }
  }

  getSelectedGroupID(ev) {
    var id = ev.target.value;
    this.groupID = id;
  }

  adjustTables(table) {
    if (table = 'agenda') {

      setTimeout(() => {
        $("#agendaTable").DataTable().columns.adjust().draw();
      }, 200);
    }
    if (table = 'AttandanceTable') {
      setTimeout(() => {
        $("#AttandanceTable").DataTable().columns.adjust().draw();
      }, 200);
    }
    if (table = 'AgendaGen') {
      this.getAgendaGenerationData()
      setTimeout(() => {
        $("#AgendaGen").DataTable().columns.adjust().draw();
      }, 200);
    }
    if (table = 'agendanew') {
      setTimeout(() => {
        $("#agendaNewTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }


  showTasksBySearchData() {
    this.companytasklist = [];
    var searchParameters = {
      EventBasedorPeriodic: '1',
      UserdefinedorPredefined: this.SearchtaskUserdefinedorPredefinedModel,
      GroupId: (this.groupID === '') ? null : this.groupID
    };
    $("#companytaskTable").DataTable().destroy();
    this.companyTaskListBySearchFilter(searchParameters);
  }


  companyTaskListBySearchFilter(searchParameters) {
    this.companytasklist = [];
    var companytaskWithAddedToShow = [];
    var data = [];
    this.taskService.getCompanyTaskListBySearchFilters(searchParameters)
      .subscribe(taskList => {
        if (taskList.status == 0) {

          var predefinedTaskList = $(taskList.tasksDatalist.TasksData).filter(function (i, n) { return n.TriggerType == 1 });
          companytaskWithAddedToShow = taskList.tasksDatalist.TasksData;
          for (var i = 0; i < companytaskWithAddedToShow.length; i++) {
            if (companytaskWithAddedToShow[i].TriggerType == 1) {
              data.push(companytaskWithAddedToShow[i]);
            }
          }
          this.companytasklist = data;
          this.dtTriggerCompliance.next();
        }
      })
  }



  showAllTasks() {

    this.SearchtaskEventbasedorPeriodicModel = '1';
    this.SearchtaskUserdefinedorPredefinedModel = null;
    this.groupID = "";
    this.searchByGroupID = '';
    var searchParameters = {
      EventBasedorPeriodic: '1',
      UserdefinedorPredefined: this.SearchtaskUserdefinedorPredefinedModel,
      GroupId: (this.groupID === '') ? null : this.groupID
    };
    $("#companytaskTable").DataTable().destroy();
    this.companyTaskListBySearchFilter(searchParameters);


  }

  /*In the case of Board and all committee meetings the due date should be automatically auto populated as (date of meeting) - 7 days
   *for all meeting types. For AGM / EGM it should be 21 days prior. For postal ballot no date to be autopopulated
   */
  setDateOfSigning() {

    if (this.currentURL.includes('edit')) {

      this.meetingService.getMeetingTypeNameOnMeetingTypeID(this.addmeetingForm.controls.MeetingType.value).subscribe(element => {
        this.PSSMasterMeetingTypeID = element.PSSMasterMeetingTypeID;
        var MeetingTypeName = element.meetingTyepName;
        var Meetingdate = this.setDate(this.MeetingDateModel);
        var meetimeADJDate = this.setDate(this.meetimeADJDate);
        if (this.MeetingDateModel != null || this.MeetingDateModel != undefined) {
          if (MeetingTypeName == 'Annual General Meeting' || MeetingTypeName == 'Extraordinary General Meeting') {
            var formatedDate = moment(Meetingdate, "MM-DD-YYYY").subtract(22, 'days');
            var check = moment(formatedDate, 'MM-DD-YYYY');
            var newMonth = parseInt(check.format('M'));
            var newDay = parseInt(check.format('D'));
            var newYear = parseInt(check.format('YYYY'));
            var issueDate = { month: newMonth, day: newDay, year: newYear };
            if (this.ignoredFirstEvent) {
              this.addmeetingForm.controls.IssueNoticeDueDate.setValue(this.newAssignIssueNoticeDueDateModel);
              this.IssueNoticeDueDateModel = this.newAssignIssueNoticeDueDateModel;
            } else {
              this.addmeetingForm.controls.IssueNoticeDueDate.setValue(issueDate);
              this.IssueNoticeDueDateModel = issueDate;
            }
            this.ignoredFirstEvent = false;
            if (meetimeADJDate == null || moment(Meetingdate).diff(moment(meetimeADJDate).format('YYYY-MM-DD'), "days") >= 0) {
              this.disableAdjournedDate = true;
            } else {
              this.disableAdjournedDate = false;
            }
          } else if (MeetingTypeName == 'Postal Ballot') {
            this.addmeetingForm.controls.IssueNoticeDueDate.setValue(this.newAssignIssueNoticeDueDateModel);
            this.IssueNoticeDueDateModel = this.newAssignIssueNoticeDueDateModel;
            this.ignoredFirstEvent = false;
          }
          else {
            var formatedDate = moment(Meetingdate, "MM-DD-YYYY").subtract(7, 'days');
            var check = moment(formatedDate, 'MM-DD-YYYY');
            var newMonth = parseInt(check.format('M'));
            var newDay = parseInt(check.format('D'));
            var newYear = parseInt(check.format('YYYY'));
            var issueDate = { month: newMonth, day: newDay, year: newYear };
            if (this.ignoredFirstEvent) {
              this.addmeetingForm.controls.IssueNoticeDueDate.setValue(this.newAssignIssueNoticeDueDateModel);
            } else {
              this.addmeetingForm.controls.IssueNoticeDueDate.setValue(issueDate);
            }
            this.ignoredFirstEvent = false;

          }

        }
      })

    } else {

      var Meetingdate = this.setDate(this.MeetingDateModel);
      if (this.MeetingDateModel != null || this.MeetingDateModel != undefined) {

        //===== For Automatic Meeting Number Set START =======
        var meetingDateChangeFormat = moment(Meetingdate).format('DD-MM-YYYY');
        this.meetingDateChangeFormatForTime = meetingDateChangeFormat;
        // if(this.getTime(meetingDateChangeFormat)>this.getTime(this.financialYearEndDate))
        // {
        //   this.addmeetingForm.controls.MeetingNumber.setValue(1);
        // }
        // else{
        this.toGetMeetingNumber(this.meetingIdForMeetingNumber, meetingDateChangeFormat, this.meetingTimeForAutoMeetingNo);
        // }
        //===== For Automatic Meeting Number Set END =======

        if (this.selectedType == 'Annual General Meeting' || this.selectedType == 'Extraordinary General Meeting') {
          var formatedDate = moment(Meetingdate, "MM-DD-YYYY").subtract(22, 'days');
          var check = moment(formatedDate, 'MM-DD-YYYY');
          var newMonth = parseInt(check.format('M'));
          var newDay = parseInt(check.format('D'));
          var newYear = parseInt(check.format('YYYY'));
          var issueDate = { month: newMonth, day: newDay, year: newYear };

          this.addmeetingForm.controls.IssueNoticeDueDate.setValue(issueDate);
          this.IssueNoticeDueDateModel = issueDate;
        } else if (this.selectedType == 'Postal Ballot') {
          this.addmeetingForm.controls.IssueNoticeDueDate.setValue(this.addmeetingForm.controls.IssueNoticeDueDate.value);
          this.IssueNoticeDueDateModel = this.addmeetingForm.controls.IssueNoticeDueDate.value;

        }
        else {
          var formatedDate = moment(Meetingdate, "MM-DD-YYYY").subtract(7, 'days');
          var check = moment(formatedDate, 'MM-DD-YYYY');
          var newMonth = parseInt(check.format('M'));
          var newDay = parseInt(check.format('D'));
          var newYear = parseInt(check.format('YYYY'));
          var issueDate = { month: newMonth, day: newDay, year: newYear };
          this.addmeetingForm.controls.IssueNoticeDueDate.setValue(issueDate);
        }
      }
    }
  }

  getTime(d) {
    return new Date(d.split("-").reverse().join("-")).getTime()
  }

  setDuedatemanual(date) {
    var self = this;
    var year = date.year;
    var month = date.month - 1; //october
    var day = date.day;

    //2015-10-01

  }
  setActivatedDirectorRecordOnMeetingDateChange(meetingDate) {
    var activeDirectors = [];
    meetingDate = moment(meetingDate).format('YYYY-MM-DD');
    this.Directors.forEach(element => {
      var CessationDate = element.CessationDate;
      var AppointmentDate = element.AppointmentDate;

      if (element.AppointmentDate == "") {
        activeDirectors.push(element);
      }
      else if ((CessationDate == null || moment(meetingDate).diff(moment(CessationDate).format('YYYY-MM-DD'), "days") <= 0)
        && moment(meetingDate).diff(moment(AppointmentDate).format('YYYY-MM-DD'), "days") >= 0) {
        activeDirectors.push(element);
      }
    })
    this.activatedDirectors = activeDirectors
    this.Directors = this.activatedDirectors;
  }

  setActivatedMemberRecordOnMeetingDateChange(meetingDate) {
    var activeMemebers = [];
    var newMeetingMemberDataInMeeting = []
    meetingDate = moment(meetingDate).format('YYYY-MM-DD');
    var newMeetingMemberData = JSON.parse(localStorage.getItem("newMeetingMemberData"));
    newMeetingMemberDataInMeeting = newMeetingMemberData;
    if (newMeetingMemberDataInMeeting && newMeetingMemberDataInMeeting.length > 0) {
      for (var i = 0; i < newMeetingMemberDataInMeeting.length; i++) {
        var CessationDate = newMeetingMemberDataInMeeting[i].CessationDate;
        var AppointmentDate = newMeetingMemberDataInMeeting[i].AppointmentDate;
        if (newMeetingMemberDataInMeeting[i].AppointmentDate == "" || newMeetingMemberDataInMeeting[i].AppointmentDate == null) {
          activeMemebers.push(newMeetingMemberDataInMeeting[i]);
        }
        else if ((CessationDate == null || moment(meetingDate).diff(moment(CessationDate).format('YYYY-MM-DD'), "days") <= 0)
          && moment(meetingDate).diff(moment(AppointmentDate).format('YYYY-MM-DD'), "days") >= 0) {
          activeMemebers.push(newMeetingMemberDataInMeeting[i]);
        }

      }
    }
    this.activatedMemebers = activeMemebers
    this.Members = this.activatedMemebers;
  }

  getActiveDirectors(meetingDate) {
    var activeDirectors = []

    this.Directors.forEach(element => {
      var CessationDate = moment(element.CessationDate).format('YYYY-MM-DD');
      var AppointmentDate = moment(element.AppointmentDate).format('YYYY-MM-DD');;
      meetingDate = moment(meetingDate).format('YYYY-MM-DD');;

      if (element.AppointmentDate == "") {
        activeDirectors.push(element);
      } else if ((element.CessationDate == null || moment(meetingDate).diff(CessationDate) <= 0) && moment(meetingDate).diff(AppointmentDate) >= 0) {
        activeDirectors.push(element);
      }

    })
  }


  addAgendaPageRedirection() {
    localStorage.setItem('agendaAddReturnContext', 'meeting');
    localStorage.setItem('fromMeeting', this.g_meetingID)
    var meetingID = this.g_meetingID;
    var meetingTypeID = this.g_meetingTypeID;
    var queryParams = [{
      "meetingID": meetingID,
      "meetingTypeID": meetingTypeID
    }]
    localStorage.setItem('queryParams', JSON.stringify(queryParams));
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['agenda', 'add'] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['agenda/add'])

  }

  adjustDirectorTable() {
    setTimeout(() => {
      $("#directorTable").DataTable().columns.adjust().draw();
    }, 200);

  }

  adjustMemberTable() {
    setTimeout(() => {
      $("#memberTable").DataTable().columns.adjust().draw();
    }, 200);
  }

  adjustTransferToGemTable() {

    setTimeout(() => {
      $("#transferToGemTable").DataTable().columns.adjust().draw();
    }, 200);
  }
  clickTransferToGem() {
    $('#transferToGemTabId').click();
    setTimeout(() => {
      $("#transferToGemTable").DataTable().columns.adjust().draw();
    }, 200);
  }

  adjustComplianceTable() {

    // var compliance = this.complianceToShow;
    // this.complianceToShow = [];

    // $("#addedtaskTable").DataTable().destroy();
    // this.complianceToShow = compliance;
    // this.router.navigate(['/meeting/edit/'+this.g_meetingID+'/Compliance']);
    var self = this;
    setTimeout(() => {
      if (self.isHeaderSetted) {
        $("#addedtaskTable").DataTable().columns.adjust().draw();
      }
    }, 300);

  }

  adjustAgendaAccessTable() {
    setTimeout(() => {
      $("#agendaAccessTable").DataTable().columns.adjust().draw();
    }, 200);
  }

  private formatAgendaAuditWhen(d: any): string {
    if (d === null || d === undefined || d === '') {
      return '—';
    }
    const m = moment(d);
    return m.isValid() ? m.format('DD-MM-YYYY hh:mm A') : '—';
  }

  /** Step types: Insert | Edit | File upload | Attachment (same spirit as UPSI i / u trails). */
  private formatAgendaAuditType(op: string | undefined): string {
    const o = (op || '').toString().toLowerCase();
    if (o === 'i') {
      return 'Insert';
    }
    if (o === 'e') {
      return 'Edit';
    }
    if (o === 'f') {
      return 'File upload';
    }
    if (o === 'a') {
      return 'Attachment';
    }
    if (o === 'u') {
      return 'Edit';
    }
    return 'Edit';
  }

  /** Fallback for audit "Changed by" when API did not store a name on the row. */
  private loggedInUserAuditLabel(): string {
    try {
      const raw = localStorage.getItem('user');
      if (!raw) {
        return '';
      }
      const u = JSON.parse(raw);
      const full = [u.FirstName, u.LastName].filter((x: any) => x != null && String(x).trim() !== '').join(' ').trim();
      return (
        full ||
        (u.UserName && String(u.UserName).trim()) ||
        (u.userName && String(u.userName).trim()) ||
        (u.EmailId && String(u.EmailId).trim()) ||
        (u.email && String(u.email).trim()) ||
        (u._id != null ? `User id: ${u._id}` : '')
      );
    } catch {
      return '';
    }
  }

  showAgendaAuditTrail(agenda: any) {
    type Row = {
      whenMs: number;
      typeLabel: string;
      when: string;
      user: string;
      changes: string;
    };
    const rows: Row[] = [];
    const whenMs = (d: any) => {
      if (!d) {
        return NaN;
      }
      const m = moment(d);
      return m.isValid() ? m.valueOf() : NaN;
    };
    const currentUserFallback = this.loggedInUserAuditLabel();
    const pushRow = (d: any, operationCode: string | undefined, user: string, changes: string) => {
      const fromApi = user && String(user).trim() ? String(user).trim() : '';
      const displayUser = fromApi || currentUserFallback;
      rows.push({
        whenMs: whenMs(d),
        typeLabel: this.formatAgendaAuditType(operationCode),
        when: this.formatAgendaAuditWhen(d),
        user: displayUser ? displayUser : '—',
        changes: changes && String(changes).trim() ? String(changes) : '—'
      });
    };

    const actLog = agenda.AgendaActivityLog;
    const useActivityLogTrail = Array.isArray(actLog) && actLog.length > 0;

    if (Array.isArray(actLog)) {
      actLog.forEach((e: any) => {
        const summary = (e.changeSummary || e.detail || '').toString().trim();
        const headline = e.action ? `${e.action}: ` : '';
        const named =
          e.userName ||
          e.UserName ||
          e.performedByName ||
          e.PerformedByName ||
          '';
        const idRaw = e.userId != null && e.userId !== '' ? String(e.userId).trim() : '';
        const actor =
          named && String(named).trim()
            ? String(named).trim()
            : idRaw
              ? `User id: ${idRaw}`
              : '';
        pushRow(e.at || e.performedAt, e.operation, actor, headline + summary);
      });
    }

    if (!useActivityLogTrail && agenda.CreatedDate) {
      const creator =
        agenda.CreatedBy ??
        agenda.createdBy ??
        agenda.CreatedByUserId ??
        agenda.ModifiedBy ??
        agenda.modifiedBy ??
        '';
      const fallbackUser =
        creator != null && creator !== ''
          ? `User id: ${creator}`
          : '';
      const label = agenda.AgendaTitle
        ? `Agenda item added — title: ${agenda.AgendaTitle}`
        : 'Agenda item added';
      pushRow(
        agenda.CreatedDate,
        'i',
        fallbackUser,
        label
      );
    }

    if (!useActivityLogTrail) {
      const gen = agenda.AgendaGenerationDocument;
      if (gen && gen.UploadDate && gen.DocName && gen.DocName !== 'File Not Available') {
        pushRow(gen.UploadDate, 'f', '', `Latest agenda file on record: ${gen.DocName}`);
      }

      const minDoc = agenda.AgendaMinuteDocument;
      if (minDoc && minDoc.UploadDate && minDoc.DocName && minDoc.DocName !== 'File Not Available') {
        pushRow(minDoc.UploadDate, 'f', '', `Latest minute file on record: ${minDoc.DocName}`);
      }

      const pdfs = agenda.AgendaGenerationPdf;
      if (Array.isArray(pdfs)) {
        pdfs.forEach((p: any, idx: number) => {
          if (p && p.UploadDate) {
            const name = p.PdfName || p.UploadFileName || `Attachment ${idx + 1}`;
            if (name && name !== 'File Not Available') {
              pushRow(p.UploadDate, 'a', '', `Attachment on file: ${name}`);
            }
          }
        });
      }

      const docHist = agenda.AgendaGenerationDocumentHistory;
      if (Array.isArray(docHist)) {
        docHist.forEach((h: any) => {
          if (h && h.UploadDate) {
            pushRow(h.UploadDate, 'f', '', `Older agenda file version: ${h.DocName || '—'}`);
          }
        });
      }
    }

    const agendaHist = agenda.AgendaHistory;
    if (Array.isArray(agendaHist)) {
      agendaHist.forEach((h: any) => {
        const when = h.transferToGemTime || h.TransferToGemTime;
        const title = h.AgendaTitle || h.agendaTitle || '';
        const num = h.AgendaNumber || h.agendaNumber || '';
        const performedBy =
          h.PerformedByName ||
          h.performedByName ||
          (h.PerformedById || h.performedById ? `User id: ${h.PerformedById || h.performedById}` : '');
        const parts: string[] = [];
        parts.push('Snapshot before change while published');
        if (num !== '' && num !== null && num !== undefined) {
          parts.push(`#${num}`);
        }
        if (title) {
          parts.push(String(title));
        }
        const snapGen = h.AgendaGenerationDocument;
        if (snapGen && snapGen.DocName && snapGen.DocName !== 'File Not Available') {
          parts.push(`Agenda doc: ${snapGen.DocName}`);
        }
        const snapMin = h.AgendaMinuteDocument;
        if (snapMin && snapMin.DocName && snapMin.DocName !== 'File Not Available') {
          parts.push(`Minute: ${snapMin.DocName}`);
        }
        const snapPdfs = h.AgendaGenerationPdf;
        if (Array.isArray(snapPdfs) && snapPdfs.length > 0) {
          const pdfLabel = snapPdfs
            .map((p: any, i: number) => (p && (p.PdfName || p.UploadFileName)) || `PDF ${i + 1}`)
            .filter((s: string) => s && s !== 'File Not Available')
            .join(', ');
          if (pdfLabel) {
            parts.push(`Attachments: ${pdfLabel}`);
          }
        }
        const changes = parts.join(' · ');
        pushRow(when, 'e', performedBy, changes);
      });
    }

    rows.sort((a, b) => {
      if (isNaN(a.whenMs) && isNaN(b.whenMs)) {
        return 0;
      }
      if (isNaN(a.whenMs)) {
        return 1;
      }
      if (isNaN(b.whenMs)) {
        return -1;
      }
      return b.whenMs - a.whenMs;
    });

    this.agendaAuditTrailHeadline = agenda.AgendaTitle
      ? `Audit trail — ${agenda.AgendaNumber != null ? agenda.AgendaNumber + ' · ' : ''}${agenda.AgendaTitle}`
      : 'Agenda audit trail';
    this.agendaAuditRows = rows.map(({ whenMs, ...rest }) => rest);
    $('#agendaAuditTrailDialog').modal('show');
  }

  agendaDeleteConFirmation(agendaObj) {
    this.deletingAgendaObject = agendaObj;
    $("#agendaDelete").modal('toggle');
  }

  removeAgendaFromMeeting() {
    this.deleteAgendaFromMeeting(this.deletingAgendaObject)
  }


  deleteAgendaFromMeeting(AgendaObject) {
    var agendaById = AgendaObject._id
    var meetingId = this.getMeetingIdFromLocalStorage();
    var agendaToDeleteById = {
      "id": agendaById
    };
    this.meetingService.deleteAgendaInMeeting(meetingId, agendaToDeleteById)
      .subscribe(response => {
        if (response.status == 0) {
          var agendaTable = $('#agendaTable').DataTable({ destroy: true });
          var addedtaskTable = $('#addedtaskTable').DataTable({ destroy: true });
          agendaTable.destroy();
          $("#agendaNewTable").DataTable().destroy();
          addedtaskTable.destroy();
          this.agendaAddedTaskList = [];
          this.agendaArray = _.sortBy(response.data[0].Agenda, ["Agendaorder"]);

          this.newAgendaArray = this.agendaArray.map(enhanchArr);
          this.newAgendaArray.push(...this.tempArray)
          this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
            return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
          });
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
          this.dtTriggerAgenda.next();
          this.dtTriggerAgendaNew.next()
          this.transferToGemArray = [];
          var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
          transferToGemTable.destroy();
          this.transferToGemArray = response.data[0].Agenda;
          for (var index = 0; index < this.transferToGemArray.length; index++) {
            this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
          }
          this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
          this.dtTriggerOfTransferToGem.next();
          $("#agendaAccessTable").DataTable().destroy();
          this.agendaAccessArray = response.data[0].AgendaAccessRights;
          this.dtTriggerAgendaAccess.next();
          this.getActivatedTaskList()
          this.alert.success("Agenda Deleted successfully.");

        }
      },
        error => {
          console.log("error", error);
        })

  }


  editAgendaInAgenda(agenda_id) {
    localStorage.removeItem('fromMeeting');
    localStorage.setItem('fromMeeting', this.g_meetingID);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['agenda', 'edit', agenda_id] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['agenda/edit/' + agenda_id]);
  }

  editAgendaLibraryInAgenda(agendaId) {

    localStorage.removeItem('fromMeeting');
    localStorage.setItem('fromMeeting', this.g_meetingID);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['meeting', 'Libraryagenda', 'edit', agendaId] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(
    //   [{ outlets: { 'structure-outlet': ['Libraryagenda', 'edit', agendaId] } }],
    //   { relativeTo: this.route.parent });
    // this.router.navigate(['meeting/Libraryagenda/edit/' + agenda_id]);
  }



  redirectToEditTask(Task_id) {
    localStorage.removeItem('fromMeeting');
    localStorage.setItem('fromMeeting', this.g_meetingID);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['tasks', 'library', 'update', Task_id] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['tasks/library/update/' + Task_id]);
  }

  confirmationForDeleteCompliance(ComplianceObject) {
    this.ComplianceObject = ComplianceObject;
    $("#complianceDelete").modal('toggle');
  }

  removeComplianceFromMeeting() {

    var activatedTaskById = this.ComplianceObject._id;
    var meetingId = this.g_meetingID;

    var activatedTaskToDeleteById = {
      "id": activatedTaskById
    };

    this.meetingService.deleteComplianceInMeeting(meetingId, activatedTaskToDeleteById)
      .subscribe((response: any) => {
        //     // //console.log(("Compliance Deleted", response);
        if (response.status == 0) {

          $("#dtTriggerAddingCompliance").DataTable().destroy();
          this.alert.success("Compliance Deleted successfully.");

          var index = this.indexOfDeleteingTaskElementArray(this.activatedTaskList, activatedTaskById)

          this.getActivatedTaskList();
        }
      })
  }

  indexOfDeleteingTaskElementArray(array: any[], id) {
    var index = _.findIndex(array, function (o) {
      return o.ID == id || o._id == id;
    })
    return index;
  }


  upload() {
    this.disabledOnclick = true;
    var file = this.filesToUpload;
    this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        if (this.attendanceFile == "" || this.attendanceFile == undefined) {

          var document = {
            "DocumentName": this.titleOnAddUpdate + " - Attendence Proof",
            "DateOfDocument": new Date(),
            "CompletedDate": null,
            "MeetingTypeID": this.g_meetingTypeID,
            "ParentDocumentTypeID": null,
            "ParentSubDocumentTypeID": null,
            "DirectorKmp": "None",
            "DirectorID": null,
            "KMPID": null,
            "Remarks": "",
            "Overwrite": false,
            "Filename": this.changedName,
            "OriginalFileName": this.FileOrignalName,
            "FilePath": "D:\\Harrier\\PSSProject\\pss_api\\uploads\\Document_Type\\",
            "CreatedBy": null,
            "CreatedDate": new Date(),
            "LastUpdateFiles": new Date(),
            "ModifiedBy": null,
            "ModifiedDate": null,
          }
          this.meetingService.addAttendanceDocToMeeting(document, this.g_meetingID)
            .subscribe(data => {
              this.disabledOnclick = false;
              if (data.status == 0) {
                this.attendanceFile = data.MeetingData[0].AttendanceFile;
                $("#AttandenceMarkDilogue").modal('toggle');
                this.isFileAvailable = true;
                this.alert.success("Attendance file saved successfully.");
              }
            });
        } else {
          //updating document
          var newDocumentManagement = {
            _id: this.attendanceFile,
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName
          }
          this.meetingService.updateDocumentOnly(newDocumentManagement)
            .subscribe(data => {
              this.disabledOnclick = false;
              if (data.status == 0) {
                $("#AttandenceMarkDilogue").modal('toggle');
                this.alert.success("Attendance file saved successfully.");
              }
            });
        }
      }
    }, (error) => {
      this.alert.error(error);
      this.disabledOnclick = false;
    });
  }


  include_agendaFile_in_agendaFileArray() {

    //IF data in agendaFile, then if that data's DocId not present in AgendaFileArray,
    //only then add that data in AgendaFileArray

    let agendaFile_data = { ...this.meetingDocumentArray.agendaFile };
    let doc_id = "";
    if (agendaFile_data) {

      if (agendaFile_data.hasOwnProperty("docId")) {
        doc_id = agendaFile_data.docId;
        if (doc_id) {
          if (this.meetingDocumentArray.agendaFileArray.filter(a => a.docId === doc_id).length == 0) {
            this.meetingDocumentArray.agendaFileArray.push(agendaFile_data);
          }
        }

      }

    }
  }


  uploadDocumentModel(uploadFor) {
    this.typeHasError = false;
    this.fileHasError.msg = "";
    this.fileHasError.state = false;

    // Toggle the collapsible panel - if same panel is clicked, close it; otherwise open the new one
    if (this.openUploadPanel === uploadFor) {
      this.openUploadPanel = '';
    } else {
      this.openUploadPanel = uploadFor;
      // Reset file input when opening a panel
      this.filesToUpload = undefined;
      if (uploadFor !== 'agenda') {
        $(".fileUpload").val("");
      } else {
        // Initialize DataTable for agenda files when panel opens
        setTimeout(() => {
          if (this.meetingDocumentArray.agendaFileArray && this.meetingDocumentArray.agendaFileArray.length > 0) {
            if ($.fn.DataTable.isDataTable('#agendaFilesTable')) {
              $('#agendaFilesTable').DataTable().destroy();
            }
            this.dtTriggerAgendaFiles.next();
            this.attachAgendaFilesRowReorderHandler();
          }
        }, 100);
      }
    }
  }

  fileChangeEvent(fileInput: any) {

    this.typeHasError = false;
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if (checkfile) {
      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput, fileInput)
      if (filenameValidation == "Valid") {
        this.filesToUpload = <Array<File>>fileInput.target.files;
        this.typeHasError = false;
      } else {
        this.alert.error(filenameValidation);
        this.typeHasError = true;
      }

    } else {
      this.typeHasError = true;
      this.alert.error("Invalid file extension");
    }
    fileInput = null;
  }

  fileChangeEventAgenda(fileInput: any) {

    this.filesToUpload = [];
    this.typeHasError = false;
    for (var i = 0; i <= fileInput.target.files.length - 1; i++) {
      var basefilesToUpload = fileInput.target.files[i];
      let fileObj = {
        target: {
          files: [basefilesToUpload]
        }
      }

      var checkfile = this.commonFunction.checkFileExtension(fileObj);
      if (checkfile) {
        var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj, fileInput)
        if (filenameValidation == "Valid") {

          this.filesToUpload.push(basefilesToUpload);
        } else {
          this.alert.error(filenameValidation);
          this.typeHasError = true;
        }
      } else {
        this.alert.error("Invalid file extension");
      }

    }

    fileInput = null;
  }


  deleteDocument(module, documentId) {


    //Applicable for module agenda
    //Since agenda has 2 keys old agendaFile and new AgendaFileArray
    //isDeleteFromAgendaFileRequired flags wether data needs to be deleted from agendaFile old key as well
    //default isDeleteFromAgendaFileRequired true or false data will always be deleted from AgendaFileArray
    //It will remain false for all the other modules
    let isDeleteFromAgendaFileRequired = false;

    if (module == "notice" || module == "draft" || module == "final" || module == "atr") {

      //Deleting the file from the db
      this.meetingService.deleteFromDirectory(documentId, this.g_meetingID, isDeleteFromAgendaFileRequired, module).subscribe(data => {
      });

      //Deleting the file from TS variables
      let resetDocvalues = {
        "name": "File Not Available",
        "isAvaible": false,
        "docId": null,
        "UploadDate": null
      };

      if (module == "notice") { this.meetingDocumentArray.noticeFile = { ...resetDocvalues }; }
      if (module == "draft") { this.meetingDocumentArray.draftFile = { ...resetDocvalues }; }
      if (module == "final") { this.meetingDocumentArray.finalFile = { ...resetDocvalues }; }
      if (module == "atr") { this.meetingDocumentArray.ATRFile = { ...resetDocvalues }; }

    }

    if (module == "agenda") {

      //Deleting file from agendaFileArray-----------------------------------------------------------------
      let mdaAgendaFiles = [...this.meetingDocumentArray.agendaFileArray];
      mdaAgendaFiles = mdaAgendaFiles.filter(file => file.docId != documentId);
      this.meetingDocumentArray.agendaFileArray = mdaAgendaFiles;
      setTimeout(() => {
        if ($.fn.DataTable.isDataTable('#agendaFilesTable')) {
          $('#agendaFilesTable').DataTable().destroy();
        }
        if (this.openUploadPanel === 'agenda' && this.meetingDocumentArray.agendaFileArray.length > 0) {
          this.dtTriggerAgendaFiles.next();
          this.attachAgendaFilesRowReorderHandler();
        }
      }, 100);
      //===================================================================================================

      //Deleting file from agendaFile-----------------------------------------------------------------

      let agendaFile_data = { ...this.meetingDocumentArray.agendaFile };
      let doc_id = "";
      if (agendaFile_data) {
        if (agendaFile_data.hasOwnProperty("docId")) {
          doc_id = agendaFile_data.docId;
          if (doc_id == documentId) {
            agendaFile_data.UploadDate = null;
            agendaFile_data.docId = null;
            agendaFile_data.isAvaible = false;
            agendaFile_data.name = "File Not Available";
            this.meetingDocumentArray.agendaFile = agendaFile_data;
            isDeleteFromAgendaFileRequired = true;
          }
        }
      }
      //===================================================================================================


      this.meetingService.deleteFromDirectory(documentId, this.g_meetingID, isDeleteFromAgendaFileRequired, module).subscribe(data => {
      });

    }


  }

  uploadDocFile(fileFor) {
    let self = this;
    if (this.filesToUpload != undefined) {
      switch (fileFor) {

        case 'notice': {

          if (this.meetingDocumentArray.noticeFile.docId == "" || this.meetingDocumentArray.noticeFile.docId == undefined) {
            this.insertFileIndividuallyInDocument('notice', this.filesToUpload).then(function (response) {
              var response = response.result
              self.meetingDocumentArray.noticeFile.docId = response._id;
              self.meetingDocumentArray.noticeFile.name = response.OriginalFileName;
              self.meetingDocumentArray.noticeFile.isAvaible = true;
              self.meetingDocumentArray.noticeFile.UploadDate = response.CreatedDate;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          } else {
            this.updateFileIndividuallyInDocument(this.meetingDocumentArray.noticeFile.docId, 'notice', this.filesToUpload).then(function (response) {
              var response = response.result
              self.meetingDocumentArray.noticeFile.docId = response._id;
              self.meetingDocumentArray.noticeFile.name = response.OriginalFileName;
              self.meetingDocumentArray.noticeFile.isAvaible = true;
              self.meetingDocumentArray.noticeFile.UploadDate = response.CreatedDate;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          }
          this.filesToUpload = undefined;
          $(".fileUpload").val("");
          this.openUploadPanel = '';
          break;
        }
        case 'draft': {
          if (this.meetingDocumentArray.draftFile.docId == "" || this.meetingDocumentArray.draftFile.docId == undefined) {
            this.insertFileIndividuallyInDocument('draft', this.filesToUpload).then(function (response) {
              var response = response.result;
              self.meetingDocumentArray.draftFile.docId = response._id;
              self.meetingDocumentArray.draftFile.name = response.OriginalFileName;
              self.meetingDocumentArray.draftFile.isAvaible = true;
              self.meetingDocumentArray.draftFile.UploadDate = response.CreatedDate;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          } else {
            this.updateFileIndividuallyInDocument(this.meetingDocumentArray.draftFile.docId, 'draft', this.filesToUpload).then(function (response) {
              var response = response.result
              self.meetingDocumentArray.draftFile.docId = response._id;
              self.meetingDocumentArray.draftFile.name = response.OriginalFileName;
              self.meetingDocumentArray.draftFile.isAvaible = true;
              self.meetingDocumentArray.draftFile.UploadDate = response.CreatedDate;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          }
          this.filesToUpload = undefined;
          $(".fileUpload").val("");
          this.openUploadPanel = '';
          break;
        }
        case 'agenda': {

          //agenda----------------------------------------------------------------------------------------------------------
          this.insertFileIndividuallyInDocumentForPdf('agenda', this.filesToUpload, "").then(function (response) {
            var response = response.result;
            var agendaFileObjectArray: typeof self.meetingDocumentArray.agendaFile[] = [...self.meetingDocumentArray.agendaFileArray];
            for (let x = 0; x < response.length; x++) {
              var agendaFileObject: typeof self.meetingDocumentArray.agendaFile = {};
              agendaFileObject.docId = response[x].Document._id;
              agendaFileObject.name = response[x].Document.OriginalFileName;
              agendaFileObject.isAvaible = true;
              agendaFileObject.UploadDate = response[x].Document.CreatedDate;


              agendaFileObjectArray.push({ ...agendaFileObject });
            }


            self.meetingDocumentArray.agendaFileArray = agendaFileObjectArray;
            //update document Object in meeting.
            self.updateDocOBJInMeetingTable();
            setTimeout(() => {
              if ($.fn.DataTable.isDataTable('#agendaFilesTable')) {
                $('#agendaFilesTable').DataTable().destroy();
              }
              if (self.openUploadPanel === 'agenda' && self.meetingDocumentArray.agendaFileArray.length > 0) {
                self.dtTriggerAgendaFiles.next();
                self.attachAgendaFilesRowReorderHandler();
              }
            }, 100);
            self.openUploadPanel = '';
          });

          //----------------------------------------------------------------------------------------------------------------
          /*
          if (this.meetingDocumentArray.agendaFile.docId == "" || this.meetingDocumentArray.agendaFile.docId == undefined) {
            this.insertFileIndividuallyInDocument('agenda', this.filesToUpload).then(function (response) {
              var response = response.result;
              self.meetingDocumentArray.agendaFile.docId = response._id;
              self.meetingDocumentArray.agendaFile.name = response.OriginalFileName;
              self.meetingDocumentArray.agendaFile.isAvaible = true;
              self.meetingDocumentArray.agendaFile.UploadDate = response.CreatedDate;
              var agendaFileObject = [...self.meetingDocumentArray.agendaFile];
              var agendaFileObjectArray:typeof self.meetingDocumentArray.agendaFile [] = [];
              agendaFileObjectArray.push(agendaFileObject);
              agendaFileObjectArray.push(agendaFileObject);
              self.meetingDocumentArray.agendaFileArray = agendaFileObjectArray;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          } else {
            this.updateFileIndividuallyInDocument(this.meetingDocumentArray.agendaFile.docId, 'agenda', this.filesToUpload).then(function (response) {
              self.meetingDocumentArray.agendaFile.docId = response._id;
              self.meetingDocumentArray.agendaFile.name = response.OriginalFileName;
              self.meetingDocumentArray.agendaFile.isAvaible = true;
              self.meetingDocumentArray.agendaFile.UploadDate = response.CreatedDate;
              //self.meetingDocumentArray.TestUpdateKey = "TestUpdateValue";
              var agendaFileObject = self.meetingDocumentArray.agendaFile;
              var agendaFileObjectArray:typeof self.meetingDocumentArray.agendaFile [] = [];
              agendaFileObjectArray.push(agendaFileObject);
              agendaFileObjectArray.push(agendaFileObject);
              self.meetingDocumentArray.agendaFileArray = agendaFileObjectArray;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          }
          */
          this.filesToUpload = undefined;
          $(".fileUpload").val("");
          break;
        }
        case 'final': {
          if (this.meetingDocumentArray.finalFile.docId == "" || this.meetingDocumentArray.finalFile.docId == undefined) {
            this.insertFileIndividuallyInDocument('final', this.filesToUpload).then(function (response) {
              var response = response.result;
              self.meetingDocumentArray.finalFile.docId = response._id;
              self.meetingDocumentArray.finalFile.name = response.OriginalFileName;
              self.meetingDocumentArray.finalFile.isAvaible = true;
              self.meetingDocumentArray.finalFile.UploadDate = response.CreatedDate;
              self.updateDocOBJInMeetingTable();
            });
          } else {
            this.updateFileIndividuallyInDocument(this.meetingDocumentArray.finalFile.docId, 'final', this.filesToUpload).then(function (response) {
              var response = response.result;
              self.meetingDocumentArray.finalFile.docId = response._id;
              self.meetingDocumentArray.finalFile.name = response.OriginalFileName;
              self.meetingDocumentArray.finalFile.isAvaible = true;
              self.meetingDocumentArray.finalFile.UploadDate = response.CreatedDate;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          }
          this.filesToUpload = undefined;
          $(".fileUpload").val("");
          this.openUploadPanel = '';
          break;
        }
        default: {
          if (this.meetingDocumentArray.ATRFile.docId == "" || this.meetingDocumentArray.ATRFile.docId == undefined) {
            this.insertFileIndividuallyInDocument('ATR', this.filesToUpload).then(function (response) {
              var response = response.result
              self.meetingDocumentArray.ATRFile.docId = response._id;
              self.meetingDocumentArray.ATRFile.name = response.OriginalFileName;
              self.meetingDocumentArray.ATRFile.isAvaible = true;
              self.meetingDocumentArray.ATRFile.UploadDate = response.CreatedDate;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          } else {
            this.updateFileIndividuallyInDocument(this.meetingDocumentArray.ATRFile.docId, 'ATR', this.filesToUpload).then(function (response) {
              var response = response.result

              self.meetingDocumentArray.ATRFile.docId = response._id;
              self.meetingDocumentArray.ATRFile.name = response.OriginalFileName;
              self.meetingDocumentArray.ATRFile.isAvaible = true;
              self.meetingDocumentArray.ATRFile.UploadDate = response.CreatedDate;
              //update document Object in meeting.
              self.updateDocOBJInMeetingTable();
            });
          }
          this.filesToUpload = undefined;
          $(".fileUpload").val("");
          this.openUploadPanel = '';
          break;
        }
      }
    } else {
      // alert("please choose diffrent file.");
      $("#documentFilesUploadDialog").modal('toggle');
      this.alert.error("Can not upload empty file.");
      // this.fileHasError.msg = "Please choose file.";
      // this.fileHasError.state = true;
    }

  }

  downloadAttandanceFile() {
    var token = localStorage.getItem('token')
    if (this.attendanceFile == undefined) {
    } else {
      window.location.href = environment.pssServerUrl + this.downloadAllLink + this.attendanceFile + "/" + token;
    }

  }

  downloadATRFile() {
    var token = localStorage.getItem('token')
    if (this.ATRFile_id == undefined) {
    } else {
      window.location.href = environment.pssServerUrl + this.downloadAllLink + this.ATRFile_id + "/" + token;
    }
  }

  loadDocumentTab() {
    this.meetingService.getMeetingDetails(this.g_meetingID)
      .subscribe((meetingDetails: any) => {
        // console.log(meetingDetails);
        this.AtrDocument = meetingDetails.meetingData[0].AtrDocument[0];
        this.IsATRAvailable = false;
        this.ATRFile_id = undefined;
        if (this.AtrDocument != undefined) {

          this.ATRFile_id = meetingDetails.meetingData[0].AtrDocument[0].atrFile_id;

          if (this.ATRFile_id != undefined) {
            this.IsATRAvailable = true;
          }
          if (meetingDetails.meetingData[0].AtrDocument[0].noticeDate != null) {
            var dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].noticeDate));
            this.documentForm.controls.noticeDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
          }
          if (meetingDetails.meetingData[0].AtrDocument[0].draftDate != null) {
            dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].draftDate));
            this.documentForm.controls.draftDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
          }
          if (meetingDetails.meetingData[0].AtrDocument[0].agendaDate != null) {
            var dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].agendaDate));
            this.documentForm.controls.agendaDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
          }
          if (meetingDetails.meetingData[0].AtrDocument[0].finalDate != null) {
            var dt = new Date(this.setFormatDate(meetingDetails.meetingData[0].AtrDocument[0].finalDate));
            this.documentForm.controls.finalDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
          }

          this.documentForm.controls.noticeTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].noticeTime);
          this.documentForm.controls.agendaTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].agendaTime);
          this.documentForm.controls.draftTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].draftTime);
          this.documentForm.controls.finalTime.setValue(meetingDetails.meetingData[0].AtrDocument[0].finalTime);

        }
      })

  }

  saveDocumentATR() {
    if (this.filesToUpload != undefined) {
      //insert with file
      this.uploadATR();

    } else if (this.ATRFile_id != undefined && this.filesToUpload == undefined) {
      //update without file
      var AtrFile = {
        _id: this.ATRFile_id,
        noticeDate: this.commonFunction.setDate(this.documentForm.controls.noticeDate.value),
        noticeTime: $("#noticeTime").val(),
        draftTime: $("#draftTime").val(),
        draftDate: this.commonFunction.setDate(this.documentForm.controls.draftDate.value),
        agendaDate: this.commonFunction.setDate(this.documentForm.controls.agendaDate.value),
        agendaTime: $("#agendaTime").val(),
        finalDate: this.commonFunction.setDate(this.documentForm.controls.finalDate.value),
        finalTime: $("#finalTime").val(),
      }
      //Update Service Call
      this.meetingService.updateFileInfoToMeetingATR(AtrFile, this.g_meetingID).subscribe(data => {
        if (data.status == 0) {
          this.loadDocumentTab();
          this.alert.success("Document saved successfully.");
        }
      });


    } else {
      //insert without file
      var AtrFileInsert = {
        noticeDate: this.commonFunction.setDate(this.documentForm.controls.noticeDate.value),
        noticeTime: $("#noticeTime").val(),
        draftTime: $("#draftTime").val(),
        draftDate: this.commonFunction.setDate(this.documentForm.controls.draftDate.value),
        agendaDate: this.commonFunction.setDate(this.documentForm.controls.agendaDate.value),
        agendaTime: $("#agendaTime").val(),
        finalDate: this.commonFunction.setDate(this.documentForm.controls.finalDate.value),
        finalTime: $("#finalTime").val(),
      }
      this.meetingService.addFileToMeetingATR(AtrFileInsert, this.g_meetingID).subscribe(data => {
        if (data.status == 0) {
          this.loadDocumentTab();
          this.alert.success("Document saved successfully.");
        }
      });
    }

  }


  uploadATR() {
    var file = this.filesToUpload;

    //Firest time entry to document table
    this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {


      if (this.ATRFile_id == undefined) {
        //adding new document
        var document = {
          "DocumentName": "ATR File - Meeting",
          "DateOfDocument": new Date(),
          "CompletedDate": null,
          "MeetingTypeID": null,
          "ParentDocumentTypeID": null,
          "ParentSubDocumentTypeID": null,
          "DirectorKmp": "None",
          "DirectorID": null,
          "KMPID": null,
          "Remarks": "",
          "Overwrite": false,
          "Filename": this.changedName,
          "OriginalFileName": this.FileOrignalName,
          "FilePath": "D:\\Harrier\\PSSProject\\pss_api\\uploads\\Document_Type\\",
          "CreatedBy": null,
          "CreatedDate": new Date(),
          "LastUpdateFiles": new Date(),
          "ModifiedBy": null,
          "ModifiedDate": null,
        }

        this.meetingService.addATRDocToMeeting(document, this.g_meetingID)
          .subscribe(data => {
            if (data.status == 0) {

              if (this.documentForm.valid) {
                var AtrFile = {
                  noticeDate: this.commonFunction.setDate(this.documentForm.controls.noticeDate.value),
                  noticeTime: $("#noticeTime").val(),
                  draftTime: $("#draftTime").val(),
                  draftDate: this.commonFunction.setDate(this.documentForm.controls.draftDate.value),
                  agendaDate: this.commonFunction.setDate(this.documentForm.controls.agendaDate.value),
                  agendaTime: $("#agendaTime").val(),
                  finalDate: this.commonFunction.setDate(this.documentForm.controls.finalDate.value),
                  finalTime: $("#finalTime").val(),
                  atrFile_id: data.MeetingData._id
                }
                this.meetingService.addFileToMeetingATR(AtrFile, this.g_meetingID).subscribe(data => {
                  if (data.status == 0) {
                    this.alert.success("Document saved successfully.");
                  }
                });

              }


            }
          });

      } else {
        var newDocumentManagement = {
          _id: this.ATRFile_id,
          Upload: this.changedName,
          OriginalFileName: this.FileOrignalName
        }
        this.meetingService.updateDocumentOnly(newDocumentManagement)
          .subscribe(data => {
            if (data.status == 0) {
              this.alert.success("ATR file updated successfully.");
            }
          });
      }
    });


  }


  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        this.agendaDocName = files[i].name.replace(',', '');
        var name = now + '-' + files[i].name.replace(',', '');
        // name = name.replace('(', '');
        // name = name.replace(')', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        // this.FileOrignalName = name;
        this.FileOrignalName = files[i].name.replace(',', '');

        this.changedName = name;
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      var token = localStorage.getItem('token')

      xhr.open("POST", url, true);
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  insertFileIndividuallyInDocument(fileFor, file): Promise<any> {
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: this.titleOnAddUpdate + '- Documents-' + Date.now(),
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: this.g_meetingTypeID,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        return this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .toPromise().then(res => {

            return Promise.resolve(res);
          })
      }
    })
  }

  makeFileRequest2(url: string, params: Array<string>, files: Array<File>, fileFor, type) {
    var pdfArray = [];
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        // name = name.replace('(', '');
        // name = name.replace(')', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        // this.FileOrignalName = name;
        this.FileOrignalName = files[i].name.replace(',', '');

        this.changedName = name;
        // this.changedName = now + '-' + files[i].name.replace(',', '');

        var documentManagement = {
          "DocumentManagement": {
            DocumentName: this.titleOnAddUpdate + '- Documents-' + Date.now() + fileFor + ' ' + type + ' - ' + this.FileOrignalName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: this.g_meetingTypeID,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }

        pdfArray.push(documentManagement);
        this.pdfArray1.push(documentManagement);

      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(pdfArray);
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  insertFileIndividuallyInDocumentForPdf(fileFor, file, type): Promise<any> {
    return this.makeFileRequest2(environment.pssServerUrl + "documentManagement/fileUpload/", [], file, fileFor, type).then((result) => {
      if (result) {
        var documentManagement;
        return this.documentManagementMasterService.addMultiplePdfDocuments(result)
          .toPromise().then(res => { return Promise.resolve(res); })
      }
    })
  }

  updateFileIndividuallyInDocument(docId, fileFor, file): Promise<any> {

    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {

        var documentUpdate = {
          DocumentName: this.titleOnAddUpdate + '- Documents-' + fileFor,
          Upload: this.changedName,
          OriginalFileName: this.FileOrignalName

        }
        return this.documentManagementMasterService.updateDocumentManagementInMeeting(documentUpdate, docId)
          .toPromise().then(res => {
            return Promise.resolve(res);
          })

      }
    })
  }

  updatePdfFileIndividuallyInDocument(docId, fileFor, file, type): Promise<any> {

    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {

        var documentUpdate = {
          DocumentName: this.titleOnAddUpdate + '- Documents-' + fileFor + ' ' + type,
          Upload: this.changedName,
          OriginalFileName: this.FileOrignalName

        }
        return this.documentManagementMasterService.updateDocumentManagementInMeeting(documentUpdate, docId)
          .toPromise().then(res => {
            return Promise.resolve(res);
          })

      }
    })
  }

  saveAgendaFilesOrder() {
    this.updateDocOBJInMeetingTable();
  }

  attachAgendaFilesRowReorderHandler() {
    var self = this;
    var attempts = 0;
    var maxAttempts = 40;

    var checkAndAttach = setInterval(() => {
      attempts++;
      if ($.fn.DataTable.isDataTable('#agendaFilesTable')) {
        clearInterval(checkAndAttach);
        var agendaFilesTable = $("#agendaFilesTable").DataTable();
        agendaFilesTable.off('row-reorder');
        agendaFilesTable.on('row-reorder', (e, newOrderDataList, changes) => {
          var reorderedFiles = [];
          for (let i = 0; i < newOrderDataList.length; i++) {
            var oldPosition = newOrderDataList[i].oldPosition;
            if (self.meetingDocumentArray.agendaFileArray && self.meetingDocumentArray.agendaFileArray[oldPosition]) {
              reorderedFiles.push(self.meetingDocumentArray.agendaFileArray[oldPosition]);
            }
          }
          if (reorderedFiles.length > 0) {
            self.meetingDocumentArray.agendaFileArray = reorderedFiles;
            self.saveAgendaFilesOrder();
          }
        });
      } else if (attempts >= maxAttempts) {
        clearInterval(checkAndAttach);
        console.warn('Agenda files table not ready after maximum attempts');
      }
    }, 50);
  }

  updateDocOBJInMeetingTable() {
    this.meetingService.updateDocumentInMeeting(this.meetingDocumentArray, this.g_meetingID)
      .subscribe(data => {
        if (data.status == 0) {
          if ($("#documentFilesUploadDialog").is(":visible")) {
            $("#documentFilesUploadDialog").modal('hide');
          }
          if ($("#documentSubtabAgendaUploadDialog").is(":visible")) {
            $("#documentSubtabAgendaUploadDialog").modal('hide');
          }

          this.alert.success(data.message);
        }
      })

  }

  downloadFile(downloadingFileID) {
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + this.downloadAllLink + downloadingFileID + "/" + token;
  }

  getInCorpDate() {
    this.dateOfIncorpOfCompany = "";
    this.committeeService.getInCorpDateOfCompany().subscribe(companyDateOfIncorp => {
      if (companyDateOfIncorp.CompanyDetails) {
        let dt = new Date(this.commonFunction.setFormatDate(companyDateOfIncorp.CompanyDetails[0].DateOfIncorporation))
        this.dateOfIncorpOfCompany = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      }
    })
  }

  EditTask(taskId) {
    localStorage.setItem('fromMeeting', this.g_meetingID);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['tasks', 'activated', 'update', taskId] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/tasks/activated/update/', taskId]);
  }

  disableControls(editPermission: boolean) {
    if (!editPermission && environment.PSS == false) {
      this.addmeetingForm.controls.SigningNoticePlace.disable();
      this.addmeetingForm.controls.MeetingNumber.disable();
      this.addmeetingForm.controls.MeetingDate.disable();
      this.addmeetingForm.controls.EmailID.disable();
      this.addmeetingForm.controls.MeetingTime.disable();
      this.addmeetingForm.controls.MeetingPlace.disable();
      this.addmeetingForm.controls.IssueNoticeDueDate.disable();
      this.addmeetingForm.controls.NoticeSignatoryName.disable();
      this.addmeetingForm.controls.ContactNumber.disable();
      this.addmeetingForm.controls.NoticeSignatoryDesignation.disable();
      this.addmeetingForm.controls.DinNumber.disable();
      this.addmeetingForm.controls.SigningNoticeDate.disable();
      this.addmeetingForm.controls.Process.disable();
      this.addmeetingForm.controls.Category.disable();
    }
  }


  clearMeetingDetails() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['meeting'] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/meeting']);
  }



  checkMeetingEndTime(event) {
    this.meetingEndTime = $('#meetingEndTime').val();
    if (this.meetingHeld == "No") {
      this.adjournedClicked('No')
      if ((this.meetingStartTime == "" || this.meetingStartTime == undefined) && (this.meetingEndTime == "" || this.meetingEndTime == undefined)) {
        this.madeAttendanceButtonValidInvalid = false;
      } else {
        this.madeAttendanceButtonValidInvalid = true;
      }
      this.MeetingtimeCheack = false;
    }
    else if (this.meetingHeld == "Yes") {
      this.adjournedClicked('Yes')
      if ((this.meetingStartTime == "" || this.meetingStartTime == undefined) || (this.meetingEndTime == "" || this.meetingEndTime == undefined)) {
        this.madeAttendanceButtonValidInvalid = true;
      } else {
        this.madeAttendanceButtonValidInvalid = false;
      }
      this.validateMeetingHeldTime();
    }



  }


  adjournedClicked(varData) {

    // this.meetingAdjValidation = false;
    if (varData == 'ADJ') {
      this.adjFlag = true;
      this.flagSetToNo = false;
      this.flagSetToYes = false;
      $("#meetingStartTime").val("");
      $("#meetingEndTime").val("");
      this.meetingStartTime = "";
      this.meetingEndTime = "";
      this.madeAttendanceButtonValidInvalid = false;
      this.MeetingtimeCheack = false;

    } else if (varData == 'Yes') {
      this.meetingAdjValidation = false;
      this.adjFlag = false;
      $("#meetingADJTime").val("");
      this.meetimeADJDate = null
      this.flagSetToYes = true;
      this.flagSetToNo = false;
      if ((this.meetingStartTime == "" || this.meetingStartTime == undefined) || (this.meetingEndTime == "" || this.meetingEndTime == undefined)) {
        this.madeAttendanceButtonValidInvalid = true;
      } else {
        this.madeAttendanceButtonValidInvalid = false;
      }
      this.validateMeetingHeldTime();
    }
    else if (varData == 'No') {
      this.meetingAdjValidation = false;
      this.adjFlag = false;
      this.meetimeADJDate = null
      $("#meetingADJTime").val("");
      this.flagSetToYes = false;
      this.flagSetToNo = true;
      $("#meetingStartTime").val("");
      $("#meetingEndTime").val("");
      this.meetingStartTime = "";
      this.meetingEndTime = "";

      if ((this.meetingStartTime == "" || this.meetingStartTime == undefined) || (this.meetingEndTime == "" || this.meetingEndTime == undefined)) {
        this.madeAttendanceButtonValidInvalid = false;
      } else {
        this.madeAttendanceButtonValidInvalid = true;
      }
      this.MeetingtimeCheack = false;
    }

  }

  checkMeetingStartTime(event) {
    this.meetingStartTime = $('#meetingStartTime').val();
    if (this.meetingHeld == "No") {
      this.adjournedClicked('No')
      if ((this.meetingStartTime == "" || this.meetingStartTime == undefined) && (this.meetingEndTime == "" || this.meetingEndTime == undefined)) {
        this.madeAttendanceButtonValidInvalid = false;
      } else {
        this.madeAttendanceButtonValidInvalid = true;
      }
      this.MeetingtimeCheack = false;
    }
    else if (this.meetingHeld == "Yes") {
      this.adjournedClicked('Yes')
      if ((this.meetingStartTime == "" || this.meetingStartTime == undefined) || (this.meetingEndTime == "" || this.meetingEndTime == undefined)) {
        this.madeAttendanceButtonValidInvalid = true;
      } else {
        this.madeAttendanceButtonValidInvalid = false;
      }
      this.validateMeetingHeldTime();
    }


  }

  validateMeetingHeldTime() {
    if ((this.meetingStartTime != undefined || this.meetingStartTime != "") && (this.meetingEndTime != undefined || this.meetingStartTime != "")) {
      var startTime = moment(this.meetingStartTime, ["h:mm A"]);
      var endTime = moment(this.meetingEndTime, ["h:mm A"]);

      if (startTime < endTime) {
        this.MeetingtimeCheack = false;

      } else {
        this.MeetingtimeCheack = true;

      }
    }
  }


  checkCategory(ev, category) {

    let allCategoryFlag = true;
    this.selectedAllCategory = false;
    if (ev.target.checked == true) {
      this.cheackCategory = true;
      for (var i = 0; i < this.categoryPopupArray.length; i++) {
        if (category._id == this.categoryPopupArray[i]._id) {
          this.categoryPopupArray[i].IsSelectedCategory = true;
        }
      }
    }
    else {
      for (var i = 0; i < this.categoryPopupArray.length; i++) {
        if (category._id == this.categoryPopupArray[i]._id) {
          this.categoryPopupArray[i].IsSelectedCategory = false;
        }
      }
      this.cheackCategory = false
      for (var i = 0; i < this.categoryPopupArray.length; i++) {
        if (this.categoryPopupArray[i].IsSelectedCategory) {
          this.cheackCategory = true;
        }
      }

    }

    var allSearchedSelectedCategory = true;
    if (_.size(this.categoryPopupArray)) {
      for (var i = 0; i < this.categoryPopupArray.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataCategory.length; j++) {
          if (this.searcheFilteredDataCategory[j] == this.categoryPopupArray[i]._id) {
            if (this.categoryPopupArray[i].IsSelectedCategory) {
            } else {
              allSearchedSelectedCategory = false;
            }
          }
        }
      }
    }

    if (allSearchedSelectedCategory) {
      this.selectedAllCategory = true;
    } else {
      this.selectedAllCategory = false;
    }

  }


  checkAllCategory(ev) {
    if (ev.target.checked == true) {
      for (var i = 0; i < this.categoryPopupArray.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataCategory.length; j++) {
          if (this.searcheFilteredDataCategory[j] == this.categoryPopupArray[i]._id) {
            this.categoryPopupArray[i].IsSelectedCategory = true;
            this.cheackCategory = true;
            this.selectedAllCategory = true;
          }
        }
      }
    } else {
      this.cheackCategory = true;
      this.selectedAllCategory = false;
      this.categoryPopupArray.forEach(element => {
        element.IsSelectedCategory = false;
      });
    }
  }
  createCategoryPopupArray(category) {

    var categoryData = category.categoryList;

    categoryData.forEach(element => {

      var index = _.findIndex(this.AgendaCategory, function (o) {

        return _.get(o, 'categoryID') == element._id;
      });

      if (index == -1) {
        this.categoryPopupArray.push(element);
      }
    });

  }

  getSelectedCategories() {
    this.categoryPopupArray.forEach(element => {
      element.IsSelectedCategory = false;
    });
    this.commonFunction.sortByKey(this.categoryPopupArray, "CategoryName");
    this.dtTriggerOfCategoryPopup.next();
    setTimeout(() => {
      $("#categoryTablePopup").DataTable().columns.adjust().draw();
    }, 300);
  }

  addCategoryPopup() {
    this.categoryPopupArray = [];
    $("#categoryTablePopup").DataTable().destroy();
    if (this.PSSMasterMeetingTypeID != undefined) {
      this.meetingService.getPredefinedCommitteeCategoryByMeetingType(this.g_meetingTypeID)
        .subscribe(category => {
          if (category.status == 0) {
            this.createCategoryPopupArray(category);
          }
          this.getSelectedCategories();
        });
    } else {
      this.meetingService.getCategoryByMeetingType(this.g_meetingTypeID)
        .subscribe(category => {
          if (category.status == 0) {
            this.createCategoryPopupArray(category);
          }
          this.getSelectedCategories();
        });
    }

    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#categoryDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#categoryDialog').modal('show');
    }, 100);

  }

  indexOfElementCategoryArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {

      return o.categoryID == elementValue._id;
    })

  }

  addSelectedCategory() {
    this.loading1 = true;
    this.disabledOnclick = true;
    $("#categoryDialog").modal('toggle');
    var selectedCategoryData = [];
    this.cheackCategory = false;
    for (var i = 0; i < this.categoryPopupArray.length; i++) {
      if (this.categoryPopupArray[i].IsSelectedCategory) {
        var data = {
          'categoryID': this.categoryPopupArray[i]._id,
          'CategoryName': this.categoryPopupArray[i].CategoryName,
          'IsGlobal': this.categoryPopupArray[i].IsGlobal,
          'IsActive': this.categoryPopupArray[i].IsActive
        }

        selectedCategoryData.push(data);
      }
    }
    this.meetingService.getAgendasBeHalfOfCategory(selectedCategoryData).subscribe(agendaData => {
      this.disabledOnclick = false;
      if (agendaData.status == 0) {
        var bothData = {
          agendaOnCategory: agendaData.result,
          CategoryData: selectedCategoryData
        }
        this.meetingService.addCategoryAndAgendaInMeeting(bothData, this.g_meetingID)
          .subscribe(data => {
            this.disabledOnclick = false;
            if (data.status == 0) {

              this.categoryArray = [];
              this.agendaArray = [];
              this.loading1 = false;
              this.alert.success("Category Saved Successfully, and Agenda Related to category added to meeting Successfully.");
              $("#addingCategoryTable").DataTable().destroy();
              $("#agendaTable").DataTable().destroy();
              $("#agendaNewTable").DataTable().destroy();

              this.AgendaCategory = data.result[0].Category;
              this.agendaArray = _.sortBy(data.result[0].Agenda, ["Agendaorder"]);
              // let filterData = this.newAgendaArray.filter((x:any)=>x.disabled == false);
              // this.tempArray=filterData
              this.newAgendaArray = this.agendaArray.map(enhanchArr);
              this.newAgendaArray.push(...this.tempArray)

              this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
                return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
              });
              this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
              this.dtTriggerOfCategory.next();
              this.dtTriggerAgenda.next();
              this.dtTriggerAgendaNew.next()
              this.transferToGemArray = [];
              $("#transferToGemTable").DataTable().destroy();
              this.transferToGemArray = _.sortBy(data.result[0].Agenda, ["Agendaorder"]);
              this.dtTriggerOfTransferToGem.next();
              $("#agendaAccessTable").DataTable().destroy();
              this.agendaAccessArray = data.result[0].AgendaAccessRights;
              this.dtTriggerAgendaAccess.next();
              this.getActivatedTaskList();
              this.cheackCategory = true;
            } else {
              this.loading1 = false;
              this.alert.error('Oops, Something went wrong.')
            }
          });
      } else {
        this.loading1 = false;
        this.alert.error('Oops, Something went wrong.')
      }
    })
    // $('.btn.btn-primary').off('click').on('click', () => {
    //   $('#success-alert2').modal('hide');
    //   $('.modal-backdrop').remove();
    //   $('body').removeClass('modal-open');
    // });
  }

  categoryDeleteConFirmation(category) {
    this.category = category;
    $("#categoryDelete").modal('toggle');
  }

  categoryDelete() {
    this.meetingService.deleteCategoryFromMeeting(this.category, this.g_meetingID)
      .subscribe(data => {
        if (data.status == 0) {
          $("#categoryDelete").modal('toggle');
          this.categoryArray = [];
          this.agendaArray = [];

          $("#addingCategoryTable").DataTable().destroy();
          $("#agendaTable").DataTable().destroy();
          $("#agendaNewTable").DataTable().destroy();

          this.AgendaCategory = data.result[0].Category;
          // this.agendaArray = data.result[0].Agenda;
          this.agendaArray = _.sortBy(data.result[0].Agenda, ["Agendaorder"]);
          // let filterData = this.newAgendaArray.filter((x:any)=>x.disabled == false);
          // this.tempArray=filterData
          this.newAgendaArray = this.agendaArray.map(enhanchArr);
          this.newAgendaArray.push(...this.tempArray)

          this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
            return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
          });
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
          this.dtTriggerOfCategory.next();
          this.dtTriggerAgenda.next();
          this.dtTriggerAgendaNew.next()
          this.transferToGemArray = [];
          var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
          transferToGemTable.destroy();
          this.transferToGemArray = data.result[0].Agenda;
          for (var index = 0; index < this.transferToGemArray.length; index++) {
            this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
          }
          this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
          this.dtTriggerOfTransferToGem.next();
          $("#agendaAccessTable").DataTable().destroy();
          this.agendaAccessArray = data.result[0].AgendaAccessRights;
          this.dtTriggerAgendaAccess.next();
          this.alert.success("Category Deleted Successfully, and Agenda Related to category removed from meeting Successfully.");
          this.getActivatedTaskList();
          this.loadMeetingDetails(this.g_meetingID);
        }
      })
  }

  //----------------------Send Notification Function----------------------------------------------

  sendNoticationForNotice() {

    let userInformation = {
      Invitees: this.meetingDataObject[0].Invitees,
      Members: this.meetingDataObject[0].Members,
      Directors: [],
      CreatedBy: this.meetingDataObject[0].CreatedBy
    }
  }

  sendNoticationForAgenda() {
    let userInformation = {
      Invitees: this.meetingDataObject[0].Invitees,
      Members: this.meetingDataObject[0].Members,
      Directors: []
    }
  }

  sendNoticationForDraft() {
    let userInformation = {
      Invitees: this.meetingDataObject[0].Invitees,
      Members: this.meetingDataObject[0].Members,
      Directors: []
    }
  }

  sendNoticationForFinal() {
    let userInformation = {
      Invitees: this.meetingDataObject[0].Invitees,
      Members: this.meetingDataObject[0].Members,
      Directors: []
    }
  }

  sendNoticationForATR() {
    let userInformation = {
      Invitees: this.meetingDataObject[0].Invitees,
      Members: this.meetingDataObject[0].Members,
      Directors: []
    }
  }

  sendNotification(type) {
    // UserGovevaId is present in the member
    // Invitees don't have UserGovevaId
    this.notifyresponse = true;
    const self = this;
    let meetingTypeObject = _.find(self.meetingTypes, function (type) { return type == self.meetingDataObject[0].MeetingTypeID })
    let govevaUserIdArray = this.Members.map(function (memberObeject) {
      return memberObeject.UserGovevaId
    })
    let atrDocumentCopy = this.meetingDataObject[0].AtrDocument;
    if (_.size(atrDocumentCopy)) {
      atrDocumentCopy = atrDocumentCopy[0]
    } else {
      atrDocumentCopy = {
        noticeDate: '',
        noticeTime: '',
        agendaDate: '',
        agendaTime: '',
        draftDate: '',
        draftTime: '',
        finalDate: '',
        finalTime: '',
        agendaArray: [],
        allAgendas: []
      }
    }
    switch (type) {
      case 'Notice':
        atrDocumentCopy.noticeDate = this.commonFunction.setDate({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
        atrDocumentCopy.noticeTime = _.toString(moment().format('LT'));
        atrDocumentCopy.isNoticeNotify = true;
        break;
      case 'Agenda':
        atrDocumentCopy.agendaDate = this.commonFunction.setDate({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
        atrDocumentCopy.agendaTime = _.toString(moment().format('LT'))
        atrDocumentCopy.isAgendaNotify = true;
        break;
      case 'Draft':
        atrDocumentCopy.draftDate = this.commonFunction.setDate({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
        atrDocumentCopy.draftTime = _.toString(moment().format('LT'))
        atrDocumentCopy.isDraftNotify = true;
        break;
      case 'Final':
        atrDocumentCopy.finalDate = this.commonFunction.setDate({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
        atrDocumentCopy.finalTime = _.toString(moment().format('LT'))
        atrDocumentCopy.isFinalNotify = true;
        break;
      case 'TransferToGem':
        atrDocumentCopy.agendaDate = '';
        atrDocumentCopy.agendaTime = ''
        atrDocumentCopy.isAgendaNotify = false;
        atrDocumentCopy.agendaArray = this.transferToGemSelectedAgenda;
        atrDocumentCopy.allAgendas = this.clonedAgendaArray;
        break;
      default:
        atrDocumentCopy.isATRNotify = true;
    }
    let informationAndType = {
      Type: type,
      Invitees: this.Invitees,
      GovevaIdOfMembers: govevaUserIdArray,
      Directors: this.Directors,
      CreatedBy: this.meetingDataObject[0].CreatedBy, //getInfo from localStorage
      URL: environment.MeetingMailURL + this.g_meetingID + '/' + JSON.parse(localStorage.getItem("companyDetails")).companyID + ')',
      Venue: this.addmeetingForm.controls.MeetingPlace.value,
      Time: this.addmeetingForm.controls.MeetingTime.value,
      Date: this.addmeetingForm.controls.MeetingDate.value,
      MeetingType: this.MeetingTypeName,
      MeetingId: this.meetingDataObject[0]._id,
      AtrDocument: atrDocumentCopy
    }

    this.meetingService.sendNotifcationToUsers(informationAndType).subscribe(responseForNotification => {
      this.notifyresponse = false;
      this.transferToGemSelectedAgenda = []
      if (!responseForNotification.status) {

        this.meetingDataObject[0].AtrDocument = responseForNotification.meetingRecord.AtrDocument
        if (type == 'Notice') {
          let splitNoticeDate = new Date(responseForNotification.meetingRecord.AtrDocument[0].noticeDate)
          this.documentForm.controls.noticeDate.setValue({ year: splitNoticeDate.getFullYear(), month: splitNoticeDate.getMonth() + 1, day: splitNoticeDate.getDate() })
          this.documentForm.controls.noticeTime.setValue(responseForNotification.meetingRecord.AtrDocument[0].noticeTime);
          this.isNoticeNotify = true
        }
        if (type == 'Agenda') {
          let agendaDate = new Date(responseForNotification.meetingRecord.AtrDocument[0].agendaDate)
          this.documentForm.controls.agendaDate.setValue({ year: agendaDate.getFullYear(), month: agendaDate.getMonth() + 1, day: agendaDate.getDate() })
          this.documentForm.controls.agendaTime.setValue(responseForNotification.meetingRecord.AtrDocument[0].agendaTime);
          this.isAgendaNotify = true
        }
        if (type == 'Draft') {
          let draftDate = new Date(responseForNotification.meetingRecord.AtrDocument[0].draftDate)
          this.documentForm.controls.draftDate.setValue({ year: draftDate.getFullYear(), month: draftDate.getMonth() + 1, day: draftDate.getDate() })
          this.documentForm.controls.draftTime.setValue(responseForNotification.meetingRecord.AtrDocument[0].draftTime);
          this.isDraftNotify = true;
        }
        if (type == 'Final') {
          let finalDate = new Date(responseForNotification.meetingRecord.AtrDocument[0].finalDate)
          this.documentForm.controls.finalDate.setValue({ year: finalDate.getFullYear(), month: finalDate.getMonth() + 1, day: finalDate.getDate() })
          this.documentForm.controls.finalTime.setValue(responseForNotification.meetingRecord.AtrDocument[0].finalTime);
          this.isFinalNotify = true;
        }
        if (type == 'ATR') {
          this.isATRNotify = true;
        }
        this.alert.success(responseForNotification.message);
      }
      else {
        this.alert.error(responseForNotification.message);
      }
    })
  }






  getActiveTab() {
    this.IsMeetingDetailsActive = this.currentURL.search('MeetingDetails');
    this.IsCategoryTabActive = this.currentURL.search('Category');
    this.IsAgendaTabActive = this.currentURL.search('Agenda');
    this.IsComplianceTabActive = this.currentURL.search('Compliance');
    this.IsDirectorsTabActive = this.currentURL.search('Directors');
    this.IsInviteesTabActive = this.currentURL.search('Invitees');
    this.IsMembersTabActive = this.currentURL.search('Members');
    this.IsAttendanceTabActive = this.currentURL.search('Attendance');
    this.IsDocumentStampGeneratorTabActive = this.currentURL.search('DocumentStampGenerator');
    this.IsTransferToGemTabActive = this.currentURL.search('TransferToGemTab');
    this.IsVotingResultsTabActive = this.currentURL.search('VotingResults');
    this.votingResultsActive = '';

    if (this.tabValue == 'MeetingDetails') {
      this.IsMeetingDetailsActive = true;
      this.meetingActive = 'active';
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
    } else if (this.tabValue == 'Category') {
      this.IsCategoryTabActive = true;
      this.meetingActive = "";
      this.categoryActive = 'active';
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
    } else if (this.tabValue == 'Agenda') {
      this.IsAgendaTabActive = true;
      this.meetingActive = "";
      this.categoryActive = "";
      this.agendaActive = 'active';
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
      setTimeout(() => {
        $("#agendaTable").DataTable().columns.adjust().draw();
      }, 1000);
    } else if (this.tabValue == 'Auto Bookmark') {
      this.IsAgendNewTabActive = true;
      this.meetingActive = "";
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = 'active';
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
      setTimeout(() => {
        $("#agendaNewTable").DataTable().columns.adjust().draw();
      }, 1000);
    }
    else if (this.tabValue == 'Compliance') {
      this.IsComplianceTabActive = true;
      this.meetingActive = "";
      this.agendaNewActive = "";
      this.categoryActive = "";
      this.agendaActive = "";
      this.complianceActive = 'active';
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
    } else if (this.tabValue == 'Directors') {
      this.IsDirectorsTabActive = true;
      this.meetingActive = "";
      this.categoryActive = "";
      this.agendaActive = "";
      this.complianceActive = "";
      this.agendaNewActive = "";
      this.directorActive = 'active';
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
    } else if (this.tabValue == 'Invitees') {
      this.IsInviteesTabActive = true;
      this.meetingActive = "";
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = 'active';
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
    } else if (this.tabValue == 'Members') {
      this.IsMembersTabActive = true;
      this.meetingActive = '';
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = 'active';
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
    } else if (this.tabValue == 'Attendance') {
      this.IsAttendanceTabActive = true;
      this.meetingActive = '';
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = 'active';
      this.documentActive = "";
      this.transferToGemActive = "";
      this.docketsActive = "";
    } else if (this.tabValue == 'DocumentStampGenerator') {
      this.IsDocumentStampGeneratorTabActive = true;
      this.meetingActive = "";
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = 'active';
    } else if (this.tabValue == 'Docket') {
      this.IsDocumentStampGeneratorTabActive = true;
      this.meetingActive = "";
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = '';
      this.docketsActive = 'active';
    } else if (this.tabValue == 'TransferToGemTab') {
      this.IsTransferToGemTabActive = true;
      this.meetingActive = '';
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
      this.transferToGemActive = 'active';
      this.docketsActive = "";
    } else if (this.tabValue == 'VotingResults') {
      this.IsVotingResultsTabActive = true;
      this.meetingActive = '';
      this.categoryActive = '';
      this.agendaActive = '';
      this.agendaNewActive = '';
      this.complianceActive = '';
      this.directorActive = '';
      this.invitteeActive = '';
      this.memberActive = '';
      this.attendanceActive = '';
      this.documentActive = '';
      this.transferToGemActive = '';
      this.docketsActive = '';
      this.votingResultsActive = 'active';
    }
    else {
      this.IsMeetingDetailsActive = true;
      this.meetingActive = 'active';
      this.categoryActive = "";
      this.agendaActive = "";
      this.agendaNewActive = "";
      this.complianceActive = "";
      this.directorActive = "";
      this.invitteeActive = "";
      this.memberActive = "";
      this.attendanceActive = "";
      this.documentActive = "";
    }
  }
  EditTask1(taskId) {
    setTimeout(() => {
      // $('#success-alert2').modal('hide');
      // $('.modal-backdrop').remove();
      // $('body').removeClass('modal-open');
      this.disabledOnclick = false;
      this.ngZone.run(() => {
        this.router.navigate([{ outlets: { 'structure-outlet': ['addMeetings', 'edit', taskId] } }],
          { relativeTo: this.route.parent }
        );
      });
    }, 700);

  }
  backToMeetingsPage() {
    setTimeout(() => {
      // $('#success-alert2').modal('hide');
      // $('.modal-backdrop').remove();
      // $('body').removeClass('modal-open');
      this.disabledOnclick = false;
      this.ngZone.run(() => {
        this.router.navigate(
          [{ outlets: { 'structure-outlet': ['meeting'] } }],
          { relativeTo: this.route.parent }
        );
      });
    }, 700);
  }

  back() {
    // var fromMeeting = localStorage.getItem('fromMeeting')
    // this.router.navigate(['/meeting']);
    this.addmeetingForm.reset();
    this.ngOnInit();

    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['meeting'] } }],
      { relativeTo: this.route.parent });
    // this.location.back(); 
  }


  inviteeGovevaMemberSelectBox: any;
  invitteeListFromGovevea: any = [];
  isAddExistingInvitteeValid: boolean;

  getMembersFromGovevaForInvitee() {
    this.isAddExistingInvitteeValid = false
    this.invitteeListFromGovevea = [];
    this.inviteeForm.reset();
    this.inviteeForm.controls.Address.enable();
    this.inviteeForm.controls.City.enable();
    this.inviteeForm.controls.State.enable();
    this.inviteeForm.controls.TelO.enable();
    this.inviteeForm.controls.TelR.enable();
    this.inviteeForm.controls.FaxNo.enable();
    this.inviteeForm.controls.InAttendance.enable();
    this.inviteeGovevaMemberSelectBox = 'null';
    this.inviteeForm.controls.InviteeName.disable();
    this.inviteeForm.controls.Designation.disable();
    this.inviteeForm.controls.MobileNo.disable();
    this.inviteeForm.controls.EmailId.disable();
    this.inviteeForm.controls.InAttendance.setValue('Special Invitee');
    this.inviteeForm.controls.ThroughVC.setValue('No');
    if (this.MeetingTypeName == 'Board' || this.MeetingTypeName == 'Independent Directors' || this.MeetingTypeName == 'Annual General Meeting' || this.MeetingTypeName == 'Extraordinary General Meeting' || this.MeetingTypeName == 'Postal Ballot' || this.MeetingTypeName == 'Others') {

      if (this.MeetingTypeName == 'Board') {
        this.inviteeForm.controls.InAttendance.enable();
      } else {
        this.inviteeForm.controls.InAttendance.disable();
      }

      this.committeeService.getMembersFromGoveva().subscribe(members => {
        if (members.status == 0) {
          this.invitteeListFromGovevea = members.userList
          var other = _.concat(this.Invitees, this.Members);
          if (other != null) {
            var ids = new Set(other.map(({ EmailId }) => EmailId));
            this.invitteeListFromGovevea = this.invitteeListFromGovevea.filter(({ EmailId }) => !ids.has(EmailId));
          }
        } else {
          this.invitteeListFromGovevea = []
        }
      });

    } else {
      this.inviteeForm.controls.InAttendance.setValue('Special Invitee');
      this.inviteeForm.controls.InAttendance.disable();
      for (var index = 0; index < this.Directors.length; index++) {
        this.Directors[index].EmailId = this.Directors[index].EmailID
      }
      this.committeeService.getUsersFromGovevaForInvittee().subscribe(members => {
        if (members.status == 0) {
          this.invitteeListFromGovevea = members.result
          var other = _.concat(this.Invitees, this.Members, this.Directors);
          if (other != null) {
            var ids = new Set(other.map(({ EmailId }) => EmailId));
            this.invitteeListFromGovevea = this.invitteeListFromGovevea.filter(({ EmailId }) => !ids.has(EmailId));
          }
          for (var i = 0; i < this.invitteeListFromGovevea.length; i++) {
            this.invitteeListFromGovevea[i].FullName = this.invitteeListFromGovevea[i].FirstName + ' ' + this.invitteeListFromGovevea[i].LastName
          }
        } else {
          this.invitteeListFromGovevea = []
        }
      });
    }
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#existingInviteeDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#existingInviteeDialog').modal('show');
    }, 100);


  }

  selectMemberFromInvittee(event) {
    var id = event.target.value;
    if (id == null || id == undefined || id == 'null') {
      this.inviteeForm.reset();
      this.inviteeForm.controls.InAttendance.setValue('No');
      this.inviteeForm.controls.ThroughVC.setValue('No');
    } else {
      this.invitteeListFromGovevea.forEach(element => {
        if (element._id == id) {
          this.isAddExistingInvitteeValid = true;
          this.inviteeForm.controls.InviteeName.setValue(element.FullName ? element.FullName : element.Title + '' + element.FirstName + ' ' + element.LastName);
          this.inviteeForm.controls.Designation.setValue(element.Designation);
          this.inviteeForm.controls.MobileNo.setValue(element.MobileNumber);
          this.inviteeForm.controls.EmailId.setValue(element.EmailId);
          this.inviteeForm.controls.GovevaUserId.setValue(element._id);
        }
      })
    }
  }

  // saveInviteeForGoveva() {
  //   this.disabledOnclick = true;
  //   if (this.inviteeForm.valid) {
  //     this.inviteeForm.controls.InviteeName.enable();
  //     this.inviteeForm.controls.Designation.enable();
  //     this.inviteeForm.controls.MobileNo.enable();
  //     this.inviteeForm.controls.EmailId.enable();
  //     console.log("Form Data Before Save:", this.inviteeForm.getRawValue());
  //     var invityMember = {
  //       InviteeName: this.inviteeForm.controls.InviteeName.value,
  //       Designation: this.inviteeForm.controls.Designation.value,
  //       Address: this.inviteeForm.controls.Address.value,
  //       City: this.inviteeForm.controls.City.value,
  //       State: this.inviteeForm.controls.State.value,
  //       TelO: this.inviteeForm.controls.TelO.value,
  //       TelR: this.inviteeForm.controls.TelR.value,
  //       FaxNo: this.inviteeForm.controls.FaxNo.value,
  //       MobileNo: this.inviteeForm.controls.MobileNo.value,
  //       EmailId: this.inviteeForm.controls.EmailId.value,
  //       InAttendance: this.inviteeForm.controls.InAttendance.value,
  //       ThroughVC: this.inviteeForm.controls.ThroughVC.value,
  //       selectedInvitee: true,
  //       UserGovevaId: this.inviteeForm.controls.GovevaUserId.value,
  //     }
  //     var inviteeTable = $('#inviteeTable').DataTable({ destroy: true });
  //     inviteeTable.destroy();
  //     var newMeetingID = this.g_meetingID;


  //     this.meetingService.addInviteesInmeeting(newMeetingID, invityMember)
  //       .subscribe((invitees: any) => {

  //         if (invitees.status == 0) {
  //           this.loadMeetingDetails(this.g_meetingID);
  //           this.Invitees = invitees.MeetingData[0].Invitees;
  //           this.alert.success("Invitee added successfully.");
  //           this.disabledOnclick = false;
  //           this.dtTriggerInvitee.next();
  //           this.inviteeForm.reset();
  //         }
  //         else {
  //           this.alert.error(invitees.message);
  //         }
  //       });
  //   } else {
  //     this.disabledOnclick = false;
  //     return false
  //   }
  //   $('#existingInviteeDialog').off('hidden.bs.modal');
  //   $('.modal-backdrop').remove();
  //   $('body').removeClass('modal-open');
  //   $('#existingInviteeDialog').modal('hide');

  // }
  saveInviteeForGoveva() {
    this.disabledOnclick = true;

    // Manually enable disabled fields before saving
    ['InviteeName', 'Designation', 'MobileNo', 'EmailId'].forEach(field => {
      this.inviteeForm.controls[field].enable();
    });

    if (this.inviteeForm.valid) {
      const invityMember = this.inviteeForm.getRawValue(); // Includes disabled fields
      invityMember.UserGovevaId = invityMember.GovevaUserId;
      var inviteeTable = $('#inviteeTable').DataTable({ destroy: true });
      inviteeTable.destroy();

      this.meetingService.addInviteesInmeeting(this.g_meetingID, invityMember)
        .subscribe((invitees: any) => {
          if (invitees.status == 0) {
            this.loadMeetingDetails(this.g_meetingID);
            this.Invitees = invitees.MeetingData[0].Invitees;
            this.alert.success("Invitee added successfully.");
            this.dtTriggerInvitee.next();
            this.inviteeForm.reset();
          } else {
            this.alert.error(invitees.message);
          }
          this.disabledOnclick = false;
        });
    } else {
      this.alert.error('Please fill all required fields.');
      console.warn('Form is invalid:', this.inviteeForm);
      this.disabledOnclick = false;
      return false;
    }

    // Close modal safely
    $('#existingInviteeDialog').off('hidden.bs.modal');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#existingInviteeDialog').modal('hide');
  }


  indexOfSelectedMemberElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {

      if (o.EmailId == elementValue.EmailId) { }
      return o.EmailId == elementValue.EmailId;
    })
    return index;
  }
  typeHasError: boolean = true;
  agendaDocsToUpload: Array<File>;
  minutesDocsToUpload: Array<File>;
  consolidatedDocsToUpload: Array<File>;
  agendaPdfToUpload: Array<File>;
  agendaGenerationTitle: any;
  agendaGenerationID: any;
  agendaIsAvailable: boolean;
  agendaPdfIsAvailable: boolean;
  agendaUplaodedDocumentID: any;
  agendaUplaodedPdfID: any;

  initiateUploadAgendaDocs(data, type) {
    this.typeHasError = false;
    if (data.CategoryID != null && data.CategoryID != undefined && data.CategoryID != "") {
      this.categoryMasterService.getCategoryById(data.CategoryID)
        .subscribe(category => {
          if (category.status == 0) {
            this.isCategoryGlobal = category.categoryList[0].IsGlobal;
          }
        });
    }
    if (data._id != null && data._id != undefined && data._id != "") {
      this.meetingService.getAgendaByID(data._id)
        .subscribe(agendaData => {
          if (agendaData.status == 0) {
            if (agendaData.agendaDetails[0].PSSMasterAgendaID != null && agendaData.agendaDetails[0].PSSMasterAgendaID != undefined && agendaData.agendaDetails[0].PSSMasterAgendaID != "") {
              this.isPSSMasterAgenda = true;
            } else {
              this.isPSSMasterAgenda = false;
            }
          }
        });
    }

    if (type == 'Agenda') {
      this.agendaIsAvailable = data.AgendaGenerationDocument ? data.AgendaGenerationDocument.IsAvailable : false;
      this.agendaUplaodedDocumentID = data.AgendaGenerationDocument ? data.AgendaGenerationDocument.DocumentManagementID : false;
      this.agendaGenerationTitle = data.AgendaTitle;
      this.agendaGenerationID = data._id;
      this.uploadButtonType = 'Agenda';
      this.isLibraryAgenda = data.IscategorySelected;
      $('.agendaFileInput').val('');
      $('.chkCompanyName').prop("checked", false);
      this.uploadAgendaDocFileBtn = true;
      this.pushCompanyId = [];
      // $("#documentUploadLable").html("Upload Notice Doc.");
      //if(!data.isSubmited){
      this.currentAgenda = data
      //}
      $("#AgendaDocumentUploadTitle").html("Document For Agenda");
      $("#agendaDocxUploadDialog").modal('toggle');
    } else if (type == 'Minutes') {
      this.agendaIsAvailable = data.AgendaMinuteDocument ? data.AgendaMinuteDocument.IsAvailable : false;
      this.agendaUplaodedDocumentID = data.AgendaMinuteDocument ? data.AgendaMinuteDocument.DocumentManagementID : false;
      this.agendaGenerationTitle = data.AgendaTitle;
      this.agendaGenerationID = data._id;
      this.uploadButtonType = 'Minutes';
      this.isLibraryAgenda = data.IscategorySelected;
      $('.minutesFileInput').val('');
      $('.chkCompanyNameMinutes').prop("checked", false);
      this.uploadAgendaDocFileBtn = true;
      this.pushCompanyId = [];
      $("#MinuteDocumentUploadTitle").html("Document For Minute");
      $("#agendaMinutesUploadDialog").modal('toggle');
    }

  }

  initiateUploadAgendaPdf(data) {
    this.typeHasError = false;
    this.agendaPdfIsAvailable = data.AgendaGenerationPdf ? data.AgendaGenerationPdf.IsPdfAvailable : false;
    this.agendaUplaodedDocumentID = data.AgendaGenerationPdf ? data.AgendaGenerationPdf.DocumentManagementID : false;
    this.agendaGenerationTitle = data.AgendaTitle;
    this.agendaGenerationID = data._id;
    this.getAgendaAttachmentData(data._id);
    $("#AgendaPdfUploadTitle").html("Attachment For Agenda");
    $("#agendaPdfUploadDialog").modal('toggle');
  }


  agendaDocsChangeEvent(fileInput: any) {
    this.typeHasError = false
    var inputMime = fileInput.target.files[0].type;
    var docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    var doc = 'application/msword';

    var checkfile = this.commonFunction.checkFileExtensionForMeetingAgendaDocuments(fileInput);
    if (checkfile) {

      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput, fileInput)
      if (filenameValidation == "Valid") {
        this.agendaDocsToUpload = <Array<File>>fileInput.target.files;
        this.typeHasError = false;
      } else {
        this.alert.error(filenameValidation);
        this.typeHasError = true;
      }
    } else {
      this.typeHasError = true;
      this.alert.error("Invalid file extension");
    }
    fileInput = null;
  }

  minutesDocsChangeEvent(fileInput: any) {

    this.typeHasError = false
    var inputMime = fileInput.target.files[0].type;
    var docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    var doc = 'application/msword';
    // only for Mahinda Company Change
    // this.minutesDocsToUpload = <Array<File>>fileInput.target.files;
    /* Actual format */
    // if (inputMime == docx) {
    //   // || inputMime == doc
    //   this.agendaDocsToUpload = <Array<File>>fileInput.target.files;
    // } else {
    //   this.typeHasError = true;
    // }
    /* Actual format */

    var checkfile = this.commonFunction.checkFileExtensionForAgendaDocuments(fileInput);
    if (checkfile) {

      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput, fileInput)
      if (filenameValidation == "Valid") {
        this.minutesDocsToUpload = <Array<File>>fileInput.target.files;
        this.typeHasError = false;
      } else {
        this.alert.error(filenameValidation);
        this.typeHasError = true;
      }


    } else {
      this.alert.error("Invalid file extension");
      this.typeHasError = true;
    }
    fileInput = null;
  }

  agendaPdfChangeEvent(fileInput: any) {

    this.typeHasError = false;
    var inputMime = fileInput.target.files[0].type;
    var pdf = 'application/pdf';
    this.agendaPdfToUpload = [];
    for (var i = 0; i < fileInput.target.files.length; i++) {

      var fileInputToUpload = fileInput.target.files[i];
      let fileObj = {
        target: {
          files: [fileInputToUpload]
        }
      }
      if (this.commonFunction.checkFileExtension(fileObj)) {

        var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj, fileInput);
        if (filenameValidation == "Valid") {
          this.agendaPdfToUpload.push(fileInputToUpload);
        } else {
          this.alert.error(filenameValidation);
          this.typeHasError = true;
        }
      } else {
        this.alert.error("Invalid File Extention");
        this.typeHasError = true;
      }
    }

  }

  uploadAgendaDocFile(event) {
    // if (this.currentAgenda && !this.currentAgenda.isSubmited) {
    //   this.fileAgendaDocEvent = event
    //   return;
    // }
    // ===== Replace Library Agenda Doc START =======
    // this.isNewScreen==false;
    var updateLibraryAgendaDoc = false;
    var companyIdArray = this.pushCompanyId;
    if (this.pushCompanyId.length > 0) {
      companyIdArray = this.pushCompanyId;
    } else {
      if (event.target.id == 'replaceLibraryAgendaDoc') {
        updateLibraryAgendaDoc = true;
      }
    }
    // ===== Replace Library Agenda Doc END =======
    var file = this.agendaDocsToUpload;
    var self = this;
    this.loading = true;
    if (this.isNewScreen == true) {
      this.insertFileIndividuallyInDocument(self.agendaGenerationTitle, file).then(function (response) {
        if (response.status == 0) {
          self.agendaService.uploadJarFile({
            AgendaTitle: self.currentAgenda.AgendaTitle,
            AgendaNumber: self.currentAgenda.AgendaNumber,
            CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID,
            AgendaID: self.agendaGenerationID,
            DocumentManagementID: response.result._id
            // MeetingID:self.g_meetingID,
            // filePath:self.currentAgenda.PreambleAndResolution_FilePath,
            // userID:self.currentAgenda._id
          }).subscribe((result: any) => {
            if (result.status == 0) {
              var data = {
                IsAvailable: true,
                AgendaID: self.agendaGenerationID,
                DocumentManagementID: response.result._id,
                UploadDate: new Date(),
                IsPublished: true,
                MeetingID: self.g_meetingID,
                FileOrignalName: self.FileOrignalName,
                updateLibraryAgendaDoc: updateLibraryAgendaDoc,
                companyIdArray: companyIdArray
              }
              $("#agendaDocxUploadDialog").modal('toggle');
              self.meetingService.agendaGenerationFileUpdateInDB(data).subscribe(responseData => {
                if (responseData.status == 0) {
                  self.agendaArray = [];
                  var agendaTable = $('#agendaTable').DataTable({ destroy: true });
                  agendaTable.destroy();
                  $("#agendaNewTable").DataTable().destroy();
                  var agendaNewTable = $('#agendaNewTable').DataTable({ destroy: true });
                  agendaNewTable.destroy();
                  self.alert.success("File Uploaded Successfully");
                  self.agendaArray = responseData.data;

                  self.newAgendaArray = self.agendaArray.map(enhanchArr);
                  self.newAgendaArray.push(...self.tempArray)
                  self.dtTriggerAgenda.next();
                  self.dtTriggerAgendaNew.next();
                  self.transferToGemArray = [];
                  var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
                  transferToGemTable.destroy();
                  self.transferToGemArray = responseData.data;
                  for (var index = 0; index < self.transferToGemArray.length; index++) {
                    self.transferToGemArray[index].setSelected = self.transferToGemArray[index].isPublished;
                  }
                  self.dtTriggerOfTransferToGem.next();
                  $("#agendaAccessTable").DataTable().destroy();
                  self.agendaAccessArray = responseData.data;
                  self.dtTriggerAgendaAccess.next();

                  self.agendaDocsToUpload = undefined;
                  $(".fileUpload").val("");
                  // self.downloadAgendaGeneratedDoc();
                  self.getAgendaGenerationData()
                  self.loading = false;
                } else if (responseData.status == 55) {
                  // self.meetingService.downloadSplitFailureFile(responseData.filename);
                  self.alert.error("Please upload file without bookmark or upload from Agenda tab");
                  self.loading = false;

                  self.agendaArray = [];
                  var agendaTable = $('#agendaTable').DataTable({ destroy: true });
                  agendaTable.destroy();
                  $("#agendaNewTable").DataTable().destroy();
                  self.agendaArray = responseData.data;

                  self.newAgendaArray = self.agendaArray.map(enhanchArr);
                  self.newAgendaArray.push(...self.tempArray)

                  self.dtTriggerAgenda.next();
                  self.dtTriggerAgendaNew.next();
                  self.transferToGemArray = [];
                  var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
                  transferToGemTable.destroy();
                  self.transferToGemArray = responseData.data;
                  for (var index = 0; index < self.transferToGemArray.length; index++) {
                    self.transferToGemArray[index].setSelected = self.transferToGemArray[index].isPublished;
                  }
                  self.dtTriggerOfTransferToGem.next();
                  $("#agendaAccessTable").DataTable().destroy();
                  self.agendaAccessArray = responseData.data;
                  self.dtTriggerAgendaAccess.next();

                  self.agendaDocsToUpload = undefined;
                  $(".fileUpload").val("");
                  // self.downloadAgendaGeneratedDoc();
                  self.getAgendaGenerationData()
                  self.loading = false;
                } else {
                  self.alert.error(responseData.message);
                  self.loading = false;
                }

              })
            }
          })
        }
        else {
          self.loading = false;
          self.alert.error("Oops Something went wrong.");
        }
      }, (error) => {
        this.loading = false;
        this.alert.error(error);
      })
    } else {
      this.insertFileIndividuallyInDocument(self.agendaGenerationTitle, file).then(function (response) {
        if (response.status == 0) {
          var data = {
            IsAvailable: true,
            AgendaID: self.agendaGenerationID,
            DocumentManagementID: response.result._id,
            UploadDate: new Date(),
            IsPublished: true,
            MeetingID: self.g_meetingID,
            FileOrignalName: self.FileOrignalName,
            updateLibraryAgendaDoc: updateLibraryAgendaDoc,
            companyIdArray: companyIdArray
          }
          $("#agendaDocxUploadDialog").modal('toggle');
          self.meetingService.agendaGenerationFileUpdateInDB(data).subscribe(responseData => {
            if (responseData.status == 0) {
              self.agendaArray = [];
              var agendaTable = $('#agendaTable').DataTable({ destroy: true });
              agendaTable.destroy();
              $("#agendaNewTable").DataTable().destroy();
              var agendaNewTable = $('#agendaNewTable').DataTable({ destroy: true });
              agendaNewTable.destroy();
              self.alert.success("File Uploaded Successfully");
              self.agendaArray = responseData.data;

              self.newAgendaArray = self.agendaArray.map(enhanchArr);
              self.newAgendaArray.push(...self.tempArray)
              self.dtTriggerAgenda.next();
              self.dtTriggerAgendaNew.next();
              self.transferToGemArray = [];
              var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
              transferToGemTable.destroy();
              self.transferToGemArray = responseData.data;
              for (var index = 0; index < self.transferToGemArray.length; index++) {
                self.transferToGemArray[index].setSelected = self.transferToGemArray[index].isPublished;
              }
              self.dtTriggerOfTransferToGem.next();
              $("#agendaAccessTable").DataTable().destroy();
              self.agendaAccessArray = responseData.data;
              self.dtTriggerAgendaAccess.next();

              self.agendaDocsToUpload = undefined;
              $(".fileUpload").val("");
              // self.downloadAgendaGeneratedDoc();
              self.getAgendaGenerationData()
              self.loading = false;
            } else if (responseData.status == 55) {
              self.meetingService.downloadSplitFailureFile(responseData.filename);
              self.alert.error(responseData.message);
              self.loading = false;

              self.agendaArray = [];
              var agendaTable = $('#agendaTable').DataTable({ destroy: true });
              agendaTable.destroy();
              $("#agendaNewTable").DataTable().destroy();

              self.agendaArray = responseData.data;

              self.newAgendaArray = self.agendaArray.map(enhanchArr);
              self.newAgendaArray.push(...self.tempArray)

              self.dtTriggerAgenda.next();
              self.dtTriggerAgendaNew.next();
              self.transferToGemArray = [];
              var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
              transferToGemTable.destroy();
              self.transferToGemArray = responseData.data;
              for (var index = 0; index < self.transferToGemArray.length; index++) {
                self.transferToGemArray[index].setSelected = self.transferToGemArray[index].isPublished;
              }
              self.dtTriggerOfTransferToGem.next();
              $("#agendaAccessTable").DataTable().destroy();
              self.agendaAccessArray = responseData.data;
              self.dtTriggerAgendaAccess.next();

              self.agendaDocsToUpload = undefined;
              $(".fileUpload").val("");
              // self.downloadAgendaGeneratedDoc();
              self.getAgendaGenerationData()
              self.loading = false;
            } else {
              self.alert.error("Please upload file with bookmark or upload from Auto Bookmark tab");
              self.loading = false;
            }

          })


        }
        else {
          self.loading = false;
          self.alert.error("Oops Something went wrong.");
        }
      }, (error) => {
        this.loading = false;
        this.alert.error(error);
      })
    }
  }

  uploadMinutesDocFile(event) {
    // ===== Replace Library Agenda Doc START =======
    var updateMinuteDocInLibrary = false;
    var companyIdArrayForMinute = this.pushCompanyId;
    if (this.pushCompanyId.length > 0) {
      companyIdArrayForMinute = this.pushCompanyId;
    } else {
      if (event.target.id == 'saveMinuteDocInLibrary') {
        updateMinuteDocInLibrary = true;
      }
    }

    // ===== Replace Library Agenda Doc END =======
    var file = this.minutesDocsToUpload;
    if (!file || !file.length) {
      this.alert.error('Please select a minute document to upload.');
      return;
    }
    var self = this;
    this.loading = true;
    this.insertFileIndividuallyInDocument(self.agendaGenerationTitle, file).then(function (response) {
      if (response.status == 0) {
        var originalFileName =
          self.FileOrignalName ||
          self.agendaDocName ||
          (file[0] && file[0].name ? file[0].name.replace(',', '') : '') ||
          (response.result && response.result.OriginalFileName
            ? response.result.OriginalFileName
            : '');
        if (!originalFileName) {
          self.loading = false;
          self.alert.error(
            'Could not determine file name. Please select the file again.'
          );
          return;
        }

        var data = {
          IsAvailable: true,
          AgendaID: self.agendaGenerationID,
          DocumentManagementID: response.result._id,
          UploadDate: new Date(),
          IsPublished: true,
          MeetingID: self.g_meetingID,
          FileOrignalName: originalFileName,
          updateMinuteDocInLibrary: updateMinuteDocInLibrary,
          companyIdArrayForMinute: companyIdArrayForMinute
        }
        $("#agendaMinutesUploadDialog").modal('toggle');
        self.meetingService.minutesFileUpdateInDB(data).subscribe(responseData => {
          if (responseData.status == 0) {
            self.agendaArray = [];
            var agendaTable = $('#agendaTable').DataTable({ destroy: true });
            agendaTable.destroy();
            $("#agendaNewTable").DataTable().destroy();
            self.alert.success("File Uploaded Successfully");
            self.agendaArray = responseData.data;

            self.newAgendaArray = self.agendaArray.map(enhanchArr);
            self.newAgendaArray.push(...self.tempArray)

            self.dtTriggerAgenda.next();
            self.dtTriggerAgendaNew.next();
            self.transferToGemArray = [];
            var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
            transferToGemTable.destroy();
            self.transferToGemArray = responseData.data;
            for (var index = 0; index < self.transferToGemArray.length; index++) {
              self.transferToGemArray[index].setSelected = self.transferToGemArray[index].isPublished;
            }
            self.dtTriggerOfTransferToGem.next();
            $("#agendaAccessTable").DataTable().destroy();
            self.agendaAccessArray = responseData.data;
            self.dtTriggerAgendaAccess.next();

            self.minutesDocsToUpload = undefined;
            $('#agendaMinutesUploadDialog input[type=file]').val('');
            self.getAgendaGenerationData();
            self.loading = false;
          } else if (responseData.status == 55) {
            self.meetingService.downloadSplitFailureFile(responseData.filename);
            self.alert.error(responseData.message);

            self.agendaArray = [];
            var agendaTable = $('#agendaTable').DataTable({ destroy: true });
            agendaTable.destroy();
            $("#agendaNewTable").DataTable().destroy();
            // self.alert.success("Docx File Uploaded Successfully");
            self.agendaArray = responseData.data;
            // let filterData = self.newAgendaArray.filter((x:any)=>x.disabled == false);
            // self.tempArray=filterData
            self.newAgendaArray = self.agendaArray.map(enhanchArr);
            self.newAgendaArray.push(...self.tempArray)

            self.dtTriggerAgenda.next();
            self.dtTriggerAgendaNew.next();
            self.transferToGemArray = [];
            var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
            transferToGemTable.destroy();
            self.transferToGemArray = responseData.data;
            for (var index = 0; index < self.transferToGemArray.length; index++) {
              self.transferToGemArray[index].setSelected = self.transferToGemArray[index].isPublished;
            }
            self.dtTriggerOfTransferToGem.next();
            $("#agendaAccessTable").DataTable().destroy();
            self.agendaAccessArray = responseData.data;
            self.dtTriggerAgendaAccess.next();

            self.minutesDocsToUpload = undefined;
            $('#agendaMinutesUploadDialog input[type=file]').val('');
            self.getAgendaGenerationData();
            self.loading = false;
          } else {
            self.alert.error(responseData.message);
            self.loading = false;
          }
        })
      } else {
        self.loading = false;
        self.alert.error("Oops Something went wrong.");
      }
    }, (error) => {
      self.loading = false;
      self.alert.error(error);
    })
  }

  uploadAgendaPdfFile() {
    var file = this.agendaPdfToUpload;
    var self = this;
    var pdfData = [];
    this.loading = true;
    this.insertFileIndividuallyInDocumentForPdf(self.agendaGenerationTitle, file, '-PDF Attachment').then(function (response) {

      if (response.status == 0) {
        for (var i = 0; i < response.result.length; i++) {
          var data = {
            IsAvailable: true,
            AgendaID: self.agendaGenerationID,
            DocumentManagementID: response.result[i].Document._id,
            UploadDate: new Date(),
            IsPublished: true,
            MeetingID: self.g_meetingID,
            PdfName: response.result[i].Document.OriginalFileName,
            UploadFileName: response.result[i].Document.Filename,
          }

          pdfData.push(data);
        }

        $("#agendaPdfUploadDialog").modal('toggle');
        self.meetingService.agendaGenerationPdfFileUpdateInDB(pdfData).subscribe(responseData => {
          self.agendaArray = [];
          var agendaTable = $('#agendaTable').DataTable({ destroy: true });
          agendaTable.destroy();
          $("#agendaNewTable").DataTable().destroy();
          self.alert.success("PDF File Uploaded Successfully");
          self.agendaArray = responseData.data;

          self.newAgendaArray = self.agendaArray.map(enhanchArr);
          self.newAgendaArray.push(...self.tempArray)

          self.dtTriggerAgenda.next();
          self.dtTriggerAgendaNew.next();
          self.transferToGemArray = [];
          var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
          transferToGemTable.destroy();
          self.transferToGemArray = responseData.data;
          for (var index = 0; index < self.transferToGemArray.length; index++) {
            self.transferToGemArray[index].setSelected = self.transferToGemArray[index].isPublished;
          }
          self.dtTriggerOfTransferToGem.next();
          $("#agendaAccessTable").DataTable().destroy();
          self.agendaAccessArray = responseData.data;
          self.dtTriggerAgendaAccess.next();
          self.agendaPdfToUpload = undefined;
          $(".fileUpload").val("");
          // self.downloadAgendaGeneratedDoc();
          self.getAgendaGenerationData()
          self.loading = false;
        })
      } else {
        self.alert.error(response.message);
        self.loading = false;
      }
    }, (error) => {
      this.alert.error(error);
      self.loading = false;
    })


  }

  downloadAgendaDocs(downloadDocumentID, agendaId, type) {
    var token = localStorage.getItem('token')
    this.meetingService.generateKeyBeforDownloadingDocument(this.g_meetingID, agendaId, type);
    // window.location.href = environment.pssServerUrl + this.downloadAllLink + downloadDocumentID + "/" + token;
  }

  downloadAgendaGeneratedDoc() {
    this.meetingService.readMeetingDockletFile(this.g_meetingID).subscribe(responseData => {
      // this.iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.fileurl+responseData.data );

      window.location.href = environment.fileurl + responseData.data;
    })
  }

  downloadFromHistory(data, type) {
    // window.location.href = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/' + data;.
    var meetingID = this.g_meetingID;
    var docId = data.DocxDocumentID;
    var fileName = data.displayDocxFilePath;
    if (type == 'pdf') {
      docId = data.PdfDocumentID;
      fileName = data.displayPdfFilePath
    }
    if (type == 'Minutes') {
      docId = data.MinutesDocumentID;
      fileName = data.MinutesFilePath
    }
    this.meetingService.downloadAgendaFile(meetingID, docId, fileName);

  }

  downloadPdf(data) {

    var link = document.createElement("a");
    link.setAttribute('target', '_blank');
    link.download = environment.fileurl + '/Document_Type/' + data;
    link.href = environment.fileurl + '/Document_Type/' + data;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);



  }

  getAgendaGenerationData() {
    let companyName = JSON.parse(localStorage.getItem('companyDetails')).companyName
    this.meetingService.getAgendaGenerationData(this.g_meetingID, companyName).subscribe(responseData => {
      this.agendaGeneratedHistory = [];
      $("#AgendaGen").DataTable().destroy();
      this.docketFileName = responseData.data.displayDocxFilePath;
      this.pdfFileName = responseData.data.displayPdfFilePath;
      this.pdfFileId = responseData.data.PdfDocumentID;
      this.minutesFileName =
        responseData.data.displayMinutesFilePath ||
        responseData.data.MinutesFilePath ||
        '';
      this.agendaGeneratedHistory = responseData.data.History;
      this.agendaDocData = responseData.data;
      this.docketFileId = responseData.data.DocxDocumentID;
      this.dtTriggerOfAgendaGen.next();

    });


  }

  getAgendaAttachmentData(agendaId) {

    this.meetingService.getAgendaAttachmentData(this.g_meetingID, agendaId).subscribe(responseData => {
      this.agendaPdfAttachment = [];

      this.agendaPdfAttachment = responseData.AgendaGenerationPdf;

    });


  }

  downloadDoc(data) {
    var token = localStorage.getItem('token')
    this.downloadSingleFile = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/';
    window.location.href = this.downloadSingleFile + data + "/" + token;
  }

  deletePdfAttachment(pdfId, documentId) {

    $("#deletePdfConfirmation").modal('toggle');
    this.pdfToDelete = pdfId;
    this.documentIdToDelete = documentId
  }



  removeDoc() {
    this.meetingService.agendaGenerationRemovePdfFile(this.g_meetingID, this.agendaGenerationID, this.pdfToDelete, this.documentIdToDelete).subscribe(responseData => {
      this.agendaPdfAttachment = [];
      this.agendaPdfAttachment = responseData.AgendaGenerationPdf;
      this.agendaArray = [];
      var agendaTable = $('#agendaTable').DataTable({ destroy: true });
      agendaTable.destroy();
      $("#agendaNewTable").DataTable().destroy();

      this.agendaArray = _.sortBy(responseData, ["Agendaorder"]);

      this.newAgendaArray = this.agendaArray.map(enhanchArr);
      this.newAgendaArray.push(...this.tempArray)
      this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
        return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
      });
      this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
      this.dtTriggerAgenda.next();
      this.dtTriggerAgendaNew.next()
      this.transferToGemArray = [];
      var transferToGemTable = $('#transferToGemTable').DataTable({ destroy: true });
      transferToGemTable.destroy();
      this.transferToGemArray = responseData;
      for (var index = 0; index < this.transferToGemArray.length; index++) {
        this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
      }
      this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
      this.dtTriggerOfTransferToGem.next();
      $("#agendaAccessTable").DataTable().destroy();
      this.agendaAccessArray = responseData;
      this.dtTriggerAgendaAccess.next();
      this.getAgendaAttachmentData(this.agendaGenerationID);
    });
  }

  UploadConsolidatedDocs() {
    $("#ConsolidatedDocumentUploadTitle").html("Consolidated File");
    $("#consolidatedDocxUploadDialog").modal('toggle');
  }

  consolidatedDocsChangeEvent(fileInput: any) {

    this.typeHasError = false
    var inputMime = fileInput.target.files[0].type;
    var docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    var doc = 'application/msword';
    // if (inputMime == docx) {
    //   // || inputMime == doc
    //   this.consolidatedDocsToUpload = <Array<File>>fileInput.target.files;
    // } else {
    //   this.typeHasError = true;
    // }

    var checkfile = this.commonFunction.checkFileExtensionForAgendaDocuments(fileInput);
    if (checkfile) {

      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput, fileInput)
      if (filenameValidation == "Valid") {
        this.consolidatedDocsToUpload = <Array<File>>fileInput.target.files;
        this.typeHasError = false;
      } else {
        this.alert.error(filenameValidation);
        this.typeHasError = true;
      }


    } else {
      this.alert.error("Invalid file extension");
      this.typeHasError = true;
    }

    fileInput = null;
  }

  uploadConsolidatedFile() {

    if (this.typeHasError == false) {
      var file = this.consolidatedDocsToUpload;
      this.loading = true;
      return this.makeFileRequest(environment.pssServerUrl + "consolidatedFile/fileUpload/", [], file).then((result) => {
        if (result) {
          $("#consolidatedDocxUploadDialog").modal('toggle');
          var document = {
            "DoxFileName": this.changedName,
            "MeetingID": this.g_meetingID,
            "MeetingTypeID": this.g_meetingTypeID
          }
          return this.meetingService.addConsolidatedFile(document)
            .subscribe(responseData => {
              if (responseData.status == 0) {
                this.getAgendaGenerationData();
                this.consolidatedDocsToUpload = undefined;
                $(".fileUpload").val("");
                this.getSplittedDocxData(this.g_meetingID);
                this.loading = false;

              } else if (responseData.status == 55) {
                this.meetingService.downloadSplitFailureFile(responseData.filename);
                this.alert.error(responseData.message);
                this.loading = false;
                this.getAgendaGenerationData();
                this.consolidatedDocsToUpload = undefined;
                $(".fileUpload").val("");

              } else {
                this.alert.error(responseData.message);
                this.loading = false;
              }

            })
        } else {
          this.alert.error("Oops, Something Went Wrong");
        }
      })
    } else {
      // this.alert.error("Please upload correct file format.");
      return false
    }

    // this.getSplittedDocxData(this.g_meetingID);
    // $("#splitAgenda").modal('toggle');
  }

  meetingAdjValidation: boolean = false;
  adjTimeChangeEvent(event, varC) {
    if (varC == 'date') {
      var mettingADJDate = this.meetimeADJDate;
      var meetingADJTimeEntered = $("#meetingADJTime").val();
      var meetingdate = this.MeetingDateModel;
      var meetingTime = this.addmeetingForm.controls['MeetingTime'].value;
      var newMeetingDate = this.addmeetingForm.controls['MeetingDate'].value;
    } else {
      var mettingADJDate = this.meetimeADJDate;
      var meetingADJTimeEntered = event.target.value;
      var meetingdate = this.MeetingDateModel;
      var meetingTime = this.addmeetingForm.controls['MeetingTime'].value;
      var newMeetingDate = this.addmeetingForm.controls['MeetingDate'].value;
    }
    meetingTime = moment(meetingTime, "HH:mm a");
    // var meetimeADJDates = moment(mettingADJDate).format('YYYY-MM-DD');
    // var meetingDates = moment(newMeetingDate).format('YYYY-MM-DD');
    meetingADJTimeEntered = moment(meetingADJTimeEntered, "HH:mm a");
    var Meetingdate = this.setDate(this.MeetingDateModel);
    var meetimeADJDate = this.setDate(this.meetimeADJDate);
    if (meetimeADJDate == null || (moment(meetimeADJDate).diff(moment(Meetingdate).format('YYYY-MM-DD'), "days") >= 0)) {
      this.disableAdjournedDate = true;
    } else {
      this.disableAdjournedDate = false;
    }
  }

  generateConsolidatedFile() {
    this.loading = true;
    const previousDocxId = this.docketFileId;
    this.meetingService.generateConsolidatedFile(this.g_meetingID.toString()).subscribe(responseData => {
      if (responseData.status == 0) {
        this.alert.success(responseData.Message);
        this.pollForGeneratedFile('', previousDocxId);
      } else {
        this.alert.error(responseData.Message);
        this.loading = false;
      }
    });
  }

  generateConsolidatedPdf() {
    this.loading = true;
    const previousPdfId = this.pdfFileId;
    this.meetingService.generateConsolidatedPdf(this.g_meetingID.toString()).subscribe(responseData => {
      if (responseData.status == 0) {
        this.alert.success(responseData.Message);
        this.pollForGeneratedFile('pdf', previousPdfId);
      } else {
        this.alert.error(responseData.Message);
        this.loading = false;
      }
    });
  }

  pollForGeneratedFile(type: 'pdf' | '', previousId: any) {
    const companyName = JSON.parse(localStorage.getItem('companyDetails')).companyName;
    let attempts = 0;
    const maxAttempts = 100;
    const intervalId = setInterval(() => {
      attempts++;
      this.meetingService.getAgendaGenerationData(this.g_meetingID, companyName).subscribe(responseData => {
        const currentId = type === 'pdf' ? responseData.data.PdfDocumentID : responseData.data.DocxDocumentID;
        if (currentId && currentId !== previousId) {
          clearInterval(intervalId);
          this.agendaGeneratedHistory = [];
          $("#AgendaGen").DataTable().destroy();
          this.agendaDocData = responseData.data;
          this.agendaGeneratedHistory = responseData.data.History;
          this.docketFileName = responseData.data.displayDocxFilePath;
          this.pdfFileName = responseData.data.displayPdfFilePath;
          this.pdfFileId = responseData.data.PdfDocumentID;
          this.minutesFileName =
            responseData.data.displayMinutesFilePath ||
            responseData.data.MinutesFilePath ||
            '';
          this.docketFileId = responseData.data.DocxDocumentID;
          this.dtTriggerOfAgendaGen.next();
          this.downloadFromHistory(this.agendaDocData, type);
          this.loading = false;
        } else if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          this.alert.error('Generation is taking longer than expected. Please check the history tab shortly.');
          this.loading = false;
        }
      });
    }, 3000);
  }

  getSplittedDocxData(meetingId) {
    this.isSplitOperationPerformed = false;
    this.meetingService.getSplittedAgendaDocxData(meetingId).subscribe(splittedDataResponse => {
      if (splittedDataResponse.status == 0) {
        for (var i = 0; i < splittedDataResponse.Data.length; i++) {
          if (splittedDataResponse.Data[i].isChanged == true) {
            splittedDataResponse.Data[i].isExisting = true;
          }
        }
        this.splittedData = splittedDataResponse.Data;
        this.splitDataId = splittedDataResponse.id;
        //  this.agendaReplaceArray = this.agendaArray.filter(n => !this.splittedData.some(n2 => (n2.replaceBy == n._id)));
        this.disableAddedAgenda();
        $("#splitAgenda").modal('toggle');
      } else if (splittedDataResponse.Data.length == 0 && splittedDataResponse.status == 1) {
        this.splitedCombinedMeetingId = meetingId;
        this.alert.success('File is in progress, please wait for few minutes');
        this.saveCombinedButton = true;
      }

    })
  }

  selectNewOrExisting(type, agendaNumber, agendaTitle, agendaFileName, documentId, selectedAgendaId, index) {
    this.splitId = selectedAgendaId;
    this.isExisting = false;

    if (type === 'new') {

      this.splittedData[index].isExisting = false;
      this.splittedData[index].replaceBy = "New";
      this.isExisting = false;
    } else if (type === 'Existing') {

      this.splittedData[index].isExisting = true;
      this.isExisting = true;
    }
    this.disableAddedAgenda();
  }

  revertAgendaSelection(index) {
    this.splittedData[index].replaceBy = null;
    this.isExisting = null;
    this.splittedData[index].isExisting = null;
    this.disableAddedAgenda();
  }

  saveSplittedAgenda() {
    this.disabledOnclick = true;
    this.loading = true;

    // Reset failed agendas tracking
    this.failedAgendaNumbers = [];
    this.agendaFailedText = '';

    // Save to localStorage for reconnection on page refresh
    localStorage.setItem('agendaProcessing', JSON.stringify({
      meetingId: this.g_meetingID,
      status: 'processing',
      startedAt: Date.now()
    }));

    // Connect to SSE endpoint FIRST for real-time progress
    this.connectToSSE(true);
  }

  // Check localStorage and reconnect to SSE if processing was ongoing
  checkAndReconnectSSE() {
    const stored = localStorage.getItem('agendaProcessing');
    if (stored) {
      try {
        const data = JSON.parse(stored);
        const sixtyMinutes = 60 * 60 * 1000; // 60 minutes in milliseconds

        // Check if same meeting, still processing, and not stale (< 60 mins)
        if (data.meetingId === this.g_meetingID &&
            data.status === 'processing' &&
            (Date.now() - data.startedAt) < sixtyMinutes) {
          console.log('[SSE] Reconnecting to ongoing processing...');
          this.agendaProcessingText = 'Reconnecting...';
          this.connectToSSE(false);
        } else {
          // Stale or different meeting - clear localStorage
          localStorage.removeItem('agendaProcessing');
        }
      } catch (e) {
        console.error('[SSE] Error parsing localStorage:', e);
        localStorage.removeItem('agendaProcessing');
      }
    }
  }

  // Connect to SSE endpoint (isNewConnection: true for new save, false for reconnection)
  connectToSSE(isNewConnection: boolean) {
    const sseUrl = `${environment.pssServerUrl}meeting/streamSplitAgendaProgress/${this.g_meetingID}`;
    const eventSource = new EventSource(sseUrl);
    this.currentEventSource = eventSource;

    // Reset failed agendas on new connection
    if (isNewConnection) {
      this.failedAgendaNumbers = [];
      this.agendaFailedText = '';
    }

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.type === 'connected') {
        console.log('[SSE] Connected');

        if (isNewConnection) {
          // New save - call the API
          console.log('[SSE] Starting API call...');
          this.meetingService.saveSplittedAgendaInMeeting(this.g_meetingID, this.g_meetingTypeID, this.splitId, this.splittedData).subscribe(splitSaveResponse => {
            this.disabledOnclick = false;
            this.loading = false; // Stop spinner, user can navigate

            if (splitSaveResponse.status == 0) {
              // Processing started in background
              console.log('Save API returned success, processing in background...');
              // Close modal but don't show final success yet
              $("#splitAgenda").modal('toggle');
            } else {
              // API failed - close SSE and show error
              this.clearSSEState();
              this.alert.error("Something Went Wrong.");
              this.isSplitOperationPerformed = false;
              eventSource.close();
            }
            this.isExisting = false;
          }, error => {
            // HTTP error - close SSE
            this.disabledOnclick = false;
            this.loading = false;
            this.clearSSEState();
            this.alert.error("Something Went Wrong.");
            this.isSplitOperationPerformed = false;
            eventSource.close();
          });
        } else {
          // Reconnection - just wait for progress events
          console.log('[SSE] Reconnected, waiting for progress...');
          this.agendaProcessingText = 'Processing...';
        }
      } else if (data.type === 'processing') {
        // Show progress in UI
        console.log(`[SSE] Processing agenda ${data.current}/${data.total} - ${data.agendaNumber}`);
        this.agendaProcessingText = `Processing agenda ${data.current}/${data.total}`;
      } else if (data.type === 'error') {
        // Individual agenda failed - track it and continue
        console.error(`[SSE] Agenda ${data.agendaNumber} failed`);
        this.failedAgendaNumbers.push(data.agendaNumber);
        this.agendaFailedText = `Agenda failed: ${this.failedAgendaNumbers.join(', ')}`;
      } else if (data.type === 'converting') {
        console.log('[SSE] Converting to PDF...');
        this.agendaProcessingText = 'Converting agendas to PDF';
      } else if (data.type === 'done') {
        // All processing complete
        console.log('[SSE] All agendas processed');
        eventSource.close();
        this.currentEventSource = null;
        this.clearSSEState();
        this.saveCombinedButton = false;

        // Show appropriate message based on failures
        if (data.failedCount > 0) {
          this.alert.note(`Split completed with ${data.failedCount} failed agenda(s): ${data.failedAgendas.join(', ')}`);
        } else {
          this.alert.success("Split Operation Performed Successfully");
        }
        this.isSplitOperationPerformed = true;

        // Refresh agenda list after a short delay to ensure data is ready
        // Run inside Angular zone to ensure proper change detection
        this.ngZone.run(() => {
          setTimeout(() => {
            this.getAgendaList();
          }, 500);
        });
      }
    };

    eventSource.onerror = (error) => {
      console.error('[SSE] Error:', error);
      eventSource.close();
      this.currentEventSource = null;
      this.disabledOnclick = false;
      this.loading = false;
      this.clearSSEState();
      this.alert.error("Connection error. Please try again.");
    };
  }

  // Clear SSE-related state and localStorage
  clearSSEState() {
    this.agendaProcessingText = '';
    this.agendaFailedText = '';
    this.failedAgendaNumbers = [];
    localStorage.removeItem('agendaProcessing');
  }


  deleteSplitTemporaryData() {
    this.disabledOnclick = true;
    this.meetingService.deleteSplittedAgendaDocxData(this.splitDataId).subscribe(deleteResponse => {
      this.disabledOnclick = false;
      if (deleteResponse.status == 0) {
        this.saveCombinedButton = false;
        if (this.isSplitOperationPerformed == true) {
          this.alert.success("Consolidated file splitted successfully");
        } else {
          this.alert.error("Split operation not performed");
        }
        $("#splitAgenda").modal('toggle');
      } else {
        this.alert.error("Something went wrong");
      }
    })
  }

  // checkMeetingDate(){
  //   var newMeetingDates = this.addmeetingForm.controls['MeetingDate'].value;
  //   var mettingADJDate = this.meetimeADJDate;
  //   var meetimeADJDates = moment(mettingADJDate).format('YYYY-MM-DD');
  //   var meetingDates = moment(newMeetingDates).format('YYYY-MM-DD');
  //    var diffAppointmentDateAndDateOfIncorporation = (moment(meetimeADJDates).diff(moment(meetingDates), "days")) && (moment(meetimeADJDates).diff(moment(meetingDates), "years"));
  //     if (meetimeADJDates < meetingDates) {
  //       this.disableAdjournedDate = true;
  //     }
  //     else {
  //       this.disableAdjournedDate = false;
  //     }
  // }

  /*(18-03-2019) */

  selectAllAgendas(event) {
    // alert(ev.target.checked);
    if (event.target.checked == true) {

      this.transferToGemArray.forEach(element => {
        if (element.setSelected != true) {

          let index = this.transferToGemSelectedAgenda.indexOf(element._id);
          if (index == -1) {
            this.transferToGemSelectedAgenda.push(element._id);
          }

          element.isPublished = true;
          // element.transferToGemTime = Date.now()
          this.countAgenda++;
        }
      });
    } else {
      this.transferToGemArray.forEach(element => {
        if (element.setSelected != true) {
          let index = this.transferToGemSelectedAgenda.indexOf(element._id);
          if (index > -1) {
            this.transferToGemSelectedAgenda.splice(index, 1);
          }
          element.isPublished = false;
          this.countAgenda--;
        }
      });
    }
  }

  checkselectedAgenda(event, index, agendaId) {
    if (event.target.checked == true) {

      // this.transferToGemArray[index].transferToGemTime = Date.now();
      this.countAgenda++;
      this.transferToGemSelectedAgenda.push(agendaId);

    } else {
      // this.transferToGemArray[index].transferToGemTime = null;
      this.countAgenda--;
      let index = this.transferToGemSelectedAgenda.indexOf(agendaId);
      if (index > -1) {
        this.transferToGemSelectedAgenda.splice(index, 1);
      }
    }
    this.selectedAgenda = this.transferToGemArray.every(function (item: any) {
      return item.isPublished == true;
    })
  }


  async syncUpdatedAccessIfAnyBeforePublishing(meetingId): Promise<boolean> {
    //Job: 
    //Access can be updated just before publishing, with the function: <updateAgendaAccess()> which updates: <this.agendaAccessArray.>
    //While publishing the data & sending notification with the function: <publishAgendaToGem()> which reads from: <this.clonedAgendaArray.>
    //The same issue might happen if someone added any new invitee!
    //Hence fething from db just before publishing.

    try {


      await this.meetingService.getMeetingDetails(meetingId).subscribe(
        (meetingDetails: any) => {

          let fetchedAgendas = meetingDetails.meetingData[0].Agenda;


          if (fetchedAgendas.length == this.clonedAgendaArray.length) {

            for (let idx = 0; idx < fetchedAgendas.length; idx++) {

              let fetchedAgendas_id = fetchedAgendas[idx]._id;
              let fetchedAgendas_success = false;
              for (let inneridx = 0; inneridx < this.clonedAgendaArray.length; inneridx++) {
                if (fetchedAgendas_id == this.clonedAgendaArray[inneridx]._id) {
                  let temp_AgendaAccessRights = [...fetchedAgendas[idx].AgendaAccessRights];
                  this.clonedAgendaArray[inneridx].AgendaAccessRights = temp_AgendaAccessRights;
                }
              }

            }
          } else {
            //Returning failure since both arrays do not have same agendas
            return false;
          }
        }
      );

    } catch (exception) {
      return false;
    }
    return true;
  }



  async publishAgendaToGem() {
    this.clonedAgendaArray = Object.assign([], this.transferToGemArray);
    if (this.transferToGemSelectedAgenda.length == 0) {
      this.alert.error("Please select agendas to publish.");
      return;
    }

    let syncResult: boolean = await this.syncUpdatedAccessIfAnyBeforePublishing(this.g_meetingID);

    if (!syncResult) {
      this.alert.error('Oops something went wrong, please reload the meeting.');
      return;
    }

    if (this.countAgenda > 0) {
      this.meetingService.publishAgendaToGem(this.transferToGemArray, this.g_meetingID).subscribe(result => {
        this.countAgenda = 0;
        if (result.status == 0) {
          var filteredAgenda = _.filter(this.transferToGemArray, function (element) {
            return (element.transferToGemTime == null || element.transferToGemTime == undefined || element.transferToGemTime == '')
          })
          this.transferToGemArray = [];
          $("#transferToGemTable").DataTable().destroy();
          this.transferToGemArray = result.data;
          for (var index = 0; index < this.transferToGemArray.length; index++) {
            this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
          }
          this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
          this.dtTriggerOfTransferToGem.next();

          if (filteredAgenda.length == this.transferToGemArray.length) {
            this.sendNotification('TransferToGem')
          } else if (filteredAgenda.length >= 0) {

            $("#publishAgendaDialog").modal('toggle');
          }

        } else {
          this.transferToGemSelectedAgenda = [];
          this.alert.error('Oops, Something went wrong.')
        }
      })
    } else {
      this.alert.error('Please select agendas to publish');
    }

  }

  /* (26-03-2019) */
  hideMeetingFromGem() {
    if (this.meetingGemStatus == true || this.meetingGemStatus == undefined || this.meetingGemStatus == null) {
      $("#hideAgendaConfirmation").modal("toggle");
      $('#hideMessage').html('Do you want to hide meeting from GEM?');
      this.meetingGemStatus = false;
      this.hideBtnMsg = 'Hide'
    } else if (this.meetingGemStatus == false) {
      $("#hideAgendaConfirmation").modal("toggle");
      $('#hideMessage').html('Do you want to show meeting in GEM?');
      this.meetingGemStatus = true;
      this.hideBtnMsg = 'Show'
    }

  }

  clickOnhideOk() {
    $("#hideAgendaConfirmation").modal("toggle");
    this.meetingService.hideMeetingFromGem(this.g_meetingID, this.meetingGemStatus).subscribe(result => {
      if (this.meetingGemStatus == true) {
        this.hideOrShowBtnMsg = 'Hide Meeting From GEM'
        this.alert.success('Meeting is visible in GEM');
      } else {
        this.hideOrShowBtnMsg = 'Show Meeting in GEM'
        this.alert.success('Meeting is hidden from GEM');
      }
    })
  }

  /* (29-30-2019) */

  transferPdfToGem() {
    $("#confirmTransferPdfGem").modal("toggle");
  }

  clickTransferPdf() {
    $("#confirmTransferPdfGem").modal("toggle");
    this.meetingService.transferPdfToGem(this.g_meetingID).subscribe(result => {
      // if (result.status == 0) {
      //   this.alert.success(result.message);
      // } else {
      //   this.alert.error(result.message);
      // }
    })
  }

  /* (09-04-2019) */
  cnfrmFreezeMeeting() {
    if (this.meetingFreezeStatus == true || this.meetingFreezeStatus == undefined || this.meetingFreezeStatus == null) {
      $("#freezeMeetingCnfrm").modal("toggle");
      $('#freezeMessage').html('Do you want to unfreeze meeting?');
      this.meetingFreezeStatus = false;
      this.freezeBtnMsg = 'Unfreeze Meeting'
    } else if (this.meetingFreezeStatus == false) {
      $("#freezeMeetingCnfrm").modal("toggle");
      $('#freezeMessage').html('Do you want to freeze meeting?');
      this.meetingFreezeStatus = true;
      this.freezeBtnMsg = 'Freeze Meeting'
    }
  }

  cancelMeetingFreeze() {
    if (this.meetingFreezeStatus == false) {
      this.meetingFreezeStatus = true
    } else if (this.meetingFreezeStatus == true) {
      this.meetingFreezeStatus = false;
    }
  }

  freezeMeeting() {
    $("#freezeMeetingCnfrm").modal("toggle");
    this.meetingService.freezeMeeting(this.g_meetingID, this.meetingFreezeStatus).subscribe(result => {
      if (this.meetingFreezeStatus == true) {
        this.freezeBtnMsg = 'Unfreeze Meeting'
        this.alert.success('Meeting is Freezed');
      } else {
        this.freezeBtnMsg = 'Freeze Meeting'
        this.alert.success('Meeting is unfreezed');
      }
    })
  }

  /* (10-04-2019) */

  getAgendaAccessRights() {
    this.meetingService.getAgendaByMeeting(this.g_meetingID)
      .subscribe(agenda => {
        if (agenda.status == 0) {
          this.agendaAccessArray = agenda.Agenda;
          this.agendaArray = [];
          $("#agendaTable").DataTable().destroy();
          $("#agendaNewTable").DataTable().destroy();
          //  this.agendaArray = agenda.Agenda;
          this.agendaArray = _.sortBy(agenda.Agenda, ["Agendaorder"]);
          // let filterData = this.newAgendaArray.filter((x:any)=>x.disabled == false);
          // this.tempArray=filterData
          this.newAgendaArray = this.agendaArray.map(enhanchArr);
          this.newAgendaArray.push(...this.tempArray)

          this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
            return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
          });
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
          this.dtTriggerAgenda.next();
          this.dtTriggerAgendaNew.next()

          this.agendaArray.forEach(agendaElement => {
            for (var index = 0; index < agendaElement.AgendaAccessRights.length; index++) {
              if (agendaElement.AgendaAccessRights[index].View == false) {
                agendaElement.selectAccessAgenda = false;
                index = agendaElement.AgendaAccessRights.length
              } else {
                agendaElement.selectAccessAgenda = true;
              }
            }
            // for (var outerIndex = 0; outerIndex < this.Invitees.length; outerIndex++) {
            //   for (var index = 0; index < agendaElement.AgendaAccessRights.length; index++) {
            //     if (this.Invitees[outerIndex]._id == agendaElement.AgendaAccessRights[index].LocalCollectionId) {
            //       if (agendaElement.AgendaAccessRights[index].View == false) {
            //         this.Invitees[outerIndex].selectInvForAll = false;
            //         index = agendaElement.AgendaAccessRights.length;
            //       } else {
            //         this.Invitees[outerIndex].selectInvForAll = true;
            //       }
            //     }
            //   }
            // }


          })

          for (var index = 0; index < this.agendaArray.length; index++) {
            if (this.agendaArray[index].selectAccessAgenda == false) {
              this.selectAllAccess = false;
              index = this.agendaArray.length;
            } else {
              this.selectAllAccess = true;
            }
          }

          for (var index = 0; index < this.Invitees.length; index++) {
            this.Invitees[index].selectInvForAll = true;
          }

          var updated = [];
          for (var index = 0; index < this.agendaArray.length; index++) {
            if (this.agendaArray[index].selectAccessAgenda == false) {
              for (var inner = 0; inner < this.agendaArray[index].AgendaAccessRights.length; inner++) {
                if (this.agendaArray[index].AgendaAccessRights[inner].View == false) {
                  var inv = this.Invitees.findIndex(x => x._id == this.agendaArray[index].AgendaAccessRights[inner].LocalCollectionId);
                  if (updated.indexOf(inv) == -1) {
                    updated.push(inv);
                    this.Invitees[inv].selectInvForAll = false;
                  }

                }
              }
            }
          }


          for (var outerIndex = 0; outerIndex < this.Invitees.length; outerIndex++) {
            if (this.Invitees[outerIndex].selectInvForAll == false) {
              this.selectAllAccess = false;
              outerIndex = this.Invitees.length;
            } else {
              this.selectAllAccess = true;
            }
          }

        }
      });

  }

  updateAgendaAccess() {
    this.meetingService.updateAgendaAccess(this.g_meetingID, this.agendaAccessArray).subscribe(result => {
      if (result.status == 0) {
        this.alert.success(result.Message);
      } else {
        this.alert.error(result.Message);
      }

    })
  }

  /* (11-04-2019) */
  selectIndividualUserAccess(event, outerIndex, innerIndex, id) {

    if (event.target.checked == false) {
      this.agendaAccessArray[outerIndex].selectAccessAgenda = false;
      this.agendaAccessArray.forEach(agendaElement => {
        for (var outerIndex = 0; outerIndex < this.Invitees.length; outerIndex++) {
          if (this.Invitees[outerIndex]._id == id) {
            this.Invitees[outerIndex].selectInvForAll = false;
          }
        }
      })
    } else {

      for (var index = 0; index < this.agendaAccessArray[outerIndex].AgendaAccessRights.length; index++) {
        if (this.agendaAccessArray[outerIndex].AgendaAccessRights[index].View == false) {
          this.agendaAccessArray[outerIndex].selectAccessAgenda = false;
          index = this.agendaAccessArray[outerIndex].AgendaAccessRights.length;
        } else {
          this.agendaAccessArray[outerIndex].selectAccessAgenda = true;
        }
      }

      for (var i = 0; i < this.agendaAccessArray.length; i++) {
        var updated = [];
        var inv = this.agendaAccessArray[i].AgendaAccessRights.findIndex(x => x.LocalCollectionId == id);
        if (this.agendaAccessArray[i].AgendaAccessRights[inv].View == false) {
          var invIndex = this.Invitees.findIndex(x => x._id == id);
          if (updated.indexOf(invIndex) == -1) {
            this.Invitees[invIndex].selectInvForAll = false;
            updated.push(invIndex);
            i = this.agendaAccessArray.length;
          }

        } else {
          var invIndex = this.Invitees.findIndex(x => x._id == id);
          this.Invitees[invIndex].selectInvForAll = true;
        }
      }
      // this.agendaAccessArray.forEach(agendaElement => {
      //   var isSet = true;
      //   for (var outerIndex = 0; outerIndex < this.Invitees.length; outerIndex++) {
      //     for (var innerIndex = 0; innerIndex < agendaElement.AgendaAccessRights.length; innerIndex++) {
      //       if (this.Invitees[outerIndex]._id == agendaElement.AgendaAccessRights[innerIndex].LocalCollectionId) {
      //         if (agendaElement.AgendaAccessRights[innerIndex].View == true && isSet == true) {
      //           isSet = true;
      //           this.Invitees[outerIndex].selectInvForAll = true;
      //         } else {
      //           isSet = false;
      //           this.Invitees[outerIndex].selectInvForAll = false;
      //         }
      //         innerIndex = agendaElement.AgendaAccessRights.length;
      //       }
      //     }
      //   }
      // })

    }


  }

  selectAllUsersForAllAgenda(event) {
    if (event.target.checked == true) {
      this.agendaAccessArray.forEach(agendaElement => {
        agendaElement.AgendaAccessRights.forEach(accessElement => {
          agendaElement.selectAccessAgenda = true;
          accessElement.View = true;
        })
      })
      for (var index = 0; index < this.Invitees.length; index++) {
        this.Invitees[index].selectInvForAll = true;
      }
    } else if (event.target.checked == false) {
      this.agendaAccessArray.forEach(agendaElement => {
        agendaElement.AgendaAccessRights.forEach(accessElement => {
          agendaElement.selectAccessAgenda = false;
          accessElement.View = false;
        })
      })
      for (var index = 0; index < this.Invitees.length; index++) {
        this.Invitees[index].selectInvForAll = false;
      }
    }
  }

  selectAllUsersPerAgenda(event, index) {

    if (event.target.checked == true) {
      this.agendaAccessArray[index].AgendaAccessRights.forEach(accessElement => {
        accessElement.View = true;
      })
    } else if (event.target.checked == false) {

      this.agendaAccessArray[index].AgendaAccessRights.forEach(accessElement => {
        accessElement.View = false;
        for (var outerIndex = 0; outerIndex < this.Invitees.length; outerIndex++) {
          this.Invitees[outerIndex].selectInvForAll = false;
        }
      })

    }
    var isSet = true;
    this.agendaAccessArray.forEach(agendaElement => {
      for (var outerIndex = 0; outerIndex < this.Invitees.length; outerIndex++) {
        for (var innerIndex = 0; innerIndex < agendaElement.AgendaAccessRights.length; innerIndex++) {
          if (this.Invitees[outerIndex]._id == agendaElement.AgendaAccessRights[innerIndex].LocalCollectionId) {
            if (agendaElement.AgendaAccessRights[innerIndex].View == true && isSet == true) {
              isSet = true;
              this.Invitees[outerIndex].selectInvForAll = true;
            } else {
              isSet = false;
              this.Invitees[outerIndex].selectInvForAll = false;
            }
            innerIndex = agendaElement.AgendaAccessRights.length;
          }
        }
      }
    })
    // this.getAgendaAccessRights();
  }

  selectIndividualUsersForAllAgenda(event, userId, index) {
    this.agendaAccessArray.forEach(agendaElement => {
      agendaElement.AgendaAccessRights.forEach(accessElement => {
        if (userId == accessElement.LocalCollectionId) {
          accessElement.View = event.target.checked;
        }
      })
    })

    // for(var outerIndex = 0; outerIndex < this.agendaAccessArray.length; outerIndex++) {
    //   for(var innerIndex = 0; innerIndex < this.agendaAccessArray[outerIndex].AgendaAccessRights.length;innerIndex++) {
    //     if(this.agendaAccessArray[outerIndex].AgendaAccessRights[innerIndex].View == false) {
    //       this.agendaAccessArray[outerIndex].selectAccessAgenda = false;
    //     } else {

    //     }
    //   }
    // }

    this.agendaAccessArray.forEach(agendaElement => {
      for (var innerIndex = 0; innerIndex < agendaElement.AgendaAccessRights.length; innerIndex++) {
        if (agendaElement.AgendaAccessRights[innerIndex].View == false) {
          agendaElement.selectAccessAgenda = false;
          innerIndex = agendaElement.AgendaAccessRights.length
        } else {
          agendaElement.selectAccessAgenda = true;
        }
      }
      // for (var outerIndex = 0; outerIndex < this.Invitees.length; outerIndex++) {
      //   for (var index = 0; index < agendaElement.AgendaAccessRights.length; index++) {
      //     if (this.Invitees[outerIndex]._id == agendaElement.AgendaAccessRights[index].LocalCollectionId) {
      //       if (agendaElement.AgendaAccessRights[index].View == false) {
      //         this.Invitees[outerIndex].selectInvForAll = false;
      //         index = agendaElement.AgendaAccessRights.length;
      //         outerIndex = this.Invitees.length;
      //       } else {
      //         this.Invitees[outerIndex].selectInvForAll = true;
      //       }
      //     }
      //   }
      // }

    })
  }

  /* (15-04-2019) */

  closeAccessRightsPopUp() {
    this.agendaAccessArray = [];
    this.meetingService.getAgendaByMeeting(this.g_meetingID)
      .subscribe(agenda => {
        if (agenda.status == 0) {
          this.agendaAccessArray = agenda.Agenda;
          this.agendaArray = [];
          $("#agendaTable").DataTable().destroy();
          $("#agendaNewTable").DataTable().destroy();
          this.agendaArray = agenda.Agenda;

          this.newAgendaArray = this.agendaArray.map(enhanchArr);
          this.newAgendaArray.push(...this.tempArray)

          this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
            return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
          });
          this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
          this.dtTriggerAgenda.next()
        }
      });

  }

  showSelectedAgendaDetail(index, agendaId) {

  }

  disableAddedAgenda() {
    for (var i = 0; i < this.agendaArray.length; i++) {

      for (var j = 0; j < this.splittedData.length; j++) {
        if (this.agendaArray[i]._id == this.splittedData[j].replaceBy) {
          this.agendaArray[i].isDisabled = true;
          j = this.splittedData.length;
        } else {
          this.agendaArray[i].isDisabled = false;
        }
      }
    }
  }

  generateMinutesDocument() {
    this.loading = true;
    this.meetingService.generateMinutesDocument(this.g_meetingID).subscribe(responseData => {
      if (responseData.status == 0) {
        this.getAgendaGenerationData();
        this.loading = false;
        this.alert.success("Minutes File is Generated Successfully.");
      } else {
        this.alert.error(responseData.Message);
        this.loading = false;
      }
    });
  }
  generateNoticeFile() {
    this.meetingService.generateNoticeFile(this.g_meetingID).subscribe(response => {
      if (response.status == 0) {
        window.location.href = environment.pssServerUrl + this.downloadAllLink + response.documentId;
        this.alert.success('File downloaded successfully');
      } else {
        this.alert.error(response.message);
      }
    })
  }

  clickUploadProof() {
    this.typeHasError = false;
  }
  agendaGroupSort() {
    var agendaTable = $('#agendaTable').DataTable();
    var agendaList = agendaTable.rows().data();

    this.meetingService.sortAgendaGroup(this.g_meetingID).subscribe(data => {
      if (data.status == 0) {
        this.agendaArray = [];
        var agendaTable = $('#agendaTable').DataTable({ destroy: true });
        agendaTable.destroy();
        $("#agendaNewTable").DataTable().destroy();
        this.agendaArray = _.sortBy(data.data, ["Agendaorder"]);

        this.newAgendaArray = this.agendaArray.map(enhanchArr);
        this.newAgendaArray.push(...this.tempArray)
        this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
          return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
        });
        this.isAgendaUpdateBtnEnable = !this.isAgendaUpdateBtnEnable;
        this.dtTriggerAgenda.next();
        this.dtTriggerAgendaNew.next()
        this.transferToGemArray = [];
        $("#transferToGemTable").DataTable().destroy();
        this.transferToGemArray = data.data;
        for (var index = 0; index < this.transferToGemArray.length; index++) {
          this.transferToGemArray[index].setSelected = this.transferToGemArray[index].isPublished;
        }
        this.transferToGemArray = _.sortBy(this.transferToGemArray, ["Agendaorder"]);
        this.dtTriggerOfTransferToGem.next();
        this.alert.success("agenda sort saved successfully.");
      }
    });
  }

  ordinalSuffix(num) {
    var s = ["th", "st", "nd", "rd"],
      v = num % 100;
    return num + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  changeCompanyNameData(event, value) {
    if (event.target.checked) {
      this.pushCompanyId.push(value);
    }
    if (!event.target.checked) {
      let index = this.pushCompanyId.indexOf(value);
      if (index > -1) {
        this.pushCompanyId.splice(index, 1);
      }
    }
    if (this.pushCompanyId.length > 0) {
      this.uploadAgendaDocFileBtn = false;
    } else {
      this.uploadAgendaDocFileBtn = true;
    }
  }
  // ======= 'fixed type of category' scenario =========
  // On Select to default category Agenda And Category add in meeting.
  defaultCategoryAndAgendaAdd(CategoryId, MeetingId) {
    this.meetingService.getCategoryMasterDataByCatId(CategoryId)
      .subscribe(response => {
        if (response.status == 0) {
          var CategoryData = [];
          var catMasterData = response.categoryMasterResult[0];
          var data = {
            'categoryID': catMasterData._id,
            'CategoryName': catMasterData.CategoryName,
            'IsGlobal': catMasterData.IsGlobal,
            'IsActive': catMasterData.IsActive
          }
          CategoryData.push(data);
          if (CategoryData.length > 0) {
            this.meetingService.getAgendasBeHalfOfCategory(CategoryData).subscribe(agendaData => {
              if (agendaData.status == 0) {
                var bothData = {
                  agendaOnCategory: agendaData.result,
                  CategoryData: CategoryData
                }
                this.meetingService.addCategoryAndAgendaInMeeting(bothData, MeetingId)
                  .subscribe(catNmeetingData => {
                    if (catNmeetingData.status == 0) {
                    }
                  });
              }
            });
          }
        }
      });
  }

  // Default Category Displayed in Add And Edit 'Meeting Details Tab'
  toGetDefaultCategory(meetingTypeID, MeetingAddEdit) {
    var meetingDataObjectCatId: any = [];
    if (MeetingAddEdit == 'MeetingEdit') {
      if (this.meetingDataObject[0].Category.length > 0) {
        this.meetingDataObject[0].Category.forEach(catData => {
          meetingDataObjectCatId.push(catData.categoryID);
        });
      }
    }

    if (meetingTypeID != "") {
      this.meetingService.getCategoryByMeetingType(meetingTypeID)
        .subscribe(category => {
          if (category.status == 0) {
            category.categoryList.forEach(element => {
              if (element.isDefault == true) {
                if (meetingDataObjectCatId.indexOf(element._id) === -1) {
                  this.defaultCategoryArray.push({
                    _id: element._id,
                    CategoryName: element.CategoryName
                  })
                }
              }
            });
          }
        });

      this.addmeetingForm.controls.Category.setValue(null);
    }
    else {
      return false;
    }
  }

  updateAgendaFiles() {
    this.loading = true;
    this.disabledOnclick = true;
    this.meetingService.updateAgendaFiles(this.g_meetingID).subscribe(response => {
      if (response.status == 0) {
        this.loading = false;
        this.disabledOnclick = false;
        this.agendaArray = [];
        $("#agendaTable").DataTable().destroy();
        $("#agendaNewTable").DataTable().destroy();
        var agendaData = response.Data[0].Agenda;
        this.agendaArray = _.sortBy(agendaData, ["Agendaorder"]);
        // let filterData = this.newAgendaArray.filter((x:any)=>x.disabled == false);
        // this.tempArray=filterData
        this.newAgendaArray = this.agendaArray.map(enhanchArr);
        this.newAgendaArray.push(...this.tempArray)
        this.isAgendaUpdateBtnEnable = this.agendaArray.some(function (value, index, _arr) {
          return (value.AgendaGenerationDocument.isUpdatedAsPerTemplate == false || value.AgendaMinuteDocument.isUpdatedAsPerTemplate == false);
        });
        this.alert.success("All agenda files updated successfully.");
      } else {
        this.loading = false;
        this.disabledOnclick = false;
        this.alert.error("Oops, Something went wrong.")
      }
    })
  }

  // Function For Automatic Meeting Number
  toGetMeetingNumber(meetingId, Meetingdate, MeetingTime) {

    // if (meetingId != "" || meetingId != null ) 
    if (meetingId != "" && meetingId != null && MeetingTime != undefined) {
      //this.meetingIdForMeetingNumber=meetingId;
      this.meetingService.getMeetingNumberByMeetingType(meetingId, Meetingdate, MeetingTime)
        .subscribe(result => {
          //this.isMeetingDataGreaterSelectDate=false;
          if (result.status == 0) {
            if (result.isDataForSelectedFinancialYear == false) {
              // No data for selected financial year, leave empty for user to enter
              this.addmeetingForm.controls.MeetingNumber.setValue(1);
            }
            else if (result.meetingDataLessSelectDate.length > 0) {
              this.financialYearEndDate = moment(result.meetingDataLessSelectDate[0].financialYearEndDate).utc().format('DD-MM-YYYY');
              if (result.meetingDataLessSelectDate[0].MeetingNumber === "") {
                // Check if [1] also has empty MeetingNumber
                if (result.meetingDataLessSelectDate[1] && result.meetingDataLessSelectDate[1].MeetingNumber === "") {
                  // Both [0] and [1] are empty, look for highest number in the array or leave empty
                  let maxNumber = 0;
                  for (let i = 0; i < result.meetingDataLessSelectDate.length; i++) {
                    if (result.meetingDataLessSelectDate[i].MeetingNumber && result.meetingDataLessSelectDate[i].MeetingNumber !== "") {
                      const num = parseInt(result.meetingDataLessSelectDate[i].MeetingNumber);
                      if (!isNaN(num) && num > maxNumber) {
                        maxNumber = num;
                      }
                    }
                  }
                  // Use the highest found number + 1, or leave empty if no valid numbers found
                  if (maxNumber > 0) {
                    this.addmeetingForm.controls.MeetingNumber.setValue((maxNumber + 1).toString());
                  } else {
                    this.addmeetingForm.controls.MeetingNumber.setValue("");
                  }
                } else if (result.meetingDataLessSelectDate[1] && result.meetingDataLessSelectDate[1].MeetingNumber) {
                  // [1] has a valid number, use it
                  this.addmeetingForm.controls.MeetingNumber.setValue((parseInt(result.meetingDataLessSelectDate[1].MeetingNumber) + 1).toString());
                } else {
                  // [1] doesn't exist or is invalid, leave empty for user input
                  this.addmeetingForm.controls.MeetingNumber.setValue("");
                }
              }
              else {
                this.addmeetingForm.controls.MeetingNumber.setValue((parseInt(result.meetingDataLessSelectDate[0].MeetingNumber) + 1).toString());
              }
            }
            else if (result.meetingDataGreaterSelectDate.length > 0) {

              this.isMeetingDataGreaterSelectDate = true;
              setTimeout(() => {
                $('#automaticMeetingNumberMessage').modal('show');
              }, 500);
              if (result.meetingDataGreaterSelectDate[0].MeetingNumber === "") {
                // Check if [1] exists and has a valid number
                if (result.meetingDataGreaterSelectDate[1] && result.meetingDataGreaterSelectDate[1].MeetingNumber && result.meetingDataGreaterSelectDate[1].MeetingNumber !== "") {
                  this.addmeetingForm.controls.MeetingNumber.setValue((parseInt(result.meetingDataGreaterSelectDate[1].MeetingNumber) + 1).toString());
                } else {
                  // Look for highest number in the array
                  let maxNumber = 0;
                  for (let i = 0; i < result.meetingDataGreaterSelectDate.length; i++) {
                    if (result.meetingDataGreaterSelectDate[i].MeetingNumber && result.meetingDataGreaterSelectDate[i].MeetingNumber !== "") {
                      const num = parseInt(result.meetingDataGreaterSelectDate[i].MeetingNumber);
                      if (!isNaN(num) && num > maxNumber) {
                        maxNumber = num;
                      }
                    }
                  }
                  // Use the highest found number + 1, or leave empty if no valid numbers found
                  if (maxNumber > 0) {
                    this.addmeetingForm.controls.MeetingNumber.setValue((maxNumber + 1).toString());
                  } else {
                    this.addmeetingForm.controls.MeetingNumber.setValue("");
                  }
                }
              }
              else {
                this.addmeetingForm.controls.MeetingNumber.setValue((parseInt(result.meetingDataGreaterSelectDate[0].MeetingNumber) + 1).toString());

              }

            }
            // else {


            //   this.addmeetingForm.controls.MeetingNumber.setValue(1);
            // }
          } else {

            this.addmeetingForm.controls.MeetingNumber.setValue("");
          }
        });
    }
  }

  getAgendaandProcess() {
    this.meetingService.getProcessandAgendabyMeetingId(this.g_meetingID)
      .subscribe(result => {
        if (result.status == 0) {
          this.agendaForFilter = result.Agenda;
          this.processForFilter = result.Process;
        }
      })
  }

  getProcessByMeetingAgendaId(agendaId) {
    this.meetingService.getAgendaSpecificProcess(this.g_meetingID, agendaId)
      .subscribe(result => {
        if (result.status == 0) {
          this.processForFilter = result.Process;
        }
      })
  }

  searchCompliance() {

    this.taskService.getUsersList().subscribe(data => {
      if (data.status == 0) {
        this.userList = data.result;

        this.activatedTaskList = [];
        $("#addedtaskTable").DataTable().destroy();

        this.meetingService.getFilteredCompliance(this.g_meetingID, this.filterAgendaId, this.filterProcessId).subscribe(data => {
          if (data.status == 0) {

            this.activatedTaskList = data.taskList;

            this.activatedTaskList.forEach(element => {

              for (var i = 0; i < this.userList.length; i++) {
                if (element.AssignedTo == this.userList[i]._id) {
                  element.AssignedName = this.userList[i].FirstName + ' ' + this.userList[i].LastName
                } else {
                  if (element.AssignedName == "" || element.AssignedName == undefined || element.AssignedName == null) {
                    element.AssignedName = ""
                  }

                }

              }
            });


            var self = this;
            setTimeout(() => {
              this.dtTriggerAddingCompliance.next();
              setTimeout(() => {
                $("#addedtaskTable").DataTable().columns.adjust().draw();
                self.isHeaderSetted = true
              }, 100);
              // this.adjustComplianceTable();
            }, 100)
          }
        })
      }

    });
  }

  clearComplianceFilter() {
    this.filterAgendaId = null;
    this.filterProcessId = null;
    this.getActivatedTaskList();
  }

  loadEmailReminderToEdit(emailReminderId) {
    this.emailReminderService.getEmailReminderByMasterId(emailReminderId)
      .subscribe((emailReminders: any) => {


        if (emailReminders.status == 0) {
          $('#reminderDialog').modal('toggle');

          this.draggableModelPopup();


          this.bodyKeyWords = emailReminders.emailReminderData[0].BodyKeyWords;
          this.subjectKeyWords = emailReminders.emailReminderData[0].SubjectKeyWords;
          this.arySubjectKeyWords = (this.subjectKeyWords).split(',');
          this.aryBodyKeyWords = (this.bodyKeyWords).split(',');
          this.mailReminderStaticID = emailReminders.emailReminderData[0].MailReminderStaticID;
          this.emailReminderId = emailReminders.emailReminderData[0]._id;
          this.isDefault = emailReminders.emailReminderData[0].IsDefault;
          this.reminderMasterForm.controls.Title.setValue(emailReminders.emailReminderData[0].Title);
          this.reminderMasterForm.controls.Title.disable();
          this.reminderMasterForm.controls.Title.updateValueAndValidity();
          this.IsSubjectKeyWordRequired = emailReminders.emailReminderData[0].IsSubjectKeyWordRequired;
          this.IsBodyKeyWordRequired = emailReminders.emailReminderData[0].IsBodyKeyWordRequired;
          this.reminderMasterForm.controls.EmailText.setValue(emailReminders.emailReminderData[0].EmailText);

          //this.reminderMasterForm.controls.Body.setValue(emailReminders.emailReminderData[0].Body);
          $('.summernote').summernote('code', emailReminders.emailReminderData[0].Body);
          this.reminderMasterForm.controls.Subject.setValue(emailReminders.emailReminderData[0].Subject);
          $("#reminderModalLabel").html('<i class="fa fa-pencil"></i> Update Email Templates');
          $('#btnsaveReminder').hide();
          $('#btnupdateReminder').show();
          this.error = { isError: false, errorMessage: '' }

        }
      });
  }

  draggableModelPopup() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  editReminder() {
    //var loginUsers = JSON.parse(localStorage.getItem("user"));
    var date = new Date();
    var timestamp = date.getTime();
    var updatedEmailRemnder = {
      MailReminderStaticID: this.mailReminderStaticID,
      BodyKeyWords: this.bodyKeyWords,
      SubjectKeyWords: this.subjectKeyWords,
      _id: this.emailReminderId,
      CompanyID: this.companyId,
      Body: $('.summernote').summernote('code'),
      Title: this.reminderMasterForm.controls.Title.value,
      Subject: this.reminderMasterForm.controls.Subject.value,
      IsDefault: this.isDefault,
      CcEmails: [],
      ToEmails: [],
      EmailText: this.reminderMasterForm.controls.EmailText.value,
      // FileNameUq: (this.filesToUpload) ? timestamp + "-" + this.filesToUpload.name.replace(',', '') : null
      //CreatedBy: loginUsers._id
    }

    // if (!this.filesToUpload) {
    //   delete updatedEmailRemnder.FileNameUq;
    // }

    // if (this.isFileDeleted) {
    //   updatedEmailRemnder.FileNameUq = null
    // }


    if (!this.isDefault) {
      this.emailReminderService.updateEmailReminder(updatedEmailRemnder)
        .subscribe(emailReminder => {
          this.disabledOnclick = false;
          if (emailReminder.status == 0) {
            $('#reminderDialog').modal('toggle');
            $('.summernote').summernote('code', "")

            this.alert.success(emailReminder.message);
            this.reminderMasterForm.reset();
          } else {
            $('#reminderDialog').modal('toggle');
            this.alert.error(emailReminder.message);
          }
          // this.getReminderList(this.type);
        });
    }
    else {
      this.emailReminderService.addEmailReminder(updatedEmailRemnder)
        .subscribe(emailReminder => {
          this.disabledOnclick = false;
          if (emailReminder.status == 0) {

            $('#reminderDialog').modal('toggle');
            $('.summernote').summernote('code', "")
            this.alert.success(emailReminder.message);
            this.reminderMasterForm.reset();
          } else {
            $('#reminderDialog').modal('toggle');
            this.alert.error(emailReminder.message);
          }
          // this.getReminderList(this.type);
        });
    }
  }

  fileChanged($event) {
    this.filesToUpload = $event.target.files[0];

  }

  clearAgendaQueue() {
    this.transferToGemSelectedAgenda = []
  }

  addNewAgendaPage() {
    let data = {
      AgendaNumber: "",
      AgendaTitle: "",
      AgendaGenerationDocument: {
        "isUpdatedAsPerTemplate": true,
        "DocName": "File Not Available",
        "IsPublished": true,
        "UploadDate": "2022-04-06T09:17:31.979Z",
        "DocumentManagementID": null,
        "IsAvailable": false
      },
      disabled: false,
      isSubmited: false
    };

    this.newAgendaArray.push(data)

    $("#agendaNewTable").DataTable().destroy()

  }

  saveAgenda(agenda) {

    if (agenda.AgendaNumber == '') {
      this.alert.error("Agenda Number Is Required");
      return;
    }
    if (agenda.AgendaTitle == '') {
      this.alert.error("Agenda Title Is Required");
      return;
    }
    let IscategorySelected = "No"
    let IsMeetingAssigned = "Yes"
    let libaryType = "Library"
    let agendaType = "Non-Open"
    if (IscategorySelected === "No") {
      libaryType = 'Non-Library';
    }
    if (IsMeetingAssigned === 'No') {
      agendaType = 'Open';
    }
    var newAgenda = {
      agendaNumber: agenda.AgendaNumber,
      agendaTitle: agenda.AgendaTitle,
      meetingType: this.g_meetingTypeID,
      processes: [],
      IscategorySelected: IscategorySelected,
      IsMeetingAssigned: IsMeetingAssigned,
      meetingID: this.g_meetingID,
      libaryType: libaryType,
      agendaType: agendaType,
      orinalFile: [],
      Upload: [],
      image: "",
      CreatedBy: '',
      CreatedDate: new Date(),
      ModifiedBy: '',
      ModifiedDate: '',
      AgendaFiles: [],
      agendaNumberPrefix: null,
      indexGrouping_id: null,
      documentType: 'None'
    }

    this.loading = true;
    this.agendaService.addAgenda(newAgenda).subscribe(agenda => {

      if (agenda.status == 0) {
        this.loading = false;
        $("#agendaTable").DataTable().destroy();
        $("#agendaNewTable").DataTable().destroy();
        this.agendaArray = _.sortBy([...this.agendaArray, agenda.agendaDetails], ["Agendaorder"]);
        let filterData = this.newAgendaArray.filter((x: any) => x.disabled == false);
        let index = filterData.findIndex((x: any) => x.AgendaNumber == newAgenda.agendaNumber)

        if (index != -1) {
          filterData.splice(index, 1)
        } else {

        }
        this.tempArray = filterData;
        this.newAgendaArray = this.agendaArray.map(enhanchArr);
        this.newAgendaArray.push(...this.tempArray)

        setTimeout(() => {
          this.dtTriggerAgenda.next()
          this.dtTriggerAgendaNew.next()
        }, 1000)
      }
      else {

        this.loading = false;
        this.alert.error(agenda.message);
      }
    });
  }

  get customeArray() {
    $("#agendaNewTable").DataTable().destroy();
    this.newAgendaArray = this.agendaArray.map(agenda => {
      return {
        ...agenda,
        disabled: true
      }
    })
    this.dtTriggerAgendaNew.next()
    return this.newAgendaArray
  }





  getCompaniesList(): void {
    this.companyMasterService.getCompanyList()
      .then((response) => {
        // 1. Store the entire response if needed
        this.companiesListData = [response.companyData];

        // 2. Extract and store just the address
        this.companyAddress = response.companyData?.RegisteredOfficeAddress || '';

        // 3. Log for verification
        console.log('Company Data:', this.companiesListData);
        console.log('Company Address:', this.companyAddress);

        // 4. Update your form control
        this.addmeetingForm.controls['MeetingPlace'].setValue(this.companyAddress);
      })
      .catch(err => {
        console.error('Error fetching company data:', err);
        this.companyAddress = 'Address not available';
      });
  }

  //---------------------- Notify Selected Functionality ----------------------

  // Open user selection modal
  openUserSelectionModal(type: string) {
    this.currentNotificationType = type;
    this.prepareUsersList();
    this.selectedUsersForNotification = [];
    this.selectAllUsers = false;
    this.showUserSelectionModal = true;
    
    setTimeout(() => {
      $('#userSelectionModal').modal('show');
    }, 100);
  }

  // Prepare the combined list of all meeting users
  prepareUsersList() {
    this.allMeetingUsers = [];
    
    // Add Directors
    if (this.Directors && this.Directors.length > 0) {
      this.Directors.forEach(director => {
        this.allMeetingUsers.push({
          id: director._id,
          name: director.MemberName || director.DirectorName || director.name,
          email: director.EmailId || director.email,
          type: 'Director',
          designation: director.Designation || 'Director',
          selected: false,
          originalObject: director // Keep reference to original object
        });
      });
    }

    // Add Members
    if (this.Members && this.Members.length > 0) {
      this.Members.forEach(member => {
        this.allMeetingUsers.push({
          id: member._id,
          name: member.MemberName || member.name,
          email: member.EmailId || member.email,
          type: 'Member',
          designation: member.Designation || 'Member',
          selected: false,
          originalObject: member // Keep reference to original object
        });
      });
    }

    // Add Invitees
    if (this.Invitees && this.Invitees.length > 0) {
      this.Invitees.forEach(invitee => {
        this.allMeetingUsers.push({
          id: invitee._id,
          name: invitee.InviteeName || invitee.name,
          email: invitee.EmailId || invitee.email,
          type: 'Invitee',
          designation: invitee.Designation || 'Invitee',
          selected: false,
          originalObject: invitee // Keep reference to original object
        });
      });
    }
  }

  // Toggle user selection
  toggleUserSelection(user: any) {
    user.selected = !user.selected;
    this.updateSelectedUsersList();
  }

  // Toggle select all users
  toggleSelectAllUsers() {
    this.selectAllUsers = !this.selectAllUsers;
    this.allMeetingUsers.forEach(user => {
      user.selected = this.selectAllUsers;
    });
    this.updateSelectedUsersList();
  }

  // Update the selected users list
  updateSelectedUsersList() {
    this.selectedUsersForNotification = this.allMeetingUsers.filter(user => user.selected);
  }

  // Close user selection modal
  closeUserSelectionModal() {
    this.showUserSelectionModal = false;
    $('#userSelectionModal').modal('hide');
  }

  isBoardMeetingSelected(): boolean {
    const n = this.MeetingTypeName;
    return (
      n === 'Board' ||
      n === 'Independent Directors' ||
      n === 'Annual General Meeting' ||
      n === 'Extraordinary General Meeting' ||
      n === 'Postal Ballot' ||
      n === 'Others'
    );
  }

  refresh(): void {
    if (this.g_meetingID) {
      this.loadMeetingDetails(this.g_meetingID);
    }
    this.bumpVotingResultsRefresh();
  }

  bumpVotingResultsRefresh(): void {
    this.votingResultsRefreshKey = (this.votingResultsRefreshKey || 0) + 1;
  }

  openMinuteVotingDetailsModal(minuteType: 'DRAFT' | 'FINAL'): void {
    this.minuteVotingModalMinuteType = minuteType;
    setTimeout(() => $('#minuteVotingDetailsModal').modal('show'));
  }

  closeMinuteVotingModal(): void {
    $('#minuteVotingDetailsModal').modal('hide');
    this.minuteVotingModalMinuteType = null;
  }

  onMinuteVotingModalHidden(): void {
    this.minuteVotingModalMinuteType = null;
  }

  // Send notification to selected users - CRITICAL: Use original objects for backend
  sendNotificationToSelectedUsers() {
    if (this.selectedUsersForNotification.length === 0) {
      this.alert.error('Please select at least one user to notify.');
      return;
    }

    this.notifyresponse = true;

    // Get original objects from selected users - THIS IS THE KEY FIX!
    const selectedDirectors = this.selectedUsersForNotification
      .filter(user => user.type === 'Director')
      .map(user => user.originalObject); // Use original complete object

    const selectedMembers = this.selectedUsersForNotification
      .filter(user => user.type === 'Member')
      .map(user => user.originalObject); // Use original complete object

    const selectedInvitees = this.selectedUsersForNotification
      .filter(user => user.type === 'Invitee')
      .map(user => user.originalObject); // Use original complete object

    let govevaUserIdArray = selectedMembers
      .filter(member => member.UserGovevaId)
      .map(member => member.UserGovevaId);

    let atrDocumentCopy = this.meetingDataObject[0].AtrDocument;
    if (_.size(atrDocumentCopy)) {
      atrDocumentCopy = atrDocumentCopy[0];
    } else {
      atrDocumentCopy = {
        noticeDate: '',
        noticeTime: '',
        agendaDate: '',
        agendaTime: '',
        draftDate: '',
        draftTime: '',
        finalDate: '',
        finalTime: '',
        agendaArray: [],
        allAgendas: []
      };
    }

    // Set document data based on type - EXACTLY same as regular notification
    switch (this.currentNotificationType) {
      case 'Notice':
        atrDocumentCopy.noticeDate = this.commonFunction.setDate({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
        atrDocumentCopy.noticeTime = _.toString(moment().format('LT'));
        atrDocumentCopy.isNoticeNotify = true;
        break;
      case 'Agenda':
        atrDocumentCopy.agendaDate = this.commonFunction.setDate({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
        atrDocumentCopy.agendaTime = _.toString(moment().format('LT'));
        atrDocumentCopy.isAgendaNotify = true;
        break;
      case 'Draft':
        atrDocumentCopy.draftDate = this.commonFunction.setDate({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
        atrDocumentCopy.draftTime = _.toString(moment().format('LT'));
        atrDocumentCopy.isDraftNotify = true;
        break;
      case 'Final':
        atrDocumentCopy.finalDate = this.commonFunction.setDate({ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() });
        atrDocumentCopy.finalTime = _.toString(moment().format('LT'));
        atrDocumentCopy.isFinalNotify = true;
        break;
      default:
        atrDocumentCopy.isATRNotify = true;
    }

    // Use IDENTICAL payload structure as regular notification - just with selected users
    let informationAndType = {
      Type: this.currentNotificationType,
      Invitees: selectedInvitees,         // Original complete objects
      GovevaIdOfMembers: govevaUserIdArray,
      Directors: selectedDirectors,       // Original complete objects
      CreatedBy: this.meetingDataObject[0].CreatedBy,
      URL: environment.MeetingMailURL + this.g_meetingID + '/' + JSON.parse(localStorage.getItem("companyDetails")).companyID + ')',
      Venue: this.addmeetingForm.controls.MeetingPlace.value,
      Time: this.addmeetingForm.controls.MeetingTime.value,
      Date: this.addmeetingForm.controls.MeetingDate.value,
      MeetingType: this.MeetingTypeName,
      MeetingId: this.meetingDataObject[0]._id,
      AtrDocument: atrDocumentCopy
    };

    // Use SAME service method as regular notification
    this.meetingService.sendNotifcationToUsers(informationAndType).subscribe(responseForNotification => {
      this.notifyresponse = false;
      
      if (!responseForNotification.status) {
        this.meetingDataObject[0].AtrDocument = responseForNotification.meetingRecord.AtrDocument;
        
        // Update form controls based on type - same as regular notification
        if (this.currentNotificationType == 'Notice') {
          let splitNoticeDate = new Date(responseForNotification.meetingRecord.AtrDocument[0].noticeDate);
          this.documentForm.controls.noticeDate.setValue({ year: splitNoticeDate.getFullYear(), month: splitNoticeDate.getMonth() + 1, day: splitNoticeDate.getDate() });
          this.documentForm.controls.noticeTime.setValue(responseForNotification.meetingRecord.AtrDocument[0].noticeTime);
          this.isNoticeNotify = true;
        }
        if (this.currentNotificationType == 'Agenda') {
          let agendaDate = new Date(responseForNotification.meetingRecord.AtrDocument[0].agendaDate);
          this.documentForm.controls.agendaDate.setValue({ year: agendaDate.getFullYear(), month: agendaDate.getMonth() + 1, day: agendaDate.getDate() });
          this.documentForm.controls.agendaTime.setValue(responseForNotification.meetingRecord.AtrDocument[0].agendaTime);
          this.isAgendaNotify = true;
        }
        if (this.currentNotificationType == 'Draft') {
          let draftDate = new Date(responseForNotification.meetingRecord.AtrDocument[0].draftDate);
          this.documentForm.controls.draftDate.setValue({ year: draftDate.getFullYear(), month: draftDate.getMonth() + 1, day: draftDate.getDate() });
          this.documentForm.controls.draftTime.setValue(responseForNotification.meetingRecord.AtrDocument[0].draftTime);
          this.isDraftNotify = true;
        }
        if (this.currentNotificationType == 'Final') {
          let finalDate = new Date(responseForNotification.meetingRecord.AtrDocument[0].finalDate);
          this.documentForm.controls.finalDate.setValue({ year: finalDate.getFullYear(), month: finalDate.getMonth() + 1, day: finalDate.getDate() });
          this.documentForm.controls.finalTime.setValue(responseForNotification.meetingRecord.AtrDocument[0].finalTime);
          this.isFinalNotify = true;
        }
        if (this.currentNotificationType == 'ATR') {
          this.isATRNotify = true;
        }
        
        this.alert.success(`${this.currentNotificationType} notification sent to ${this.selectedUsersForNotification.length} selected user(s).`);
        this.closeUserSelectionModal();
      }
      else {
        this.alert.error(responseForNotification.message);
      }
    });
  }

}